/** English dictionary (spec 5.1). */
export const en: Record<string, string> = {
  'app.title': 'CRM/ERP',
  'app.loading': 'Loading…',
  'app.error': 'Something went wrong',
  'app.retry': 'Retry',

  'auth.signIn': 'Sign in',
  'auth.signOut': 'Sign out',
  'auth.signingIn': 'Signing in…',
  'auth.required': 'Sign-in required',
  'auth.failed': 'Sign-in failed',
  'auth.signingOut': 'Signing out…',
  'auth.logoutFailed': 'The sign-in server did not confirm logout. Sign in and out again when the connection is restored.',
  'auth.retry': 'Sign in again',
  'auth.stateExpired': 'The sign-in state expired or belongs to another tab. Start again.',
  'auth.cancelled': 'Sign-in was cancelled or access was denied.',
  'auth.networkError': 'Cannot reach the sign-in server. Check your connection and retry.',
  'auth.exchangeFailed': 'Cannot complete sign-in. Start again; contact your administrator if it persists.',

  'nav.section.sales': 'Sales',
  'nav.section.billing': 'Finance',
  'nav.section.warehouse': 'Warehouse',
  'nav.section.hr': 'People',

  'nav.leads': 'Leads',
  'nav.deals': 'Deals',
  'nav.counterparties': 'Counterparties',
  'nav.quotes': 'Quotes',
  'nav.products': 'Products',
  'nav.invoices': 'Invoices',
  'nav.documents': 'Primary documents',
  'nav.contracts': 'Contracts',
  'nav.stock': 'Stock',
  'nav.receipts': 'Receiving',
  'nav.shipments': 'Shipments',
  'nav.picking': 'Picking',
  'nav.stocktakes': 'Stocktakes',
  'nav.transfers': 'Transfers',
  'nav.employees': 'Employees',
  'nav.departments': 'Org structure',
  'nav.vacancies': 'Vacancies',
  'nav.leaves': 'Leave',
  'nav.kpi': 'KPI',

  'palette.placeholder': 'Section, command or search the CRM…',
  'palette.empty': 'Nothing found',
  'nav.sections': 'Sections',
  'nav.collapse': 'Collapse menu',
  'nav.expand': 'Expand menu',
  'topbar.searchLabel': 'Search and commands, Ctrl+K',
  'topbar.notifications': 'Notifications: {count} new',
  'topbar.theme': 'Theme',
  'topbar.locale': 'Interface language',
  'topbar.profile': 'Profile',
  'palette.hint': 'Ctrl+K for the command palette',
  'palette.sections': 'Sections',
  'palette.actions': 'Actions',
  'palette.records': 'Found in the CRM',
  'palette.searching': 'Searching…',
  'palette.searchFailed': 'Search failed — sections are still available',
  'topbar.search': 'Find a section, command or record',
  'search.type.sales.counterparty': 'Client',
  'search.type.sales.contact': 'Contact',
  'search.type.sales.deal': 'Deal',
  'search.type.billing.invoice': 'Invoice',
  'search.type.sales.lead': 'Lead',
  'search.type.support.ticket': 'Ticket',
  'search.type.comment': 'Comment',
  'search.type.email': 'Email',
  'search.state.overdue': 'Overdue',
  'search.state.paid': 'Paid',
  'search.state.cancelled': 'Cancelled',
  'search.state.won': 'Won',
  'search.state.lost': 'Lost',

  'search.placeholder': 'Search everything',
  'search.empty': 'Nothing found',
  'search.minLength': 'Type at least {count} characters',

  'theme.light': 'Light theme',
  'theme.dark': 'Dark theme',
  'theme.system': 'Match system',
  'locale.ru': 'Русский',
  'locale.en': 'English',

  'access.denied': 'No access to this section',
  'access.deniedHint': 'Ask an administrator if you need it for your work',
  'page.notFound': 'Page not found',
  'page.placeholder': 'This section arrives in a later ticket',

  'list.columns': 'Columns',
  'list.resetColumns': 'Reset to defaults',
  'list.groupBy': 'Group by',
  'list.tools': 'More: views, grouping, segments, import and export',
  'pager.label': 'List pages',
  'pager.prev': 'Previous',
  'pager.next': 'Next',
  'pager.range': 'Rows {from}–{to}',
  'pager.of': 'of {total}',
  'pager.empty': 'No rows',
  'pager.size': 'Rows per page:',
  'list.noGrouping': 'No grouping',
  'list.empty': 'Nothing found',
  'list.loaded': 'Rows loaded: {count}',
  'list.more': 'Load more',
  'list.selectRow': 'Select row',
  'list.selectPage': 'Select all rows on this page',

  'filter.column': 'Column',
  'filter.operator': 'Condition',
  'filter.value': 'Value',
  'filter.valueList': 'Comma-separated values',
  'filter.add': 'Add filter',
  'filter.remove': 'Remove filter',
  'filter.op.eq': 'equals',
  'filter.op.ne': 'not equal',
  'filter.op.gt': 'greater than',
  'filter.op.gte': 'greater or equal',
  'filter.op.lt': 'less than',
  'filter.op.lte': 'less or equal',
  'filter.op.contains': 'contains',
  'filter.op.starts_with': 'starts with',
  'filter.op.between': 'between',
  'filter.op.in': 'one of',
  'filter.op.is_null': 'is empty',
  'filter.op.is_not_null': 'is filled',

  'view.picker': 'View',
  'view.none': 'No view',
  'view.name': 'View name',
  'view.save': 'Save as',
  'view.update': 'Update',
  'view.delete': 'Delete',
  'view.makeDefault': 'Open by default',
  'view.shareIt': 'Shared',
  'view.shared': 'shared',
  'view.broken': 'The view cannot be read: save it again',

  'export.csv': 'Export CSV',
  'export.running': 'Preparing the file…',

  'import.title': 'Import from CSV',
  'import.file': 'Import file',
  'import.template': 'Download template',
  'import.columns': 'File columns: {columns}',
  'import.required': 'Required: {columns}',
  'import.running': 'Uploading…',
  'import.result': 'Imported {imported} of {total}, rejected {failed}',
  'import.line': 'Line',
  'import.column': 'Column',
  'import.reason': 'Reason',
  'import.found': 'The file has {rows} rows and {columns} columns. Map the file columns onto the fields',
  'import.mapping': 'Column mapping',
  'import.field': 'Field',
  'import.fileColumn': 'File column',
  'import.example': 'Example from the first row',
  'import.skip': '— do not import —',
  'import.unmapped': 'Required fields are not mapped: {fields}',
  'import.run': 'Import {rows} rows',
  'bulk.newResponsible': 'New responsible',
  'bulk.reassign': 'Assign',
  'bulk.newStage': 'New stage',
  'bulk.move': 'Move',
  'bulk.domainResult': 'Changed {affected} of {requested}.',
  'bulk.skipped': 'Skipped: {reasons}',
  'bulk.byFilter': 'Actions on everything in the filter ({count})',

  'bulk.selected': 'Rows selected: {count}',
  'bulk.clear': 'Clear selection',
  'bulk.delete': 'Delete',
  'bulk.deleted': 'Deleted {affected} of {requested} selected',

  'column.id': 'ID',
  'column.name': 'Name',
  'column.kind': 'Kind',
  'column.inn': 'Tax ID',
  'column.kpp': 'Tax reg. code',
  'column.email': 'Email',
  'column.phone': 'Phone',
  'column.relation': 'Relation',
  'column.industry': 'Industry',
  'column.credit_limit': 'Credit limit',
  'column.is_blocked': 'Blocked',
  'column.responsible_employee_id': 'Owner',
  'column.created_at': 'Created',
  'column.number': 'Number',
  'column.title': 'Title',
  'column.tags': 'Tags',
  'column.amount': 'Amount',
  'column.currency': 'Currency',
  'column.status': 'Status',
  'column.probability': 'Probability',
  'column.stage_id': 'Stage',
  'column.funnel_id': 'Funnel',
  'column.counterparty_id': 'Counterparty',
  'column.expected_close_on': 'Expected close',
  'column.closed_at': 'Closed',
  'column.department_id': 'Department',
  'column.sku': 'SKU',
  'column.product_type': 'Product type',
  'column.vat_rate': 'VAT rate',
  'column.barcode': 'Barcode',
  'column.category_id': 'Category',
  'column.weight_kg': 'Weight, kg',
  'column.min_stock': 'Min. stock',
  'column.is_active': 'Active',

  'list.open': 'Open',

  'card.tab.main': 'General',
  'card.tab.related': 'Related',
  'card.tab.history': 'History',
  'card.tab.attachments': 'Attachments',

  'card.section.general': 'General',
  'card.section.requisites': 'Tax details',
  'card.section.contacts': 'Contacts',
  'card.section.finance': 'Financial terms',
  'card.section.money': 'Money',
  'card.section.pipeline': 'Pipeline',
  'card.section.logistics': 'Logistics',
  'card.section.service': 'System',

  'card.edit': 'Edit',
  'card.save': 'Save',
  'card.saving': 'Saving…',
  'card.cancel': 'Cancel',
  'card.back': 'Back',
  'card.saved': 'Saved',
  'card.savedPartially':
    'Fields written: {applied}. Saving stopped at "{field}": {reason}',
  'card.noRecord': 'Record is not loaded',
  'card.gone': 'The record is gone: deleted or no longer in your scope',
  'card.notAffected': 'The row did not change: deleted or outside your scope',
  'card.noVersion':
    'No protection against concurrent edits: the server does not return a record version. '
    + 'A divergence is still detected by comparing fields before the write, but the window '
    + 'between the check and the write remains.',

  'card.error.number': 'A number is expected',
  'card.error.date': 'A date is expected',
  'card.error.uuid': 'An identifier is expected',
  'card.error.boolean': 'Yes or no is expected',

  'card.conflict.title': 'The record was changed concurrently',
  'card.conflict.explain':
    'While this card was open, someone else changed these fields. '
    + 'Decide for each one whose value is right: a divergence has no automatic winner.',
  'card.conflict.detected': 'The server rejected the write because of a concurrent edit',
  'card.conflict.field': 'Field',
  'card.conflict.theirs': 'On the server',
  'card.conflict.mine': 'Your value',
  'card.conflict.decision': 'Decision',
  'card.conflict.takeTheirs': 'Take theirs',
  'card.conflict.keepMine': 'Keep mine',
  'card.conflict.discard': 'Discard edits and reload',
  'card.conflict.otherFields': 'The fields that changed are not shown on this screen',

  'card.related.missing': 'Related entities are not shown yet',
  'card.related.reason':
    'REST over the business logic lands in tickets #67 and #68; there is nothing to read yet.',
  'card.attachments.missing': 'Attachments are not shown yet',
  'card.attachments.reason': 'The system has no file storage.',
  'card.attachments.upload': 'Attach file',
  'card.attachments.empty': 'No attachments',
  'card.attachments.name': 'File',
  'card.attachments.size': 'Size',
  'card.attachments.status': 'Scan',
  'card.attachments.action': 'Action',
  'card.attachments.download': 'Download',
  'card.attachments.unavailable': 'Unavailable',
  'card.attachments.status.pending': 'Waiting for antivirus',
  'card.attachments.status.clean': 'Clean',
  'card.attachments.status.infected': 'Infected',
  'card.attachments.status.failed': 'Scan failed',
  'card.contract.attachments.show': 'Contract scan',
  'card.contract.attachments.hide': 'Hide contract scan',

  // --- counterparty card, ticket #70 ---
  'common.yes': 'yes',

  'card.tab.contacts': 'Contacts',
  'card.tab.interactions': 'Interactions',
  'card.tab.finance': 'Finance',

  'card.cp.contacts.empty': 'No contact persons recorded',
  'card.cp.contact.name': 'Name',
  'card.cp.contact.role': 'Job title',
  'card.cp.contact.primary': 'primary',
  'card.cp.contact.consent': 'Data consent',
  'card.cp.contact.noConsent': 'none',
  'card.cp.contact.noConsentFlag': 'No personal data consent',

  'card.cp.accounts.title': 'Bank details',
  'card.cp.accounts.empty': 'No bank accounts recorded',
  'card.cp.account.bank': 'Bank',
  'card.cp.account.bik': 'BIC',
  'card.cp.account.number': 'Account',
  'card.cp.account.primary': 'primary',

  'card.cp.timeline.count': 'Touches with this customer: {count}',
  'card.cp.timeline.empty': 'No interactions recorded',
  'card.cp.timeline.overdue': 'overdue',

  'activity.type.call': 'Call',
  'activity.type.email': 'Email',
  'activity.type.meeting': 'Meeting',
  'activity.type.task': 'Task',
  'activity.type.note': 'Note',

  'card.cp.finance.empty': 'No financial data',
  'card.cp.finance.needsBilling':
    'Requires the invoice read permission (billing.invoice): customer debt is billing data.',

  'card.cp.credit.unlimited': 'unlimited',
  'card.cp.credit.debt': 'Current debt',
  'card.cp.credit.available': 'Available',
  'card.cp.credit.terms': 'Payment terms',
  'card.cp.credit.termsDays': '{days} days',
  'card.cp.credit.exceeded': 'Credit limit exceeded: debt {debt} against a limit of {limit}',
  'card.cp.blocked': 'Counterparty is blocked: {reason}',

  'card.cp.ageing.title': 'Receivables by age',
  'card.cp.ageing.none': 'Nothing owed',
  'card.cp.ageing.current': 'Not yet due',
  'card.cp.ageing.d30': 'up to 30 days',
  'card.cp.ageing.d60': '31–60 days',
  'card.cp.ageing.d90': '61–90 days',
  'card.cp.ageing.d90plus': 'over 90 days',
  'card.cp.ageing.total': 'Total in currency',

  'card.cp.contracts.title': 'Contracts',
  'card.cp.contracts.empty': 'No contracts recorded',
  'card.cp.contract.number': 'Number',
  'card.cp.contract.type': 'Type',
  'card.cp.contract.valid': 'Valid',
  'card.cp.contract.lapsed': 'lapsed',

  'contract.type.sale': 'Sale',
  'contract.type.purchase': 'Purchase',
  'contract.type.service': 'Service',
  'contract.type.agency': 'Agency',
  'contract.type.storage': 'Storage',
  'contract.status.draft': 'Draft',
  'contract.status.active': 'Active',
  'contract.status.expired': 'Expired',
  'contract.status.terminated': 'Terminated',

  'card.cp.dup.searching': 'Looking for similar cards…',
  'card.cp.dup.none': 'No similar cards found',
  'card.cp.dup.found': 'Similar cards: {count}. Check you are not creating a duplicate.',
  'card.cp.dup.blocking':
    'A counterparty with this INN and KPP pair already exists — saving will fail.',
  'card.cp.dup.failed': 'The duplicate search failed. That does not mean there are none.',
  'card.cp.dup.blocked': 'blocked',
  'card.cp.dup.by.inn': 'same INN',
  'card.cp.dup.by.inn_kpp': 'same INN and KPP pair',
  'card.cp.dup.by.phone': 'same phone',
  'card.cp.dup.by.contact_phone': 'contact person phone',
  'card.cp.dup.by.email': 'same email',
  'card.cp.dup.by.contact_email': 'contact person email',

  'list.create': 'Create',

  'card.cp.create.title': 'New counterparty',
  'card.cp.create.submit': 'Create',
  'card.cp.create.legalName': 'Full legal name',
  'card.cp.create.legalAddress': 'Legal address',
  'card.cp.create.actualAddress': 'Actual address',
  'card.cp.create.blocked': 'Open the existing card first, or change the KPP',

  'counterparty.kind.legal': 'Legal entity',
  'counterparty.kind.sole_trader': 'Sole trader',
  'counterparty.kind.individual': 'Individual',

  // ---------------------------------------------------------- deal board (#71)

  'deals.mode': 'View mode',
  'deals.mode.table': 'Table',
  'deals.mode.board': 'Board',
  'deals.board.filters': 'Filters applied: {count}',

  'board.funnel': 'Funnel',
  'board.noFunnels': 'No active funnels — there is nothing to build a board from',
  'board.weightedPipeline': 'Weighted pipeline: {amount}',
  'board.columnTotals': 'deals: {count}, total: {amount}',
  'board.columnWeighted': 'weighted: {amount} ({probability}%)',
  'board.expectedClose': 'close by {date}',
  'board.stuck': 'stuck: {days} days against a limit of {limit}',
  'board.moveTo': 'Move deal {deal}',

  'card.tab.dealLines': 'Lines',
  'card.tab.stageHistory': 'Stage history',

  'card.deal.lines.empty': 'The deal has no lines',
  'card.deal.lines.total': 'Lines total',
  'card.deal.line.product': 'Product',
  'card.deal.line.quantity': 'Qty',
  'card.deal.line.price': 'Price',
  'card.deal.line.discount': 'Discount',
  'card.deal.line.vat': 'VAT',
  'card.deal.line.total': 'Line total',
  'card.deal.line.cost': 'Cost',
  'card.deal.cost.unknown': 'not recorded',
  'card.deal.margin.title': 'Margin',
  'card.deal.margin.cost': 'Deal cost',
  'card.deal.margin.amount': 'Margin',
  'card.deal.margin.unknown': 'unknown: some lines have no cost',
  'card.deal.weighted': 'Weighted amount',

  'card.deal.history.empty': 'No stage transitions yet',
  'card.deal.history.when': 'When',
  'card.deal.history.from': 'From',
  'card.deal.history.to': 'To',
  'card.deal.history.spent': 'Time in stage',
  'card.deal.history.who': 'Who',
  'card.deal.history.created': 'deal created',
  'card.deal.history.backwards': 'moved back',
  'card.deal.history.days': '{days} d',
  'card.deal.history.hours': '{hours} h',
  'card.deal.history.minutes': '{minutes} min',
  'card.deal.history.summary': 'Transitions: {total}, of them moves back: {backwards}',
  // ---------------------------------------------------------------- invoices (#72)

  'column.issued_on': 'Issued',
  'column.due_on': 'Due',

  'card.section.dates': 'Dates',

  'card.tab.invoiceLines': 'Lines',
  'card.tab.invoiceSettlements': 'Payments',
  'card.tab.invoiceDunning': 'Reminders',
  'card.tab.invoiceActions': 'Actions',
  'card.tab.receivables': 'Receivables',

  'card.inv.missing': 'Invoice not loaded',
  'card.inv.paid': 'Paid',
  'card.inv.outstanding': 'Outstanding',

  'card.inv.lines.empty': 'The invoice has no lines',
  'card.inv.lines.mismatch':
    'The invoice total does not equal the sum of its lines. The customer adds up the lines.',
  'card.inv.lines.lineMismatch':
    'Lines whose total does not add up: {count}. VAT is charged on the discounted amount and rounded per line.',
  'card.inv.line.description': 'Description',
  'card.inv.line.quantity': 'Qty',
  'card.inv.line.unitPrice': 'Price',
  'card.inv.line.discount': 'Discount',
  'card.inv.line.net': 'Net of discount',
  'card.inv.line.vatRate': 'VAT rate',
  'card.inv.line.vatAmount': 'VAT',
  'card.inv.line.total': 'Line total',

  'card.inv.total.subtotal': 'Subtotal',
  'card.inv.total.discount': 'Discount',
  'card.inv.total.vat': 'VAT',
  'card.inv.total.total': 'Total',

  'card.inv.settlements.empty': 'Nothing has been allocated to this invoice',
  'card.inv.settlements.needsBilling': 'Requires the invoices permission',
  'card.inv.settlements.needsPayments':
    'Requires the payments permission to see what settled this invoice',
  'card.inv.settlements.mismatch':
    'Allocated {allocated}, but the invoice records {paid}. The figures disagree — this is data corruption.',
  'card.inv.settlement.payment': 'Payment',
  'card.inv.settlement.date': 'Date',
  'card.inv.settlement.method': 'Method',
  'card.inv.settlement.amount': 'Allocated',
  'card.inv.settlement.rule': 'How',
  'card.inv.settlement.actions': 'Actions',
  'card.inv.settlement.remove': 'Unallocate',
  'card.inv.settlement.orphan': 'payment not found',

  'card.inv.allocate.title': 'Allocate a payment',
  'card.inv.allocate.payment': 'Payment',
  'card.inv.allocate.choose': '— choose a payment —',
  'card.inv.allocate.amount': 'Amount',
  'card.inv.allocate.submit': 'Allocate',
  'card.inv.allocate.saving': 'Allocating…',
  'card.inv.allocate.noPayment': 'No payment selected',
  'card.inv.allocate.badAmount': 'The amount must be greater than zero',
  'card.inv.allocate.noAdvances': 'The counterparty has no unallocated payments',
  'card.inv.allocate.notPayable':
    'Nothing can be allocated to this invoice: it is cancelled or already settled',

  'card.inv.dunning.empty': 'No reminders have been sent for this invoice',
  'card.inv.dunning.step': 'Step',
  'card.inv.dunning.kind': 'Action',
  'card.inv.dunning.scheduled': 'Scheduled',
  'card.inv.dunning.executed': 'Executed',
  'card.inv.dunning.result': 'Result',
  'card.inv.dunning.pending': 'not yet',
  'card.inv.dunning.days': '{days} days overdue',

  'card.inv.action.send': 'Send invoice',
  'card.inv.action.sent': 'Invoice sent',
  'card.inv.action.sendUnavailable': 'Only a draft can be sent',
  'card.inv.action.cancel': 'Cancel invoice',
  'card.inv.action.cancelled': 'Invoice cancelled',
  'card.inv.action.cancelUnavailable': 'A paid or already cancelled invoice cannot be cancelled',
  'card.inv.action.reason': 'Cancellation reason',
  'card.inv.action.reasonRequired':
    'A reason is required: it stays in the register forever',
  'card.inv.action.reissue': 'Reissue',
  'card.inv.action.reissueMissing':
    'The domain does not publish it. A replacement invoice gets a new number, and the old number is already with the customer — cancel the invoice and issue a new one explicitly.',

  'card.inv.ageing.title': 'Receivables by age',
  'card.inv.ageing.explain':
    'Not yet due is not overdue: an invoice issued yesterday with a month to pay is not a debt problem.',
  'card.inv.ageing.none': 'Nothing is owed',
  'card.inv.ageing.notYetDue': 'Not yet due',
  'card.inv.ageing.d30': 'Up to 30 days',
  'card.inv.ageing.d60': '31–60 days',
  'card.inv.ageing.d90': '61–90 days',
  'card.inv.ageing.d90plus': 'Over 90 days',
  'card.inv.ageing.overdue': 'Overdue',
  'card.inv.ageing.total': 'Total',

  'card.inv.outstanding.title': 'Open invoices',
  'card.inv.outstanding.none': 'No open invoices',
  'card.inv.outstanding.sum': 'Total receivable: {amount}',

  'card.inv.subs.title': 'Subscriptions',
  'card.inv.subs.none': 'No subscriptions',
  'card.inv.sub.name': 'Name',
  'card.inv.sub.frequency': 'Frequency',
  'card.inv.sub.dayOfMonth': 'Billing day',
  'card.inv.sub.nextRun': 'Next run',
  'card.inv.sub.paused': 'paused',
  'card.inv.sub.active': 'Active',
  'card.inv.sub.inactive': 'Paused',

  'invoice.status.draft': 'Draft',
  'invoice.status.sent': 'Sent',
  'invoice.status.partially_paid': 'Partially paid',
  'invoice.status.paid': 'Paid',
  'invoice.status.overdue': 'Overdue',
  'invoice.status.cancelled': 'Cancelled',

  'dunning.kind.email': 'Email',
  'dunning.kind.call_task': 'Call task',
  'dunning.kind.manager_notice': 'Manager notice',
  'dunning.kind.legal': 'Handed to legal',

  'payment.method.bank_transfer': 'Bank transfer',
  'payment.method.acquiring': 'Acquiring',
  'payment.method.sbp': 'SBP',
  'payment.method.cash': 'Cash',
  'payment.method.offset': 'Set-off',
  'payment.method.deposit': 'From deposit',

  'allocation.rule.auto': 'Auto-matched',
  'allocation.rule.manual': 'Manual',

  'recurring.frequency.monthly': 'Monthly',
  'recurring.frequency.quarterly': 'Quarterly',
  'recurring.frequency.yearly': 'Yearly',
  'recurring.frequency.weekly': 'Weekly',

  // ------------------------------------------------------------------ #73: documents and contracts

  'card.tab.docLines': 'Lines',
  'card.tab.docSignature': 'Signature and status',
  'card.tab.contracts': 'Contracts',
  'card.section.signature': 'Signature and EDI',

  'card.doc.empty': 'Document not loaded',
  'card.doc.number': 'Number',
  'card.doc.date': 'Date',
  'card.doc.status': 'Status',
  'card.doc.signedAt': 'Signed',
  'card.doc.subtotal': 'Total',
  'card.doc.edi': 'EDI',
  'card.doc.edi.none': 'Not dispatched',
  'card.doc.edi.messageId': 'Operator message id',
  'card.doc.reissuedFrom': 'Reissue reason',
  'card.doc.reissues': 'Replaced by',
  'card.doc.reissues.empty': 'The document has not been reissued',
  'card.doc.reissue.reason': 'Reissue reason',

  'card.doc.lines.empty': 'The document has no lines',
  'card.doc.lines.mismatch': 'The document total does not match the sum of its lines',
  'card.doc.lines.lineMismatch': 'Lines whose arithmetic disagrees: {count}',
  'card.doc.line.description': 'Description',
  'card.doc.line.quantity': 'Quantity',
  'card.doc.line.price': 'Price',
  'card.doc.line.vatRate': 'VAT rate',
  'card.doc.line.vat': 'VAT',
  'card.doc.line.total': 'Total with VAT',

  'card.doc.sign.unsigned': 'The document is not signed',
  'card.doc.sign.unknown': 'Signature state unknown',
  'card.doc.sign.intact': 'The signature matches the document content',
  'card.doc.sign.mismatch': 'The content changed after signing',
  'card.doc.sign.mismatchExplained':
    'The hash of the lines differs from the one the signature fixed: the document on screen is not the one that was signed.',
  'card.doc.sign.signedHash': 'Hash at signing',
  'card.doc.sign.currentHash': 'Hash now',

  'card.doc.status.draft': 'Draft',
  'card.doc.status.issued': 'Issued',
  'card.doc.status.signed': 'Signed',
  'card.doc.status.cancelled': 'Cancelled',

  'card.doc.action.issue': 'Issue',
  'card.doc.action.sign': 'Sign',
  'card.doc.action.edi': 'Record EDI dispatch',
  'card.doc.action.cancel': 'Cancel',
  'card.doc.action.reissue': 'Reissue',

  'card.contract.empty': 'No contracts with this counterparty',
  'card.contract.number': 'Number',
  'card.contract.type': 'Type',
  'card.contract.status': 'Status',
  'card.contract.signedOn': 'Signed on',
  'card.contract.validUntil': 'Valid until',
  'card.contract.openEnded': 'Open-ended',
  'card.contract.amount': 'Amount',
  'card.contract.paymentTerms': 'Payment terms, days',
  'card.contract.usableToday': 'Order today',
  'card.contract.usable': 'Allowed',
  'card.contract.notUsable': 'Not allowed',
  'card.contract.prolongTo': 'Prolong until',
  'card.contract.terminateReason': 'Termination reason',
  'card.contract.gaps':
    'The termination reason is kept only in the application log — the schema has no column for it. The scanned contract is unavailable: the project has no file storage.',

  'card.contract.type.sale': 'Sale',
  'card.contract.type.purchase': 'Purchase',
  'card.contract.type.service': 'Service',
  'card.contract.type.storage': 'Storage',
  'card.contract.type.agency': 'Agency',

  'card.contract.status.draft': 'Draft',
  'card.contract.status.active': 'Active',
  'card.contract.status.expired': 'Expired',
  'card.contract.status.terminated': 'Terminated',

  'card.contract.action.activate': 'Activate',
  'card.contract.action.prolong': 'Prolong',
  'card.contract.action.terminate': 'Terminate',
  // --- warehouse document cards (#74) ---
  'card.tab.whReceiptLines': 'Lines',
  'card.tab.whDiscrepancies': 'Discrepancies',
  'card.tab.whShipmentLines': 'Contents',
  'card.tab.whPacking': 'Packing list',
  'card.tab.whRoute': 'Route',
  'card.tab.whCountSheet': 'Count sheet',
  'card.tab.whVariances': 'Variance act',
  'card.tab.whApproval': 'Approval',
  'card.tab.whReservations': 'Reservations',
  'card.tab.whTransferLines': 'Lines',
  'card.tab.whActions': 'Actions',

  'card.section.quantity': 'Quantity',

  'card.wh.status': 'Status',
  'card.wh.noUpdateRight': 'No right to change this document',
  'card.wh.line.product': 'Product',
  'card.wh.line.batch': 'Batch',
  'card.wh.line.cell': 'Cell',
  'card.wh.line.quantity': 'Quantity',

  'card.wh.receipt.expected': 'Expected',
  'card.wh.receipt.accepted': 'Accepted',
  'card.wh.receipt.rejected': 'Rejected',
  'card.wh.receipt.reason': 'Reason',
  'card.wh.receipt.discrepancy': 'Discrepancy',
  'card.wh.receipt.noLines': 'No lines: an unplanned receipt is filled in by the storekeeper',
  'card.wh.receipt.noDiscrepancies': 'No discrepancies: accepted matches expected',
  'card.wh.receipt.hasDiscrepancies': 'Has discrepancies',
  'card.wh.receipt.start': 'Start receiving',
  'card.wh.receipt.started': 'Receipt started',
  'card.wh.receipt.startUnavailable': 'Only a draft can be started',
  'card.wh.receipt.cancel': 'Cancel receipt',
  'card.wh.receipt.cancelled': 'Receipt cancelled',
  'card.wh.receipt.cancelUnavailable':
    'A posted receipt is reversed by a supplier return, not by cancelling the document',
  'card.wh.receipt.countingOnTerminal': 'Lines are counted on the handheld terminal',

  'card.wh.ship.posted': 'Posted',
  'card.wh.ship.notPosted': 'Not posted',
  'card.wh.ship.handedOver': 'Handed to carrier',
  'card.wh.ship.notHandedOver': 'Not handed over',
  'card.wh.ship.delivered': 'Delivered',
  'card.wh.ship.notDelivered': 'Not delivered',
  'card.wh.ship.carrier': 'Carrier',
  'card.wh.ship.tracking': 'Tracking number',
  'card.wh.ship.packages': 'Packages',
  'card.wh.ship.packageNo': 'Package',
  'card.wh.ship.noLines': 'Shipment has no lines',
  'card.wh.ship.notPacked': 'Not packed yet: packing happens on the terminal',
  'card.wh.ship.handOver': 'Hand over to carrier',
  'card.wh.ship.carrierCode': 'Carrier code',
  'card.wh.ship.handOverSubmit': 'Hand over',
  'card.wh.ship.handedOverDone': 'Carrier request sent',
  'card.wh.ship.handOverNeedsPosting': 'Post the shipment first: what is handed over is already written off',
  'card.wh.ship.alreadyHandedOver': 'Already handed over: a repeat request brings a second courier',
  'card.wh.ship.markDelivered': 'Mark delivery',
  'card.wh.ship.deliveredAt': 'Delivered at',
  'card.wh.ship.markDeliveredSubmit': 'Mark delivered',
  'card.wh.ship.deliveredDone': 'Delivery recorded',
  'card.wh.ship.deliveredHint': 'The moment comes from the carrier; empty means now',
  'card.wh.ship.deliverNeedsHandOver': 'Shipment has not been handed to a carrier yet',
  'card.wh.ship.alreadyDelivered': 'Delivery already recorded',
  'card.wh.ship.packingOnTerminal': 'Packing and posting happen on the handheld terminal',

  'card.wh.pick.mode': 'Mode',
  'card.wh.pick.stops': 'Route stops',
  'card.wh.pick.shortages': 'Shortages',
  'card.wh.pick.shortageNotice':
    'The task has shortages: goods were not on the shelf — a reason to recount the cell',
  'card.wh.pick.routeOrder': 'No.',
  'card.wh.pick.required': 'Required',
  'card.wh.pick.picked': 'Picked',
  'card.wh.pick.noLines': 'The task has no lines',
  'card.wh.pick.assign': 'Assign a picker',
  'card.wh.pick.assignee': 'Employee',
  'card.wh.pick.assigneeHint': 'Employee id: there is no warehouse-filtered directory yet',
  'card.wh.pick.assignSubmit': 'Assign',
  'card.wh.pick.assigned': 'Picker assigned',
  'card.wh.pick.cancel': 'Cancel the task',
  'card.wh.pick.cancelHint': 'Cancelling releases the reservations the task was holding',
  'card.wh.pick.cancelSubmit': 'Cancel task',
  'card.wh.pick.cancelled': 'Task cancelled',
  'card.wh.pick.cancelUnavailable': 'A completed or cancelled task cannot be cancelled',

  'card.wh.stocktake.scope': 'Scope',
  'card.wh.stocktake.blind': 'Blind count',
  'card.wh.stocktake.blindNotice':
    'Blind count: the expected quantity is shown to nobody, the office included',
  'card.wh.stocktake.expected': 'Expected',
  'card.wh.stocktake.counted': 'Counted',
  'card.wh.stocktake.variance': 'Variance',
  'card.wh.stocktake.kind': 'Kind',
  'card.wh.stocktake.comment': 'Comment',
  'card.wh.stocktake.surplus': 'Surplus',
  'card.wh.stocktake.shortage': 'Shortage',
  'card.wh.stocktake.noLines': 'The count sheet is empty',
  'card.wh.stocktake.noVariances': 'No variances: the count matches the books',
  'card.wh.stocktake.approve': 'Approve results',
  'card.wh.stocktake.approved': 'Approved, adjustments: {count}',
  'card.wh.stocktake.approveWarning':
    'Approval changes the balance: the correction is applied as a difference to the current quantity',
  'card.wh.stocktake.approveNeedsCounting': 'Counting is not finished yet',
  'card.wh.stocktake.alreadyApproved': 'Results are already approved',
  'card.wh.stocktake.needsApproveRight':
    'Approval needs its own right: it moves stock, that is money on the balance sheet',
  'card.wh.stocktake.approvedAt': 'Approved at',
  'card.wh.stocktake.notApproved': 'Not approved',
  'card.wh.stocktake.adjustments': 'Posted adjustments',
  'card.wh.stocktake.noAdjustments': 'No adjustments needed: the count matched',
  'card.wh.stocktake.before': 'Before',
  'card.wh.stocktake.after': 'After',
  'card.wh.stocktake.delta': 'Delta',
  'card.wh.stocktake.cancel': 'Cancel stocktake',
  'card.wh.stocktake.cancelled': 'Stocktake cancelled',

  'card.wh.stock.order': 'Order',
  'card.wh.stock.expires': 'Expires',
  'card.wh.stock.noExpiry': 'Until shipment',
  'card.wh.stock.noReservations': 'No reservations: the whole balance is free',

  'card.wh.transfer.dispatched': 'Dispatched',
  'card.wh.transfer.notDispatched': 'Not dispatched',
  'card.wh.transfer.received': 'Received',
  'card.wh.transfer.notReceived': 'Not received',
  'card.wh.transfer.sent': 'Sent',
  'card.wh.transfer.accepted': 'Accepted',
  'card.wh.transfer.loss': 'Transit loss',
  'card.wh.transfer.lossNotice':
    'There are transit losses: a claim against the carrier, not a shortage of the receiving warehouse',
  'card.wh.transfer.noLines': 'The transfer has no lines',
  'card.wh.transfer.dispatch': 'Dispatch',
  'card.wh.transfer.dispatchHint':
    'Dispatch writes the goods off the sending warehouse: they are on the lorry, not on the shelf',
  'card.wh.transfer.dispatchSubmit': 'Dispatch',
  'card.wh.transfer.dispatchedDone': 'Transfer dispatched',
  'card.wh.transfer.alreadyDispatched': 'Already dispatched: the goods are in transit',
  'card.wh.transfer.cancel': 'Cancel transfer',
  'card.wh.transfer.cancelledDone': 'Transfer cancelled',
  'card.wh.transfer.cancelUnavailable': 'A dispatched transfer cannot be cancelled: goods are in transit',
  'card.wh.transfer.receiptOnTerminal': 'Receiving a transfer happens on the destination terminal',

  'warehouse.receipt.status.draft': 'Draft',
  'warehouse.receipt.status.in_progress': 'In progress',
  'warehouse.receipt.status.completed': 'Completed',
  'warehouse.receipt.status.cancelled': 'Cancelled',

  'warehouse.shipment.status.draft': 'Draft',
  'warehouse.shipment.status.packed': 'Packed',
  'warehouse.shipment.status.posted': 'Posted',
  'warehouse.shipment.status.shipped': 'Shipped',
  'warehouse.shipment.status.delivered': 'Delivered',
  'warehouse.shipment.status.cancelled': 'Cancelled',

  'warehouse.pick.status.created': 'Created',
  'warehouse.pick.status.assigned': 'Assigned',
  'warehouse.pick.status.in_progress': 'In progress',
  'warehouse.pick.status.completed': 'Completed',
  'warehouse.pick.status.cancelled': 'Cancelled',
  'warehouse.pick.mode.order': 'By order',
  'warehouse.pick.mode.wave': 'Wave',
  'warehouse.pickline.status.pending': 'Pending',
  'warehouse.pickline.status.picked': 'Picked',
  'warehouse.pickline.status.skipped': 'Skipped',
  'warehouse.pickline.status.short': 'Short',

  'warehouse.stocktake.status.draft': 'Draft',
  'warehouse.stocktake.status.counting': 'Counting',
  'warehouse.stocktake.status.counted': 'Counted',
  'warehouse.stocktake.status.approved': 'Approved',
  'warehouse.stocktake.status.cancelled': 'Cancelled',
  'warehouse.stocktake.scope.full': 'Whole warehouse',
  'warehouse.stocktake.scope.zone': 'Zone',
  'warehouse.stocktake.scope.cell': 'Cell',
  'warehouse.stocktake.scope.product': 'Product',

  'warehouse.transfer.status.draft': 'Draft',
  'warehouse.transfer.status.in_transit': 'In transit',
  'warehouse.transfer.status.received': 'Received',
  'warehouse.transfer.status.cancelled': 'Cancelled',

  'warehouse.reservation.status.active': 'Active',
  'warehouse.reservation.status.released': 'Released',
  'warehouse.reservation.status.shipped': 'Shipped',
  'warehouse.reservation.status.expired': 'Expired',

  // ------------------------------------------------------------------ HR (#75)

  'column.personnel_number': 'Personnel number',
  'column.last_name': 'Last name',
  'column.first_name': 'First name',
  'column.middle_name': 'Middle name',
  'column.work_email': 'Work email',
  'column.work_phone': 'Work phone',
  'column.position_id': 'Position',
  'column.manager_id': 'Manager',
  'column.hired_on': 'Hired on',
  'column.terminated_on': 'Terminated on',
  'column.birth_date': 'Date of birth',
  'column.gender': 'Gender',
  'column.organization_id': 'Organisation',
  'column.code': 'Code',
  'column.parent_id': 'Parent',
  'column.path': 'Tree path',
  'column.head_employee_id': 'Head',
  'column.cost_center': 'Cost centre',
  'column.salary_from': 'Salary from',
  'column.salary_to': 'Salary to',
  'column.recruiter_id': 'Recruiter',
  'column.hiring_manager_id': 'Hiring manager',
  'column.opened_on': 'Opened on',
  'column.target_close_on': 'Target close',
  'column.closed_on': 'Closed on',
  'column.external_source': 'External source',
  'column.external_id': 'External id',
  'column.employee_id': 'Employee',
  'column.leave_type': 'Leave type',
  'column.start_date': 'From',
  'column.end_date': 'To',
  'column.days_count': 'Days',
  'column.comment': 'Comment',
  'column.kpi_id': 'Metric',
  'column.period_start': 'Period from',
  'column.period_end': 'Period to',
  'column.target_value': 'Target',
  'column.actual_value': 'Actual',
  'column.bonus_amount': 'Bonus',

  'card.section.assignment': 'Assignment',

  'card.tab.hrAssignments': 'Assignments',
  'card.tab.hrReports': 'Direct reports',
  'card.tab.hrBalances': 'Leave',
  'card.tab.hrKpi': 'KPI',
  'card.tab.hrPersonalData': 'Personal data',
  'card.tab.hrActions': 'Actions',
  'card.tab.hrOrgTree': 'Org structure',
  'card.tab.hrApproval': 'Approval',
  'card.tab.hrRoute': 'Route',
  'card.tab.hrTimesheet': 'Timesheet',
  'card.tab.hrBoard': 'Candidates',
  'card.tab.hrFunnel': 'Funnel',
  'card.tab.hrKpiTargets': 'Metrics',

  'card.hr.emp.noAssignments': 'No assignments',
  'card.hr.emp.effectiveFrom': 'Effective from',
  'card.hr.emp.effectiveTo': 'Effective to',
  'card.hr.emp.open': 'current',
  'card.hr.emp.reason': 'Reason',
  'card.hr.emp.position': 'Position',
  'card.hr.emp.salary': 'Salary',
  'card.hr.emp.rate': 'Rate',
  'card.hr.emp.order': 'Order',
  'card.hr.emp.name': 'Employee',
  'card.hr.emp.noReports': 'No direct reports',
  'card.hr.emp.pdnHidden': 'Personal data is encrypted. Every view is written to the audit log.',
  'card.hr.emp.pdnReveal': 'Show personal data',
  'card.hr.emp.pdnEmpty': 'No personal data on file',
  'card.hr.emp.inn': 'Tax number',
  'card.hr.emp.snils': 'Insurance number',
  'card.hr.emp.passport': 'Passport',
  'card.hr.emp.personalPhone': 'Personal phone',
  'card.hr.emp.confirmProbation': 'Confirm probation',
  'card.hr.emp.probationConfirmed': 'Probation confirmed',
  'card.hr.emp.probationUnavailable': 'The employee is not on probation',
  'card.hr.emp.needsUpdate': 'No permission to change the employee record',
  'card.hr.emp.terminateElsewhere': 'Transfer and termination are issued by order: an effective date and an order number are required.',

  'card.hr.dept.empty': 'No departments',
  'card.hr.dept.head': 'Head',
  'card.hr.dept.move': 'Move',
  'card.hr.dept.moveTo': 'New parent department',
  'card.hr.dept.moveToRoot': 'empty — move to root',
  'card.hr.dept.moved': 'The department moved together with its subtree',
  'card.hr.dept.needsUpdate': 'No permission to change the org structure',

  'card.hr.leave.clashes': 'Who else in the department is away over these dates',
  'card.hr.leave.noClashes': 'No overlap with colleagues on leave',
  'card.hr.leave.clashesUnknownDepartment': 'The department of this employee is unknown, so overlaps cannot be shown. That is not the same as there being none.',
  'card.hr.leave.coverage': '{away} of {headcount} away, {present} present',
  'card.hr.leave.thin': 'The department would be left short of a third of its people.',
  'card.hr.leave.approve': 'Approve',
  'card.hr.leave.reject': 'Reject',
  'card.hr.leave.approved': 'Approved, the days have been deducted',
  'card.hr.leave.rejected': 'Rejected',
  'card.hr.leave.decisionUnavailable': 'A decision is taken on a request awaiting approval',
  'card.hr.leave.needsApprove': 'No permission to approve absences',
  'card.hr.leave.rowMissing': 'The request row was not read: without an employee and dates, overlaps cannot be asked for.',
  'card.hr.leave.noRoute': 'The route is empty: the employee has no manager with an account',
  'card.hr.leave.step': 'Step',
  'card.hr.leave.stepName': 'Name',
  'card.hr.leave.approver': 'Approver',
  'card.hr.leave.approverUser': 'account {id}',
  'card.hr.leave.approverRole': 'anyone in role {id}',
  'card.hr.leave.noBalances': 'No balances',
  'card.hr.leave.year': 'Year',
  'card.hr.leave.entitled': 'Entitled',
  'card.hr.leave.used': 'Used',
  'card.hr.leave.carriedOver': 'Carried over',
  'card.hr.leave.remaining': 'Remaining',
  'card.hr.leave.carryOver': 'Carry over',
  'card.hr.leave.carriedOverDone': 'The days were carried into next year',
  'card.hr.leave.noTimesheet': 'The timesheet for this period is not filled in',
  'card.hr.leave.day': 'Day',
  'card.hr.leave.dayType': 'Type',
  'card.hr.leave.hours': 'Hours',

  'card.hr.vac.noApplications': 'No applications',
  'card.hr.vac.moveTo': 'Move to stage',
  'card.hr.vac.stageChanged': 'Stage changed',
  'card.hr.vac.reject': 'Reject',
  'card.hr.vac.rejected': 'Rejection recorded',
  'card.hr.vac.reason': 'Rejection reason',
  'card.hr.vac.reasonRequired': 'A rejection without a reason is not saved: there is nothing to tell the candidate and nothing to analyse.',
  'card.hr.vac.revokeConsent': 'Revoke data consent',
  'card.hr.vac.consentRevoked': 'Consent revoked, the data is anonymised',
  'card.hr.vac.funnel': 'Funnel',
  'card.hr.vac.conversion': 'Stage-to-stage conversion',
  'card.hr.vac.stageFrom': 'From stage',
  'card.hr.vac.stageTo': 'To stage',
  'card.hr.vac.entered': 'Reached',
  'card.hr.vac.moved': 'Moved on',
  'card.hr.vac.percent': 'Conversion, %',
  'card.hr.vac.timeToFill': 'Time to fill',
  'card.hr.vac.stillOpen': 'The vacancy is still open, so the term has not come',
  'card.hr.vac.filledInDays': 'Filled in {days} days',

  'card.hr.kpi.noTargets': 'No targets',
  'card.hr.kpi.completion': 'Completion, %',
  'card.hr.kpi.metric': 'Metric',
  'card.hr.kpi.weight': 'Weight',
  'card.hr.kpi.overall': 'Overall completion: {percent}%',
  'card.hr.kpi.departmentGoal': 'This is a department goal: it has no individual employee.',
  'card.hr.kpi.bonusElsewhere': 'The bonus is computed from a bonus fund, which is set when it is settled.',

  'hr.employee.status.active': 'Active',
  'hr.employee.status.probation': 'Probation',
  'hr.employee.status.on_leave': 'On leave',
  'hr.employee.status.terminated': 'Terminated',

  'hr.assignment.reason.hire': 'Hire',
  'hr.assignment.reason.transfer': 'Transfer',
  'hr.assignment.reason.promotion': 'Promotion',
  'hr.assignment.reason.salary_change': 'Salary change',
  'hr.assignment.reason.termination': 'Termination',

  'hr.leave.type.annual': 'Annual',
  'hr.leave.type.unpaid': 'Unpaid',
  'hr.leave.type.sick': 'Sick leave',
  'hr.leave.type.maternity': 'Parental leave',
  'hr.leave.type.study': 'Study leave',
  'hr.leave.type.day_off': 'Day off',

  'hr.leave.status.draft': 'Draft',
  'hr.leave.status.pending': 'Awaiting approval',
  'hr.leave.status.approved': 'Approved',
  'hr.leave.status.rejected': 'Rejected',
  'hr.leave.status.cancelled': 'Cancelled',

  'hr.timesheet.type.work': 'Work',
  'hr.timesheet.type.vacation': 'Vacation',
  'hr.timesheet.type.sick': 'Sick',
  'hr.timesheet.type.day_off': 'Day off',
  'hr.timesheet.type.holiday': 'Public holiday',
  'hr.timesheet.type.absence': 'Absence',
  'hr.timesheet.type.business_trip': 'Business trip',

  'hr.application.stage.applied': 'Applied',
  'hr.application.stage.screening': 'Screening',
  'hr.application.stage.interview': 'Interview',
  'hr.application.stage.offer': 'Offer',
  'hr.application.stage.hired': 'Hired',
  'hr.application.stage.rejected': 'Rejected',
  // Analytics and reports (#76)
  'nav.section.analytics': 'Analytics',
  'nav.reportBuilder': 'Report builder',
  'nav.salesReports': 'Sales reports',
  'nav.financeReports': 'Finance reports',
  'nav.warehouseReports': 'Warehouse reports',
  'nav.reportSchedules': 'Report schedules',

  'report.empty': 'No data for the selected period',
  'report.period.from': 'From',
  'report.period.to': 'To',
  'report.forbidden': 'No permission for this report’s data',
  'report.builder.hint':
    'Pick a source, dimensions and measures. The field list is limited by the registry: it decides what data reporting may reach.',
  'report.source': 'Source',
  'report.source.choose': 'Choose a source',
  'report.noSources': 'No sources available',
  'report.dimensions': 'Dimensions',
  'report.measures': 'Measures',
  'report.filters': 'Filters',
  'report.measure.field': 'Measure field',
  'report.measure.choose': 'Choose a field',
  'report.measure.aggregate': 'Aggregate',
  'report.measure.add': 'Add measure',
  'report.filter.field': 'Filter field',
  'report.filter.choose': 'Choose a field',
  'report.filter.add': 'Add filter',
  'report.filter.operator': 'Operator',
  'report.filter.value': 'Value',
  'report.remove': 'Remove',
  'report.preview': 'Preview',
  'report.save': 'Save report',
  'report.saved': 'Report “{name}” saved',
  'report.saved.title': 'Saved reports',
  'report.saved.empty': 'No saved reports yet',
  'report.run': 'Run',
  'report.export': 'Export',
  'report.delete': 'Delete',
  'report.code': 'Code',
  'report.name': 'Name',
  'report.category': 'Category',
  'report.rows': 'Rows: {count}',
  'report.target.primary': 'primary database',
  'report.target.replica': 'replica',
  'report.category.sales': 'Sales',
  'report.category.warehouse': 'Warehouse',
  'report.category.finance': 'Finance',
  'report.category.hr': 'HR',
  'report.aggregate.sum': 'Sum',
  'report.aggregate.avg': 'Average',
  'report.aggregate.min': 'Minimum',
  'report.aggregate.max': 'Maximum',
  'report.aggregate.count': 'Count',
  'report.source.pnl': 'Profit and loss',
  'report.source.stock': 'Stock balances',
  'report.source.receivables': 'Receivables',
  'report.source.consumption': 'Goods consumption',
  'report.source.supplier_quality': 'Supplier quality',
  'report.source.funnel': 'Sales funnel',
  'report.source.ltv': 'Customer lifetime value',

  'report.tab.funnel': 'Funnel',
  'report.tab.pnl': 'Profit and loss',
  'report.tab.unit': 'Unit economics',
  'report.tab.actual': 'Cash flow: actual',
  'report.tab.forecast': 'Cash flow: forecast',
  'report.tab.receivables': 'Receivables',
  'report.tab.abc': 'ABC/XYZ',
  'report.tab.dead': 'Dead stock',
  'report.tab.pickers': 'Pickers',
  'report.tab.suppliers': 'Suppliers',

  'report.funnel.id': 'Funnel',
  'report.funnel.choose': 'Specify a funnel to build the report',
  'report.funnel.stage': 'Stage',
  'report.funnel.movedOn': 'Moved on',
  'report.funnel.movedBack': 'Moved back',
  'report.funnel.won': 'Won',
  'report.funnel.lost': 'Lost',
  'report.funnel.conversion': 'Conversion',
  'report.funnel.cycle': 'Deal cycle',
  'report.funnel.deals': 'Deals',
  'report.funnel.avgCycle': 'Average cycle',
  'report.funnel.medianCycle': 'Median cycle',
  'report.funnel.losses': 'Loss reasons',
  'report.funnel.noReason': 'No reason given',

  'report.pnl.dimension': 'Breakdown',
  'report.pnl.dimension.PRODUCT': 'By product',
  'report.pnl.dimension.PRODUCT_CATEGORY': 'By category',
  'report.pnl.dimension.EMPLOYEE': 'By manager',
  'report.pnl.dimension.COUNTERPARTY': 'By counterparty',
  'report.pnl.dimension.DEPARTMENT': 'By department',
  'report.pnl.dimension.TERRITORY': 'By territory',
  'report.pnl.group': 'Breakdown',
  'report.pnl.revenue': 'Revenue',
  'report.pnl.cost': 'Cost',
  'report.pnl.margin': 'Margin',
  'report.pnl.marginPercent': 'Margin, %',
  'report.pnl.incomplete':
    'Lines without cost: {count}. Their margin is not counted — the figure shown is lower than the real one.',

  'report.unit.channel': 'Channel',
  'report.unit.customers': 'Customers',
  'report.unit.spend': 'Spend',
  'report.unit.cac': 'CAC',
  'report.unit.ltv': 'LTV',
  'report.unit.ratio': 'LTV / CAC',

  'report.cash.item': 'Item',
  'report.cash.source': 'Source',
  'report.cash.direction': 'Direction',
  'report.cash.direction.in': 'Inflow',
  'report.cash.direction.out': 'Outflow',
  'report.cash.direction.incoming': 'Inflow',
  'report.cash.direction.outgoing': 'Outflow',
  'report.cash.amount': 'Amount',
  'report.cash.weighted': 'Weighted',
  'report.cash.kind.pipeline': 'Pipeline',
  'report.cash.kind.invoice': 'Invoices',
  'report.cash.kind.recurring': 'Subscriptions',

  'report.ageing.counterparty': 'Counterparty',
  'report.ageing.notYetDue': 'Not yet due',
  'report.ageing.b0': 'Up to 30 days',
  'report.ageing.b31': '31–60 days',
  'report.ageing.b61': '61–90 days',
  'report.ageing.b90': 'Over 90 days',
  'report.ageing.overdue': 'Overdue',
  'report.ageing.total': 'Total',

  'report.abc.sku': 'SKU',
  'report.abc.product': 'Product',
  'report.abc.cost': 'Turnover',
  'report.abc.cumulative': 'Cumulative share',
  'report.abc.class': 'Class',
  'report.abc.variation': 'Variation coeff.',
  'report.abc.months': 'Months of history',
  'report.abc.turnover': 'Turnover ratio',
  'report.dead.since': 'Not moved since',
  'report.dead.onHand': 'On hand',
  'report.dead.lastOutbound': 'Last shipment',
  'report.dead.never': 'Never shipped',

  'report.picker.employee': 'Picker',
  'report.picker.tasks': 'Tasks',
  'report.picker.lines': 'Lines',
  'report.picker.perHour': 'Lines per hour',
  'report.picker.shortfall': 'Shortfall, %',

  'report.supplier.name': 'Supplier',
  'report.supplier.receipts': 'Receipts',
  'report.supplier.rejected': 'Defects',
  'report.supplier.shortfall': 'Shortfall',
  'report.supplier.defectPercent': 'Defects, %',

  'report.schedule.hint':
    'Five-field cron. The email is a snapshot at send time — missed runs are not caught up.',
  'report.schedule.report': 'Report',
  'report.schedule.chooseReport': 'Choose a report',
  'report.schedule.cron': 'Schedule (cron)',
  'report.schedule.format': 'Format',
  'report.schedule.recipients': 'Recipients, comma separated',
  'report.schedule.lastRun': 'Last run',
  'report.schedule.nextRun': 'Next run',
  'report.schedule.notScheduled': 'Not scheduled',
  'report.schedule.add': 'Add schedule',

  'column.revenue': 'Revenue',
  'column.cost': 'Cost',
  'column.margin': 'Margin',
  'column.quantity': 'Quantity',
  'column.product_id': 'Product',
  'column.product_category_id': 'Product category',
  'column.territory_id': 'Territory',
  'column.product_name': 'Name',
  'column.warehouse_id': 'Warehouse',
  'column.warehouse_code': 'Warehouse code',
  'column.on_hand': 'On hand',
  'column.reserved': 'Reserved',
  'column.available': 'Available',
  'column.custody_quantity': 'In custody',
  'column.counterparty_name': 'Counterparty',
  'column.outstanding_total': 'Outstanding total',
  'column.not_yet_due': 'Not yet due',
  'column.bucket_0_30': 'Up to 30 days',
  'column.bucket_31_60': '31–60 days',
  'column.bucket_61_90': '61–90 days',
  'column.bucket_90_plus': 'Over 90 days',
  'column.month': 'Month',
  'column.cost_amount': 'Cost amount',
  'column.movement_count': 'Movements',
  'column.supplier_id': 'Supplier',
  'column.supplier_name': 'Supplier',
  'column.received_on': 'Received on',
  'column.receipt_count': 'Receipts',
  'column.accepted_quantity': 'Accepted',
  'column.rejected_quantity': 'Rejected',
  'column.shortfall_quantity': 'Shortfall',
  'column.from_stage_name': 'From stage',
  'column.to_stage_name': 'To stage',
  'column.direction': 'Direction',
  'column.changed_on': 'Changed on',
  'column.transition_count': 'Transitions',
  'column.avg_duration_seconds': 'Average duration, s',
  'column.lead_source': 'Lead source',
  'column.utm_source': 'UTM source',
  'column.utm_medium': 'UTM medium',
  'column.acquired_on': 'Acquired on',
  'column.lifetime_revenue': 'Lifetime revenue',
  'column.lifetime_margin': 'Lifetime margin',
  'column.deal_count': 'Deals',

  // ---------------------------------------------------------------- payments (#78)
  'nav.section.payments': 'Payments',
  'nav.reconciliation': 'Payment reconciliation',
  'nav.cashBook': 'Cash book',
  'nav.fiscal': 'Fiscalisation',
  'nav.paymentRegistry': 'Payment register',

  'payments.organization': 'Organisation',
  'payments.organization.choose': 'Choose an organisation',
  'payments.account': 'Bank account',
  'payments.account.choose': 'Choose an account',

  'payments.reconciliation.hint':
    'Upload a 1C Client-Bank statement. Lines become payments and settle invoices automatically; whatever did not match stays in the lists below.',
  'payments.import.file': 'Statement file',
  'payments.import.done': 'Statement uploaded: {imported} new lines of {total}, {duplicates} already known',
  'payments.import.duplicate': 'This statement is already uploaded — the same {total} operations. Nothing was created again.',
  'payments.convertAll': 'Post all',
  'payments.convertLine': 'Post',
  'payments.absorbAdvances': 'Move surplus to the customer balance',
  'payments.convert.done': 'Posted {converted}, {remaining} left',
  'payments.convert.failed': 'Not posted: {ids}',

  'payments.unprocessedLines': 'Unposted statement lines',
  'payments.unprocessedLines.hint':
    'The bank reported it, no payment yet. The line is never overwritten and never disappears - it waits.',
  'payments.unprocessedLines.empty': 'The whole statement has been posted',
  'payments.needingAttention': 'Payments with no counterparty',
  'payments.needingAttention.hint':
    'The money arrived but the payer was not identified. While the row is here, the payment is not lost.',
  'payments.needingAttention.empty': 'Every payment has been allocated',

  'payments.cashBook.hint':
    'The journal is append-only: a correction is a reversing entry beside the mistake, not an edit of it.',
  'payments.cashBook.entries': 'Entries',
  'payments.cashBook.totals': 'Turnover by item',
  'payments.cashBook.empty': 'No entries in this period',
  'payments.cashBook.netFlow': 'Net flow for the period:',
  'payments.cashBook.reverses': '(reverses entry {id})',
  'payments.reverse': 'Reverse',
  'payments.reverse.reason': 'Reason for the reversal',

  'payments.fiscal.hint':
    'Paid here and registered with the OFD are different facts. This is what never reached the OFD.',
  'payments.fiscal.outstanding': 'receipts that never reached the OFD',
  'payments.fiscal.empty': 'Every receipt reached the OFD',
  'payments.fiscal.retry': 'Retry all pending ({count})',
  'payments.fiscal.retry.done': 'Receipts sent: {count}',
  'payments.fiscal.retry.none':
    'Nothing to send: the receipts are not due for another attempt yet',
  'payments.acquiring.unprocessed': 'Acquiring notifications with no payment',
  'payments.acquiring.hint':
    'The journal is keyed by event: one payment produces several notifications from the provider.',
  'payments.acquiring.empty': 'No unprocessed notifications',
  'payments.acquiring.signed': 'Signature verified',
  'payments.acquiring.unsigned': 'Signature not verified',

  'payments.direction.incoming': 'In',
  'payments.direction.outgoing': 'Out',
  'payments.item.sales_revenue': 'Revenue',
  'payments.item.customer_advance': 'Customer advance',
  'payments.item.other_income': 'Other income',
  'payments.item.refund_issued': 'Refund issued',
  'payments.item.supplier_payment': 'Supplier payment',
  'payments.item.payroll': 'Payroll',
  'payments.item.taxes': 'Taxes',
  'payments.item.rent': 'Rent',
  'payments.item.other_expense': 'Other expense',
  'payments.receiptKind.sale': 'Sale',
  'payments.receiptKind.refund': 'Refund',
  'payments.receiptKind.correction': 'Correction',
  'payments.receiptStatus.pending': 'Awaiting submission',
  'payments.receiptStatus.sent': 'Sent, no answer',
  'payments.receiptStatus.registered': 'Registered',
  'payments.receiptStatus.failed': 'Submission failed',
  'payments.receiptStatus.abandoned': 'Retries exhausted',

  'payments.column.statementDate': 'Statement date',
  'payments.column.paymentDate': 'Payment date',
  'payments.column.paymentDirection': 'Direction',
  'payments.column.paymentAmount': 'Amount',
  'payments.column.unallocated': 'Unallocated',
  'payments.column.payer': 'Payer',
  'payments.column.paymentPurpose': 'Purpose',
  'payments.column.entryDate': 'Entry date',
  'payments.column.cashItem': 'Cash-flow item',
  'payments.column.entryDescription': 'Description',
  'payments.column.turnover': 'Turnover',
  'payments.column.receiptCreated': 'Issued',
  'payments.column.receiptKind': 'Receipt kind',
  'payments.column.receiptTotal': 'Receipt total',
  'payments.column.receiptStatus': 'OFD status',
  'payments.column.receiptAttempts': 'Attempts',
  'payments.column.receiptError': 'Error',
  'payments.column.webhookReceived': 'Received',
  'payments.column.webhookProvider': 'Provider',
  'payments.column.webhookEvent': 'Event',
  'payments.column.webhookStatus': 'Status',
  'payments.column.webhookSignature': 'Signature',

  // List-registry columns (#78). The column.* prefix is shared with other sections,
  // so these names are ones no existing catalogue entity uses.
  'column.unallocated_amount': 'Unallocated',
  'column.payer_name': 'Payer',
  'column.payer_inn': 'Payer INN',
  'column.payment_date': 'Payment date',
  'column.value_date': 'Value date',
  'column.bank_account_id': 'Bank account',
  // Cross-cutting: approvals, tasks, timeline, notifications (#79).
  'nav.section.work': 'Work',
  'nav.approvals': 'Approvals',
  'nav.tasks': 'Tasks',
  'nav.notifications': 'Notifications',
  'approvals.title': 'My approvals',
  'approvals.queue.empty': 'Nothing is waiting for your signature',
  'approvals.requestedBy': 'Raised by',
  'approvals.requestedAt': 'Raised',
  'approvals.step': 'Step',
  'approvals.approver': 'Approver',
  'approvals.stepStatus': 'Decision',
  'approvals.decidedAt': 'Decided',
  'approvals.comment': 'Comment',
  'approvals.approve': 'Approve',
  'approvals.reject': 'Reject',
  'approvals.needComment': 'A rejection needs a reason',
  'approvals.waitingOnSomeoneElse': 'Waiting on another approver',
  'approvals.history.empty': 'This document has never been through approval',
  'approvals.status.pending': 'Awaiting approval',
  'approvals.status.approved': 'Approved',
  'approvals.status.rejected': 'Rejected',
  'approvals.status.cancelled': 'Withdrawn',
  'approvals.stepStatus.pending': 'Waiting',
  'approvals.stepStatus.approved': 'Approved',
  'approvals.stepStatus.rejected': 'Rejected',
  'approvals.stepStatus.skipped': 'Not reached',
  'approvals.entity.quote': 'Quote',
  'approvals.entity.invoice': 'Invoice',
  'approvals.entity.leave': 'Leave request',
  'approvals.delegation.title': 'Delegation of signing authority',
  'approvals.delegation.granted': 'Handed over by me',
  'approvals.delegation.received': 'Signing on behalf of',
  'approvals.delegation.to': 'To',
  'approvals.delegation.period': 'Period',
  'approvals.delegation.reason': 'Reason',
  'approvals.delegation.state': 'State',
  'approvals.delegation.active': 'In force',
  'approvals.delegation.expired': 'Expired',
  'approvals.delegation.revoked': 'Revoked',
  'approvals.delegation.revoke': 'Revoke',
  'approvals.delegation.openEnded': 'open-ended',
  'approvals.delegation.none': 'You have not handed your signature to anyone',
  'approvals.delegation.noneReceived': 'Nobody has handed you their signature',
  'tasks.title': 'My tasks',
  'tasks.open': 'In progress',
  'tasks.overdue': 'Overdue',
  'tasks.overdueBadge': 'overdue',
  'tasks.empty': 'No open tasks',
  'tasks.subject': 'Task',
  'tasks.due': 'Due',
  'tasks.status': 'Status',
  'tasks.complete': 'Complete',
  'tasks.status.planned': 'Planned',
  'tasks.status.in_progress': 'In progress',
  'tasks.status.done': 'Done',
  'tasks.status.cancelled': 'Cancelled',
  'tasks.noEmployeeCard': 'This account has no employee card, so no tasks are assigned to it',
  'card.tab.timeline': 'Timeline',
  'card.tab.approvals': 'Approvals',
  'timeline.empty': 'No interactions yet',
  'timeline.hasMore': 'Showing the most recent events; earlier ones live in the section',
  'timeline.kind.call': 'Call',
  'timeline.kind.email': 'Email',
  'timeline.kind.meeting': 'Meeting',
  'timeline.kind.task': 'Task',
  'timeline.kind.note': 'Note',
  'timeline.kind.comment': 'Comment',
  'timeline.kind.stage': 'Stage',
  'timeline.stage.created': 'created',
  'timeline.stage.backwards': 'moved back',
  'notifications.title': 'Notifications',
  'notifications.empty': 'No notifications',
  'notifications.markRead': 'Mark read',
  'notifications.markAllRead': 'Mark all read · {count}',
  'notifications.live': 'Live delivery on',
  'notifications.offline': 'Connection lost: new items will appear on next open',

  // Dashboards and widgets (#77)
  'nav.dashboards': 'Dashboards',
  'dashboard.hint':
    'A dashboard is built from saved reports. Permissions are checked as the viewer: a widget over a report you cannot read refuses rather than showing figures that belong to someone else.',
  'dashboard.select': 'Dashboard',
  'dashboard.new': 'New dashboard',
  'dashboard.newName': 'Dashboard name',
  'dashboard.edit': 'Configure',
  'dashboard.done': 'Done',
  'dashboard.delete': 'Delete dashboard',
  'dashboard.empty': 'No widgets yet — add the first one over a saved report',
  'dashboard.defaultMark': '(default)',
  'dashboard.isDefault': 'Show on sign-in',
  'dashboard.isShared': 'Shared dashboard',
  'dashboard.composer': 'Composer',
  'dashboard.widget.title': 'Title',
  'dashboard.widget.report': 'Report',
  'dashboard.widget.pickReport': 'Choose a report',
  'dashboard.widget.type': 'Kind',
  'dashboard.widget.width': 'Width, columns',
  'dashboard.widget.refresh': 'Refresh every, seconds',
  'dashboard.widget.add': 'Add widget',
  'dashboard.widget.remove': 'Remove',
  'dashboard.widget.line': 'Trend',
  'dashboard.widget.type.kpi': 'Number',
  'dashboard.widget.type.table': 'Table',
  'dashboard.widget.type.bar': 'Bars',
  'dashboard.widget.type.line': 'Line',
  'dashboard.widget.type.funnel': 'Funnel',
  'dashboard.widget.type.pie': 'Pie',
  'dashboard.widget.type.gauge': 'Gauge',
  'dashboard.widget.type.heatmap': 'Heatmap',
  // Администрирование (#97)
  'nav.section.admin': 'Administration',
  'nav.adminNumbering': 'Document numbering',
  'nav.adminThresholds': 'Approval thresholds',
  'nav.adminCurrencies': 'Currencies',
  'nav.adminUnits': 'Units of measure',
  'nav.adminSettings': 'System settings',
  'admin.save': 'Save',
  'admin.cancel': 'Cancel',
  'admin.edit': 'Edit',
  'admin.yes': 'yes',
  'admin.no': 'no',
  'admin.numbering.hint': 'A mask applies from the next document. The counter is never changed: lowering it issues duplicates. A mask that would repeat numbers after a reset is refused.',
  'admin.numbering.documentType': 'Document',
  'admin.numbering.mask': 'Mask',
  'admin.numbering.reset': 'Counter reset',
  'admin.numbering.next': 'Next number',
  'admin.numbering.notSaved': '(not saved)',
  'admin.numbering.preview': 'Preview',
  'admin.numbering.reset.yearly': 'yearly',
  'admin.numbering.reset.monthly': 'monthly',
  'admin.numbering.reset.never': 'never',
  'admin.threshold.hint': 'A threshold is checked when a document is sent: a change applies from the next send, documents already sent are not re-approved.',
  'admin.threshold.add': 'Add threshold',
  'admin.threshold.form': 'Approval threshold',
  'admin.threshold.documentType': 'Document',
  'admin.threshold.name': 'Name',
  'admin.threshold.organization': 'Organisation',
  'admin.threshold.allOrganizations': 'All organisations',
  'admin.threshold.minDiscount': 'Discount from, %',
  'admin.threshold.minAmount': 'Amount from',
  'admin.threshold.currency': 'Amount currency',
  'admin.threshold.approverRole': 'Approver role',
  'admin.threshold.approverUser': 'Approver user',
  'admin.threshold.approver': 'Approver',
  'admin.threshold.step': 'Step',
  'admin.threshold.escalate': 'Escalate after, h',
  'admin.threshold.active': 'Active',
  'admin.threshold.condition': 'Condition',
  'admin.threshold.discountFrom': 'discount from {value}%',
  'admin.threshold.amountFrom': 'amount from {value} {currency}',
  'admin.threshold.or': 'or',
  'admin.currency.hint': 'A currency code never changes once created: invoices, balances and rates refer to it. There is no deletion for the same reason.',
  'admin.currency.add': 'Add currency',
  'admin.currency.form': 'Currency',
  'admin.currency.code': 'ISO code',
  'admin.currency.numericCode': 'Numeric code',
  'admin.currency.name': 'Name',
  'admin.currency.symbol': 'Symbol',
  'admin.currency.minorUnits': 'Minor units',
  'admin.unit.hint': 'A unit code never changes: imports and integrations find products by it. Precision is up to four digits, as quantities are stored.',
  'admin.unit.add': 'Add unit',
  'admin.unit.form': 'Unit of measure',
  'admin.unit.code': 'Code',
  'admin.unit.okei': 'OKEI',
  'admin.unit.name': 'Name',
  'admin.unit.kind': 'Kind',
  'admin.unit.precision': 'Decimal places',
  'admin.settings.hint': 'Time zone, working hours and the default organisation for the whole system.',
  'admin.settings.notApplied': 'The time zone and the default reminder apply: recurring tasks and reminders use them. Working hours and days are stored only — SLA (#115) will read them.',
  'admin.settings.timeZone': 'Time zone',
  'admin.settings.workDayStart': 'Working day starts',
  'admin.settings.workDayEnd': 'Working day ends',
  'admin.settings.workDays': 'Working days',
  'admin.settings.defaultOrganization': 'Default organisation',
  'admin.documentType.invoice': 'Invoice',
  'admin.documentType.quote': 'Quote',
  'admin.documentType.contract': 'Contract',
  'admin.documentType.act': 'Act',
  'admin.documentType.upd': 'UPD',
  'admin.documentType.torg12': 'TORG-12',
  'admin.documentType.invoice_factura': 'VAT invoice',
  'admin.documentType.deal': 'Deal',
  'admin.documentType.sales_order': 'Sales order',
  'admin.documentType.purchase_order': 'Purchase order',
  'admin.documentType.goods_receipt': 'Goods receipt',
  'admin.documentType.shipment': 'Shipment',
  'admin.documentType.pick_task': 'Pick task',
  'admin.documentType.stocktake': 'Stocktake',
  'admin.documentType.stock_transfer': 'Stock transfer',
  'admin.documentType.stock_write_off': 'Write-off',
  'admin.documentType.goods_return': 'Goods return',
  'admin.documentType.hr_order': 'HR order',
  'admin.documentType.hr_certificate': 'HR certificate',
  'admin.documentType.packing_list': 'Packing list',
  'admin.documentType.revaluation': 'Revaluation',
  'admin.documentType.custody_bill': 'Custody bill',
  'admin.documentType.support_ticket': 'Support ticket',
  'admin.unit.kind.piece': 'Piece',
  'admin.unit.kind.weight': 'Weight',
  'admin.unit.kind.volume': 'Volume',
  'admin.unit.kind.length': 'Length',
  'admin.unit.kind.area': 'Area',
  'admin.unit.kind.time': 'Time',
  'admin.settings.day.1': 'Mon',
  'admin.settings.day.2': 'Tue',
  'admin.settings.day.3': 'Wed',
  'admin.settings.day.4': 'Thu',
  'admin.settings.day.5': 'Fri',
  'admin.settings.day.6': 'Sat',
  'admin.settings.day.7': 'Sun',
  // Контакты и участники сделки (#98)
  'nav.contacts': 'Contacts',
  'contact.add': 'Add contact',
  'contact.create': 'Create contact',
  'contact.counterparty': 'Counterparty',
  'contact.deals.title': 'Deals',
  'contact.deals.empty': 'The contact is not on any deal visible to you',
  'participant.title': 'Participants',
  'participant.empty': 'No participants yet — it is not known who the deal is with',
  'participant.role': 'Role',
  'participant.primary': 'primary',
  'participant.remove': 'Remove',
  'participant.add': 'Add participant',
  'participant.contact': 'Contact',
  'participant.chooseContact': 'Choose a counterparty contact',
  'participant.deleted': 'contact deleted',
  'participant.noCounterparty': 'The deal has no counterparty — there is no one to choose participants from',
  'participant.role.decision_maker': 'Decision maker',
  'participant.role.economic_buyer': 'Economic buyer',
  'participant.role.technical': 'Technical',
  'participant.role.user': 'User',
  'participant.role.accountant': 'Accountant',
  'participant.role.other': 'Other',
  'column.job_title': 'Job title',
  'column.mobile_phone': 'Mobile phone',
  'column.telegram': 'Telegram',
  'column.is_primary': 'Primary contact',
  'deal.status.open': 'Open',
  'deal.status.won': 'Won',
  'deal.status.lost': 'Lost',

  'column.legal_name': 'Legal name',
  'column.ogrn': 'OGRN',
  'column.okpo': 'OKPO',
  'column.legal_address': 'Legal address',
  'column.actual_address': 'Actual address',
  'column.website': 'Website',
  'column.payment_terms_days': 'Payment terms, days',
  'column.version': 'Version',
  'card.section.addresses': 'Addresses',
  'card.section.person': 'Private person',
  'card.cp.consent': 'Consent to personal data processing obtained',
  'merge.tab': 'Duplicates',
  'merge.hint': 'Similar cards by INN, phone and email. Merging moves everything into this card and deletes the duplicate.',
  'merge.start': 'Merge here',
  'merge.preview': 'Merge preview',
  'merge.into': '"{duplicate}" will be merged into "{survivor}" and deleted.',
  'merge.blocked': 'Cannot merge while the duplicate has:',
  'merge.moves': 'Will move to this card:',
  'merge.nothingMoves': 'The duplicate has no linked records.',
  'merge.confirm': 'Merge',
  'merge.done': '"{name}" merged into this card',
  'merge.ref.contact.counterparty_id': 'Contacts',
  'merge.ref.counterparty_bank_account.counterparty_id': 'Bank accounts',
  'merge.ref.deal.counterparty_id': 'Deals',
  'merge.ref.quote.counterparty_id': 'Quotes',
  'merge.ref.activity.counterparty_id': 'Activities',
  'merge.ref.lead.converted_counterparty_id': 'Leads',
  'merge.ref.support_ticket.counterparty_id': 'Support tickets',
  'merge.ref.client_access_request.counterparty_id': 'Client access requests',
  'merge.ref.app_user.counterparty_id': 'Client portal accounts',
  'merge.ref.invoice.counterparty_id': 'Invoices',
  'merge.ref.customer_balance.counterparty_id': 'Customer balance',
  'merge.ref.contract.counterparty_id': 'Contracts',
  'merge.ref.recurring_invoice.counterparty_id': 'Recurring invoices',
  'merge.ref.primary_document.counterparty_id': 'Primary documents',
  'merge.ref.payment.counterparty_id': 'Payments',
  'merge.ref.payment_intent.counterparty_id': 'Online payments',
  'merge.ref.bank_payment_order.counterparty_id': 'Payment orders',
  'merge.ref.cash_ledger_entry.counterparty_id': 'Cash entries',
  'merge.ref.sales_order.counterparty_id': 'Sales orders',
  'merge.ref.shipment.counterparty_id': 'Shipments',
  'merge.ref.goods_return.counterparty_id': 'Returns',
  'merge.ref.purchase_order.supplier_id': 'Purchase orders',
  'merge.ref.goods_receipt.supplier_id': 'Goods receipts',
  'merge.ref.product_batch.supplier_counterparty_id': 'Product batches',
  'merge.ref.serial_number.shipped_to_counterparty_id': 'Shipped serial numbers',
  'merge.ref.stock.owner_counterparty_id': 'Goods in custody',
  'merge.ref.storage_zone.owner_counterparty_id': 'Storage zones',
  'merge.ref.cost_layer.owner_counterparty_id': 'Cost layers',
  'merge.ref.custody_tariff.owner_counterparty_id': 'Custody tariffs',
  'merge.ref.custody_daily_snapshot.owner_counterparty_id': 'Custody snapshots',
  'merge.ref.custody_billing_record.owner_counterparty_id': 'Custody charges',
  'merge.ref.activity.entity_id': 'Timeline entries',
  'merge.ref.entity_comment.entity_id': 'Comments',
  'merge.ref.attachment.entity_id': 'Attachments',
  'merge.ref.notification.entity_id': 'Notifications',
  'merge.ref.onec_link.local_id': '1C link',
  'deal.create': 'New deal',
  'deal.create.title': 'New deal',
  'deal.create.submit': 'Create',
  'deal.close.lost': 'Deal lost',
  'deal.close.won': 'Deal won',
  'deal.close.reason': 'Reason',
  'deal.close.choose': '— choose a reason —',
  'deal.close.noReason': '— no reason —',
  'deal.close.note': 'Comment',
  'deal.close.confirm': 'Close the deal',
  'deal.line.add': 'Add a line',
  'deal.line.remove': 'Remove',
  'deal.line.priceFromList': 'from the price list',
  'deal.actions.stage': 'Stage',
  'deal.delete': 'Delete the deal',
  'deal.delete.confirm': 'Delete the deal for good?',
  'card.tab.dealActions': 'Actions',
  'picker.search': 'Start typing a name',
  'picker.nothing': 'nothing found',
  'picker.results': 'Found records',
  'picker.clear': 'Clear the choice',
  'nav.adminDealReasons': 'Deal close reasons',
  'nav.adminFunnels': 'Funnels and stages',
  'nav.adminLeadRules': 'Lead distribution',
  'nav.adminAudit': 'Audit log',
  'nav.adminTags': 'Tags',
  'nav.adminCustomFields': 'Custom fields',
  'admin.dealReason.hint': 'The loss reason is chosen when a deal is closed and feeds the loss report. Kind and code are fixed; reasons are retired, not deleted.',
  'admin.dealReason.add': 'Add a reason',
  'admin.dealReason.form': 'Close reason',
  'admin.dealReason.kind': 'Kind',
  'admin.dealReason.kind.lost': 'Loss',
  'admin.dealReason.kind.won': 'Win',
  'admin.dealReason.code': 'Code',
  'admin.dealReason.name': 'Name',
  'admin.dealReason.sortOrder': 'Order',
  'admin.dealReason.active': 'Active',
  'admin.funnel.hint': 'Funnel stages are the columns of the deal board. Changes reach managers at once, without a release. Open stages are reordered by dragging or arrows; closing stages always stay last. A stage that holds deals or that deals have passed through cannot be removed — rename it instead.',
  'admin.funnel.choose': 'Funnel',
  'admin.funnel.add': 'Add funnel',
  'admin.funnel.form': 'New funnel',
  'admin.funnel.props': 'Funnel properties',
  'admin.funnel.code': 'Code',
  'admin.funnel.name': 'Name',
  'admin.funnel.default': 'default',
  'admin.funnel.active': 'Active',
  'admin.funnel.inactive': 'inactive',
  'admin.funnel.stages': 'Funnel stages',
  'admin.funnel.createHint': 'A funnel starts with the stages “New”, “Won” and “Lost”; add the rest afterwards.',
  'admin.stage.name': 'Stage',
  'admin.stage.code': 'Code',
  'admin.stage.type': 'Type',
  'admin.stage.type.open': 'open',
  'admin.stage.type.won': 'won',
  'admin.stage.type.lost': 'lost',
  'admin.stage.probability': 'Probability, %',
  'admin.stage.sla': 'Days in stage',
  'admin.stage.noSla': 'no limit',
  'admin.stage.color': 'Colour',
  'admin.stage.openDeals': 'Open deals',
  'admin.stage.up': 'Up',
  'admin.stage.down': 'Down',
  'admin.stage.remove': 'Remove',
  'admin.stage.hasDeals': 'The stage holds deals and cannot be removed',
  'admin.stage.add': 'Add stage',
  'admin.stage.form': 'Stage',
  'admin.stage.addForm': 'New stage',
  'admin.stage.position': 'Place',
  'admin.stage.first': 'First',
  'admin.stage.after': 'After “{name}”',
  'admin.rule.hint': 'Rules apply in ascending priority; the first that matches assigns the lead. A rule without conditions takes every lead. Round-robin follows the listed order.',
  'admin.rule.add': 'Add rule',
  'admin.rule.form': 'Distribution rule',
  'admin.rule.name': 'Name',
  'admin.rule.strategy': 'Strategy',
  'admin.rule.strategy.round_robin': 'Round-robin',
  'admin.rule.strategy.by_load': 'By load',
  'admin.rule.strategy.by_region': 'By territory',
  'admin.rule.strategy.manual': 'Manual',
  'admin.rule.priority': 'Priority',
  'admin.rule.conditions': 'Conditions',
  'admin.rule.anyLead': 'any lead',
  'admin.rule.anySource': 'any',
  'admin.rule.field.source': 'Source',
  'admin.rule.field.utmSource': 'utm_source',
  'admin.rule.field.utmCampaign': 'utm_campaign',
  'admin.rule.field.companyName': 'Company',
  'admin.rule.department': 'Department',
  'admin.rule.employees': 'Employees',
  'admin.rule.removeEmployee': 'Remove',
  'admin.rule.active': 'Active',
  'admin.rule.delete': 'Delete',
  'history.empty': 'No changes recorded',
  'history.more': 'Show more',
  'history.table': 'Change history',
  'history.when': 'When',
  'history.who': 'Who',
  'history.entity': 'Record',
  'history.action': 'Action',
  'history.changes': 'What changed',
  'history.system': 'system',
  'history.hidden': 'hidden — no right to this field',
  'history.action.INSERT': 'created',
  'history.action.UPDATE': 'changed',
  'history.action.DELETE': 'deleted',
  'history.action.PERMISSIONS': 'role rights',
  'audit.hint': 'Every change in the system: who, when, what it was and what it became. Fields without a field grant are hidden here too.',
  'audit.filters': 'Journal filters',
  'audit.actor': 'User',
  'audit.entityType': 'Entity',
  'audit.action': 'Action',
  'audit.from': 'From',
  'audit.to': 'To',
  'audit.any': 'any',
  'audit.apply': 'Show',
  'audit.reset': 'Reset',
  'audit.empty': 'No changes match these filters',
  'tags.input': 'Tag',
  'tags.add': 'Add tag',
  'tags.remove': 'Remove tag',
  'tags.added': 'Tag “{tag}” added: {affected} of {requested}',
  'tags.removed': 'Tag “{tag}” removed: {affected} of {requested}',
  'segments.title': 'Segments',
  'segments.apply': 'Show segment',
  'segments.delete': 'Delete segment',
  'segments.form': 'New segment',
  'segments.name': 'Segment name',
  'segments.shared': 'Shared',
  'segments.save': 'Save',
  'segments.saveCurrent': 'Save filter as a segment',
  'segments.saveAll': 'Save an “all records” segment',
  'history.action.TAGS': 'tags',
  'admin.tags.hint': 'Managers create tags right in the list. Here they are renamed, recoloured and deleted: a deleted tag leaves every record and changes every segment built on it.',
  'admin.tags.name': 'Tag',
  'admin.tags.color': 'Colour',
  'admin.tags.delete': 'Delete',
  'card.tab.customFields': 'Extra fields',
  'customFields.none': 'This entity has no extra fields',
  'customFields.form': 'Extra fields',
  'customFields.save': 'Save fields',
  'customFields.saved': 'Fields saved',
  'customFields.hint': 'A field appears on cards, in list columns and filters at once, without a release. The code is the database key and the column name and does not change; fields are hidden, not deleted — values stay.',
  'customFields.entity': 'Entity',
  'customFields.add': 'Add field',
  'customFields.declare': 'New field',
  'customFields.label': 'Label',
  'customFields.code': 'Code',
  'customFields.type': 'Type',
  'customFields.type.string': 'text',
  'customFields.type.number': 'number',
  'customFields.type.date': 'date',
  'customFields.type.boolean': 'yes/no',
  'customFields.type.enum': 'choice list',
  'customFields.type.reference': 'reference',
  'customFields.type.file': 'file',
  'customFields.options': 'Options (one per line)',
  'customFields.required': 'Required',
  'customFields.order': 'Order',
  'customFields.hide': 'Hide',
  'deal.create.responsibleMe': 'empty means you',
  'picker.failed': 'search unavailable',
  'column.source': 'Source',
  'column.rejection_reason': 'Rejection reason',
  'column.contact_name': 'Contact name',
  'column.company_name': 'Company',
  'column.first_response_due_at': 'Respond by',
  'column.first_response_at': 'First response',
  'column.utm_campaign': 'UTM campaign',
  'column.converted_at': 'Converted at',
  'column.converted_deal_id': 'Deal',
  'card.section.leadSla': 'Owner and deadlines',
  'card.section.leadChannel': 'Acquisition channel',
  'card.tab.leadActions': 'Actions',
  'lead.status.new': 'New',
  'lead.status.in_progress': 'In progress',
  'lead.status.qualified': 'Qualified',
  'lead.status.converted': 'Converted',
  'lead.status.rejected': 'Rejected',
  'lead.source.call': 'Call',
  'lead.source.email': 'Email',
  'lead.source.website': 'Website',
  'lead.source.telegram': 'Telegram',
  'lead.source.referral': 'Referral',
  'lead.source.exhibition': 'Exhibition',
  'lead.source.other': 'Other',
  'lead.actions.status': 'Status',
  'lead.actions.convert': 'Convert to a deal',
  'lead.actions.qualify': 'Qualify',
  'lead.actions.reject': 'Reject',
  'lead.actions.rejectReason': 'Rejection reason',
  'lead.actions.rejectConfirm': 'Reject the lead',
  'lead.actions.openDeal': 'Open the deal',
  'lead.actions.rejectedBecause': 'Rejected: {reason}',
  'lead.create.title': 'New lead',
  'lead.create.submit': 'Create',
  'lead.create.needContact': 'a phone, email or INN is needed',
  'nav.adminUsers': 'Users',
  'nav.adminRoles': 'Roles and rights',
  'admin.users.hint': 'Accounts, their employees and roles. Rights apply from the user’s next request. No password here — sign-in goes through Keycloak.',
  'admin.users.search': 'Search by login, name, email',
  'admin.users.add': 'Add a user',
  'admin.users.form': 'New user',
  'admin.users.username': 'Login',
  'admin.users.fullName': 'Full name',
  'admin.users.email': 'Email',
  'admin.users.employee': 'Employee',
  'admin.users.noEmployee': 'not linked — their "own" records are empty',
  'admin.users.roles': 'Roles',
  'admin.users.state': 'State',
  'admin.users.notLinked': '(never signed in)',
  'admin.users.expired': 'expired',
  'admin.users.until': 'until {date}',
  'admin.users.until.label': 'Until',
  'admin.users.revoke': 'Revoke role',
  'admin.users.assign': 'Grant',
  'admin.users.chooseRole': '— role —',
  'admin.users.active': 'Active',
  'admin.users.blocked': 'Blocked',
  'admin.users.block': 'Block',
  'admin.users.unblock': 'Unblock',
  'admin.roles.hint': 'Roles inherit their ancestors’ rights. Inherited rights are removed only at the ancestor. Superadmin rights are locked.',
  'admin.roles.add': 'Add a role',
  'admin.roles.form': 'New role',
  'admin.roles.code': 'Code',
  'admin.roles.name': 'Name',
  'admin.roles.parent': 'Inherits from',
  'admin.roles.noParent': '— no parent —',
  'admin.roles.holders': 'Holders',
  'admin.roles.system': 'built-in',
  'admin.roles.matrix': 'Rights',
  'admin.roles.delete': 'Delete',
  'admin.roles.matrixOf': 'Rights of «{role}»',
  'admin.roles.readOnly': 'Read only',
  'admin.roles.superadminLocked': 'Superadmin rights are locked: nobody could give a removed right back.',
  'admin.roles.saved': 'Rights saved',
  'admin.roles.resource': 'Resource',
  'admin.roles.action': 'Action',
  'admin.roles.field': 'Field',
  'admin.roles.scope': 'Scope',
  'admin.roles.inherited': 'Inherited',
  'admin.scope.own': 'own',
  'admin.scope.department': 'department',
  'admin.scope.all': 'all',
  'admin.users.unbind': 'Unbind',

  // List column labels that were missing (ListCatalog).
  'column.approved_at': 'Approved at',
  'column.approved_by': 'Approved by',
  'column.assignee_employee_id': 'Assignee',
  'column.batch_id': 'Batch',
  'column.cancel_reason': 'Cancellation reason',
  'column.cancelled_at': 'Cancelled at',
  'column.carrier': 'Carrier',
  'column.cell_id': 'Cell',
  'column.completed_at': 'Completed at',
  'column.contract_id': 'Contract',
  'column.contract_type': 'Contract type',
  'column.converted_counterparty_id': 'Converted counterparty',
  'column.deal_id': 'Deal',
  'column.delivered_at': 'Delivered at',
  'column.delivery_address': 'Delivery address',
  'column.discount_total': 'Discount',
  'column.dispatched_at': 'Dispatched at',
  'column.document_date': 'Document date',
  'column.document_kind': 'Document type',
  'column.edi_sent_at': 'Sent via EDI',
  'column.edi_status': 'EDI status',
  'column.from_warehouse_id': 'Source warehouse',
  'column.gross_weight_kg': 'Gross weight, kg',
  'column.handed_over_at': 'Handed to carrier',
  'column.handling_unit_id': 'Handling unit',
  'column.invoice_id': 'Invoice',
  'column.is_blind': 'Blind count',
  'column.is_cross_dock': 'Cross-dock',
  'column.method': 'Payment method',
  'column.net_weight_kg': 'Net weight, kg',
  'column.order_id': 'Order',
  'column.owner_counterparty_id': 'Goods owner',
  'column.packages_count': 'Packages',
  'column.paid_at': 'Paid at',
  'column.paid_total': 'Paid',
  'column.pick_mode': 'Picking mode',
  'column.posted_at': 'Posted at',
  'column.primary_document_id': 'Primary document',
  'column.purchase_order_id': 'Purchase order',
  'column.purpose': 'Payment purpose',
  'column.received_at': 'Received at',
  'column.received_by': 'Received by',
  'column.reserved_quantity': 'Reserved',
  'column.scope': 'Scope',
  'column.sent_at': 'Sent at',
  'column.shipment_id': 'Shipment',
  'column.shipped_at': 'Shipped at',
  'column.signed_at': 'Signed at',
  'column.signed_on': 'Signed on',
  'column.started_at': 'Started at',
  'column.subtotal': 'Subtotal',
  'column.supplier_document_number': 'Supplier document no.',
  'column.to_warehouse_id': 'Destination warehouse',
  'column.total': 'Total',
  'column.tracking_number': 'Tracking number',
  'column.unit_cost': 'Unit cost',
  'column.updated_at': 'Updated at',
  'column.valid_from': 'Valid from',
  'column.valid_until': 'Valid until',
  'column.vat_total': 'VAT',
  'column.volume_m3': 'Volume, m³',
  'column.zone_id': 'Zone',

  // Enum values: value.<catalog entity>.<column>.<code>.
  'value.sales.counterparty.kind.legal': 'Legal entity',
  'value.sales.counterparty.kind.individual': 'Individual',
  'value.sales.counterparty.kind.sole_trader': 'Sole trader',
  'value.sales.counterparty.relation.client': 'Client',
  'value.sales.counterparty.relation.supplier': 'Supplier',
  'value.sales.counterparty.relation.both': 'Client and supplier',
  'value.sales.counterparty.relation.competitor': 'Competitor',
  'value.sales.counterparty.relation.partner': 'Partner',
  'value.sales.deal.status.open': 'Open',
  'value.sales.deal.status.won': 'Won',
  'value.sales.deal.status.lost': 'Lost',
  'value.sales.product.product_type.goods': 'Goods',
  'value.sales.product.product_type.service': 'Service',
  'value.sales.product.product_type.kit': 'Kit',
  'value.sales.product.product_type.weight_goods': 'Goods by weight',
  'value.sales.lead.status.new': 'New',
  'value.sales.lead.status.in_progress': 'In progress',
  'value.sales.lead.status.qualified': 'Qualified',
  'value.sales.lead.status.converted': 'Converted',
  'value.sales.lead.status.rejected': 'Rejected',
  'value.sales.lead.source.website': 'Website',
  'value.sales.lead.source.call': 'Call',
  'value.sales.lead.source.email': 'Email',
  'value.sales.lead.source.telegram': 'Telegram',
  'value.sales.lead.source.referral': 'Referral',
  'value.sales.lead.source.exhibition': 'Exhibition',
  'value.sales.lead.source.other': 'Other',
  'value.sales.quote.status.draft': 'Draft',
  'value.sales.quote.status.sent': 'Sent',
  'value.sales.quote.status.accepted': 'Accepted',
  'value.sales.quote.status.rejected': 'Rejected',
  'value.sales.quote.status.expired': 'Expired',
  'value.billing.invoice.status.draft': 'Draft',
  'value.billing.invoice.status.sent': 'Sent',
  'value.billing.invoice.status.partially_paid': 'Partially paid',
  'value.billing.invoice.status.paid': 'Paid',
  'value.billing.invoice.status.overdue': 'Overdue',
  'value.billing.invoice.status.cancelled': 'Cancelled',
  'value.billing.document.document_kind.act': 'Act',
  'value.billing.document.document_kind.upd': 'UTD',
  'value.billing.document.document_kind.torg12': 'TORG-12',
  'value.billing.document.document_kind.invoice_factura': 'VAT invoice',
  'value.billing.document.status.draft': 'Draft',
  'value.billing.document.status.issued': 'Issued',
  'value.billing.document.status.signed': 'Signed',
  'value.billing.document.status.cancelled': 'Cancelled',
  'value.billing.document.edi_status.sent': 'Sent',
  'value.billing.contract.contract_type.sale': 'Sale',
  'value.billing.contract.contract_type.purchase': 'Purchase',
  'value.billing.contract.contract_type.service': 'Services',
  'value.billing.contract.contract_type.storage': 'Storage',
  'value.billing.contract.contract_type.agency': 'Agency',
  'value.billing.contract.status.draft': 'Draft',
  'value.billing.contract.status.active': 'Active',
  'value.billing.contract.status.expired': 'Expired',
  'value.billing.contract.status.terminated': 'Terminated',
  'value.warehouse.receipt.status.draft': 'Draft',
  'value.warehouse.receipt.status.in_progress': 'In progress',
  'value.warehouse.receipt.status.completed': 'Completed',
  'value.warehouse.receipt.status.cancelled': 'Cancelled',
  'value.warehouse.shipment.status.draft': 'Draft',
  'value.warehouse.shipment.status.packed': 'Packed',
  'value.warehouse.shipment.status.shipped': 'Shipped',
  'value.warehouse.shipment.status.in_transit': 'In transit',
  'value.warehouse.shipment.status.delivered': 'Delivered',
  'value.warehouse.shipment.status.returned': 'Returned',
  'value.warehouse.pick.pick_mode.single': 'Single order',
  'value.warehouse.pick.pick_mode.wave': 'Wave',
  'value.warehouse.pick.status.new': 'New',
  'value.warehouse.pick.status.assigned': 'Assigned',
  'value.warehouse.pick.status.in_progress': 'In progress',
  'value.warehouse.pick.status.completed': 'Completed',
  'value.warehouse.pick.status.cancelled': 'Cancelled',
  'value.warehouse.stocktake.scope.full': 'Whole warehouse',
  'value.warehouse.stocktake.scope.zone': 'Zone',
  'value.warehouse.stocktake.scope.cell': 'Cell',
  'value.warehouse.stocktake.scope.product': 'Product',
  'value.warehouse.stocktake.status.draft': 'Draft',
  'value.warehouse.stocktake.status.in_progress': 'In progress',
  'value.warehouse.stocktake.status.counted': 'Counted',
  'value.warehouse.stocktake.status.approved': 'Approved',
  'value.warehouse.stocktake.status.cancelled': 'Cancelled',
  'value.warehouse.transfer.status.draft': 'Draft',
  'value.warehouse.transfer.status.in_transit': 'In transit',
  'value.warehouse.transfer.status.received': 'Received',
  'value.warehouse.transfer.status.cancelled': 'Cancelled',
  'value.hr.employee.status.active': 'Active',
  'value.hr.employee.status.probation': 'Probation',
  'value.hr.employee.status.on_leave': 'On leave',
  'value.hr.employee.status.terminated': 'Terminated',
  'value.hr.employee.gender.M': 'Male',
  'value.hr.employee.gender.F': 'Female',
  'value.hr.vacancy.status.draft': 'Draft',
  'value.hr.vacancy.status.open': 'Open',
  'value.hr.vacancy.status.on_hold': 'On hold',
  'value.hr.vacancy.status.closed': 'Closed',
  'value.hr.vacancy.status.cancelled': 'Cancelled',
  'value.hr.leave.leave_type.annual': 'Annual leave',
  'value.hr.leave.leave_type.unpaid': 'Unpaid leave',
  'value.hr.leave.leave_type.sick': 'Sick leave',
  'value.hr.leave.leave_type.maternity': 'Parental leave',
  'value.hr.leave.leave_type.study': 'Study leave',
  'value.hr.leave.leave_type.day_off': 'Day off',
  'value.hr.leave.status.draft': 'Draft',
  'value.hr.leave.status.pending': 'Pending approval',
  'value.hr.leave.status.approved': 'Approved',
  'value.hr.leave.status.rejected': 'Rejected',
  'value.hr.leave.status.cancelled': 'Cancelled',
  'value.payments.payment.direction.incoming': 'Incoming',
  'value.payments.payment.direction.outgoing': 'Outgoing',
  'value.payments.payment.method.bank_transfer': 'Bank transfer',
  'value.payments.payment.method.acquiring': 'Card acquiring',
  'value.payments.payment.method.sbp': 'SBP',
  'value.payments.payment.method.cash': 'Cash',
  'value.payments.payment.method.offset': 'Offset',
  'value.payments.payment.method.deposit': 'From deposit',
  'value.payments.payment.status.pending': 'Pending',
  'value.payments.payment.status.confirmed': 'Confirmed',
  'value.payments.payment.status.matched': 'Allocated',
  'value.payments.payment.status.reversed': 'Reversed',
  // board (#board-paging)
  'board.showMore': 'Show more ({count} left)',
  // card (design)
  // lists & kanban (design)
  'quick.label': 'Quick filters',
  'quick.token': 'Quick',
  'nav.support': 'Support tickets',
  'column.subject': 'Subject',
  'column.assigned_user_id': 'Assignee',
  'column.first_answer_at': 'First answer',
  'column.resolved_at': 'Resolved at',
  'column.rating': 'Rating',
  'value.support.ticket.status.open': 'Awaiting answer',
  'value.support.ticket.status.answered': 'Answered',
  'value.support.ticket.status.resolved': 'Resolved',
  'value.support.ticket.status.closed': 'Closed',
  'value.support.ticket.kind.question': 'Question',
  'value.support.ticket.kind.claim': 'Claim',
  'value.support.ticket.kind.request': 'Request',
  'value.support.ticket.source.cabinet': 'From the cabinet',
  'value.support.ticket.source.email': 'From e-mail',
  'value.support.ticket.source.manual': 'Entered by a manager',
  'value.support.ticket.source.messenger': 'From a messenger',
  'quick.ticketWaiting': 'Awaiting answer',
  'quick.ticketUnassigned': 'Unassigned',
  'quick.slaBreached': 'Answer overdue',
  'notifications.kind.ticket': 'Client tickets',
  'notifications.kind.message': 'Client messages in messengers',
  'inbox.toTicket': 'Open a ticket',
  'support.sections': 'Ticket sections',
  'support.conversation': 'Conversation and notes',
  'support.tab.conversation': 'Conversation',
  'support.entry.client': 'Client',
  'support.entry.manager': 'Answer to the client',
  'support.entry.note': 'Note — staff only',
  'support.reply.title': 'Reply',
  'support.reply.mode': 'What to write',
  'support.reply.answer': 'Answer to the client',
  'support.reply.note': 'Internal note',
  'support.reply.answerHint': 'The client sees this in the app and is notified',
  'support.reply.noteHint': 'The client will not see the note',
  'support.reply.send': 'Send to the client',
  'support.reply.saveNote': 'Save the note',
  'support.reply.closed': 'The ticket is not open: reopen it to answer',
  'support.action.resolved': 'Resolve',
  'support.action.closed': 'Close',
  'support.action.open': 'Reopen',
  'support.fact.client': 'Client',
  'support.fact.sla': 'Answer by',
  'support.sla.breached': 'Answer overdue',
  'support.sla.waiting': 'No answer yet',
  'support.sla.met': 'Answered in time',
  'support.sla.late': 'Answered late',
  'support.unassigned': 'Unassigned',
  'support.assign.label': 'Who handles the ticket',
  'support.rating': 'Client\'s rating',
  // AI triage of tickets (#132)
  'column.urgent': 'Urgent',
  'column.triage_category': 'Category',
  'column.triage_tone': 'Tone',
  'column.triage_urgency': 'Urgency (text)',
  'value.support.ticket.triage_category.question': 'Question',
  'value.support.ticket.triage_category.claim': 'Claim',
  'value.support.ticket.triage_category.request': 'Request',
  'value.support.ticket.triage_category.return': 'Return',
  'value.support.ticket.triage_category.technical': 'Technical issue',
  'value.support.ticket.triage_category.billing': 'Billing',
  'value.support.ticket.triage_category.other': 'Other',
  'value.support.ticket.triage_tone.neutral': 'Neutral',
  'value.support.ticket.triage_tone.dissatisfied': 'Dissatisfied',
  'value.support.ticket.triage_tone.harsh': 'Harsh',
  'value.support.ticket.triage_urgency.normal': 'Normal',
  'value.support.ticket.triage_urgency.urgent': 'Urgent',
  'quick.ticketUrgent': 'Urgent',
  'quick.ticketClaims': 'Claims',
  'support.urgent': 'Urgent',
  'support.urgent.set': 'Mark urgent',
  'support.urgent.clear': 'Clear the urgent mark',
  'support.triage.title': 'AI triage',
  'support.triage.category': 'Category',
  'support.triage.tone': 'Tone',
  'support.triage.urgency': 'Urgency (text)',
  'support.triage.reason': 'Why',
  'support.triage.rule': 'Rule applied',
  'support.triage.kindMismatch': 'The client filed «{kind}», the text reads as «{category}»',
  'support.triage.pending': 'Not triaged yet: triage runs after the ticket is accepted, usually within a minute.',
  'support.triage.unavailable': 'Not triaged: {message}. The ticket goes the usual way.',
  'support.triage.failed': 'Not triaged: the AI provider did not answer ({message}). Will retry automatically.',
  'support.triage.rejected': 'Not triaged: the model answered outside the dictionary ({message}). No category is guessed.',
  'support.triage.no_text': 'Not triaged: the ticket has no text from the client.',
  'support.triage.stale': 'The client\'s latest message is not triaged ({message}); showing the triage of the earlier text.',
  'nav.supportInsights': 'Ticket summary',
  'nav.adminSupportRouting': 'Ticket routing',
  'insights.title': 'Ticket summary',
  'insights.intro': 'Themes are the AI triage categories; a spike is a category with at least {min} tickets and {ratio} times as many as in the previous period of the same length. Only tickets visible to you are counted.',
  'insights.from': 'From',
  'insights.to': 'To',
  'insights.apply': 'Show',
  'insights.total': 'Tickets in the period',
  'insights.previous': 'Previous period ({from} — {to})',
  'insights.unread': 'Not triaged by AI',
  'insights.urgentCount': 'Marked urgent',
  'insights.tones': 'Tone',
  'insights.themes': 'Themes',
  'insights.col.category': 'Category',
  'insights.col.count': 'Tickets',
  'insights.col.previous': 'Before',
  'insights.col.share': 'Share',
  'insights.col.harsh': 'Harsh',
  'insights.col.urgent': 'Urgent',
  'insights.spike': 'Spike',
  'insights.spikes': 'Spikes: {list}',
  'insights.noSpikes': 'No spikes',
  'insights.empty': 'No tickets in the period',
  'routing.title': 'Ticket routing',
  'routing.intro': 'A rule fires after the AI has triaged a ticket: the first matching one by priority. A ticket not triaged (AI off) matches no rule and stays with the client\'s manager. A rule does not reassign a ticket assigned by a person or already answered — it only marks it urgent.',
  'routing.empty': 'No rules — tickets go to the client\'s manager',
  'routing.add': 'Add a rule',
  'routing.edit': 'Edit',
  'routing.delete': 'Delete',
  'routing.save': 'Save',
  'routing.cancel': 'Cancel',
  'routing.name': 'Name',
  'routing.priority': 'Priority (lower runs first)',
  'routing.active': 'Enabled',
  'routing.inactive': 'Disabled',
  'routing.categories': 'Categories',
  'routing.tones': 'Tone',
  'routing.urgencies': 'Urgency (text)',
  'routing.any': 'any',
  'routing.assign': 'To whom',
  'routing.mode.user': 'An employee',
  'routing.mode.department_head': 'Head of the assignee\'s department',
  'routing.mode.keep': 'Keep the assignee',
  'routing.user': 'Employee',
  'routing.markUrgent': 'Mark urgent',
  'routing.conditions': 'Conditions',
  'routing.actions': 'Action',
  'quick.mine': 'Mine',
  'quick.open': 'Open',
  'quick.overdue': 'Overdue',
  'quick.newLeads': 'New',
  'quick.unpaid': 'Unpaid',
  'quick.reserved': 'Reserved',
  'quick.zeroStock': 'Zero stock',
  'list.toolbar': 'List tools',
  'list.count': '{count} records',
  'list.rows': '{count} rows',
  'list.searchIn': 'Search: {column}',
  'list.groupByValue': 'Grouped by: {column}',
  'list.moreActions': 'More: export, import, segments',
  'list.importMenu': 'Import from CSV…',
  'list.segmentsMenu': 'Segments…',
  'list.closePanel': 'Close panel',
  'list.retry': 'Retry',
  'list.groupEmpty': 'Not set',
  'list.groupExpand': 'Expand group {group}',
  'list.groupCollapse': 'Collapse group {group}',
  'list.groupCount': '{count} items',
  'list.groupsCapped': 'Showing the first {shown} groups — narrow the filter to see the rest',
  'list.state.forbidden': 'The “{section}” section is not available to you',
  'list.state.error': 'The list did not load',
  'list.state.errorHint': 'The server did not respond. Do not rely on stale figures — retry the request.',
  'list.state.noMatch': 'Nothing matches the conditions',
  'list.state.noMatchHint': 'Conditions are applied by the server to the whole list, not to a page. Remove some or reset them all.',
  'list.state.empty': 'No records yet',
  'list.state.emptyHint': 'Records will appear here once they are created or imported.',
  'state.kind.empty': 'No data',
  'state.kind.forbidden': 'No access',
  'state.kind.setup': 'Not configured',
  'state.kind.error': 'Error',
  'record.crumbs': 'Breadcrumbs',
  'record.more': 'More actions',
  'record.tabs': 'Record sections',
  'record.facts': 'Key facts',
  'record.notSet': '— not set',
  'record.irreversible': 'This cannot be undone.',
  'record.copyLink': 'Copy link',
  'record.copyFailed': 'Could not copy: the browser denied clipboard access',
  'record.copyNumber': 'Copy number {number}',
  'record.tab.overview': 'Overview',
  'record.tab.positions': 'Items',
  'record.tab.documents': 'Documents',
  'record.tab.history': 'History',
  'record.history.changes': 'Change log',
  'record.next.title': 'Next step',
  'record.next.missing': 'No next step assigned',
  'record.next.overdue': 'Overdue',
  'record.next.done': 'Done',
  'record.next.assign': 'Assign a step',
  'record.next.noDue': 'no due date',
  'record.feed.title': 'Activity',
  'record.feed.filter': 'Activity filter',
  'record.feed.filter.all': 'All',
  'record.feed.filter.touches': 'Calls and emails',
  'record.feed.filter.comments': 'Comments',
  'record.feed.filter.changes': 'Changes',
  'record.feed.noneByFilter': 'No events of this kind — choose “All”.',
  'record.feed.today': 'Today',
  'record.feed.yesterday': 'Yesterday, {date}',
  'record.feed.stage': 'Stage: {from} → {to}',
  'record.composer.kind': 'Entry type',
  'record.composer.add': 'Add',
  'record.composer.hint': 'Ctrl ↵ to add',
  'record.composer.failed': 'Not saved: the server did not respond. Your text is still in the field.',
  'record.composer.due': 'Due',
  'record.composer.duration': 'Duration, min',
  'record.composer.comment': 'Comment on the deal',
  'record.composer.call': 'What was discussed',
  'record.composer.task': 'What to do next',
  'record.stage.overLimit': '{days} d — limit {limit} exceeded',
  'record.stage.withinLimit': '{days} of {limit} d',
  'record.state.forbidden.title': 'This record is not available to you',
  'record.state.forbidden.text': 'The record exists, but your role cannot see it. Access is granted by a manager or an administrator.',
  'record.state.error.title': 'Could not open the record',
  'record.state.error.text': 'The server returned an error while loading. Nothing was changed — you can retry.',
  'record.state.retry': 'Retry',
  'record.state.toList': 'Back to list',
  'record.deal.sections': 'Deal sections',
  'record.deal.stages': 'Deal stages',
  'record.deal.noClient': 'No customer',
  'record.deal.nextStage': 'Move to “{stage}”',
  'record.deal.closeLost': 'Close as lost…',
  'record.deal.delete': 'Delete deal',
  'record.deal.delete.title': 'Delete deal “{title}”?',
  'record.deal.delete.text': 'The deal disappears from lists, the board and reports. The server refuses to delete a deal that already has documents.',
  'record.deal.fact.amount': 'Amount',
  'record.deal.fact.positions': 'items: {count}',
  'record.deal.fact.probability': 'Probability',
  'record.deal.fact.weighted': 'weighted {amount}',
  'record.deal.fact.closeOn': 'Expected close',
  'record.deal.fact.responsible': 'Owner',
  'record.deal.closedOn': 'closed {date}',
  'record.deal.overdueBy': 'Overdue by {days} d',
  'record.deal.dueToday': 'today',
  'record.deal.dueIn': 'in {days} d',
  'record.deal.next.missingHint': 'Without a task the deal will not show up in the owner’s “My day”, and nobody will remember it in time.',
  'record.deal.next.error': 'Could not load the deal’s tasks',
  'record.deal.feed.error': 'Could not load the deal’s activity',
  'record.deal.feed.empty.title': 'No events yet',
  'record.deal.feed.empty.text': 'Add a call, a task or a comment — it will appear here.',
  'record.deal.details': 'Details',
  'record.deal.positions': 'Items',
  'record.deal.positions.empty': 'No items. Add products on the “Items” tab — the deal amount is calculated from them.',
  'record.deal.allPositions': 'All items',
  'record.deal.quotes': 'Quotes',
  'record.deal.quotes.empty': 'No quotes have been issued for this deal.',
  'record.deal.quotes.error': 'Could not load the deal’s quotes',
  // myday & dashboard (design)
  'nav.myDay': 'My day',
  'state.forbidden.title': 'This block is not available to you',
  'state.forbidden.text': 'You have no right to its data. If you need it for your work, an administrator grants it.',
  'state.error.text': 'The server did not respond. The other blocks are up to date.',
  'state.retry': 'Retry',
  'myday.newLead': 'New lead',
  'myday.allTasks': 'All tasks',
  'myday.noCard.title': 'This account has no employee record',
  'myday.noCard.text': 'Tasks, deals and clients are assigned to an employee. Until the account is linked to one, nothing is "mine" — which does not mean everything is done.',
  'myday.facts': 'Day summary',
  'myday.fact.overdueTasks': 'overdue tasks',
  'myday.fact.todayTasks': 'tasks for today',
  'myday.fact.todayTasksNext': 'tasks for today, next at {time}',
  'myday.fact.deals': 'deals need attention',
  'myday.fact.overdueInvoices': 'overdue across invoices: {count}',
  'myday.tasks': 'Tasks',
  'myday.period': 'Period',
  'myday.period.today': 'Today',
  'myday.period.week': 'Week',
  'myday.tasks.error': 'Tasks failed to load',
  'myday.tasks.emptyToday': 'No tasks for today',
  'myday.tasks.emptyWeek': 'No tasks this week',
  'myday.tasks.emptyText': 'Nothing is overdue either. All tasks, including future ones, are on the "My tasks" screen.',
  'myday.tasks.overdue': 'Overdue · {count}',
  'myday.tasks.today': 'Today · {count}',
  'myday.tasks.week': 'Next 7 days and undated · {count}',
  'myday.tasks.complete': 'Mark as done: {subject}',
  'myday.overdueBy': 'overdue by {days} d',
  'myday.noDue': 'no due date',
  'myday.today': 'today',
  'myday.tomorrow': 'tomorrow',
  'myday.entity.deal': 'Deal',
  'myday.entity.lead': 'Lead',
  'myday.entity.counterparty': 'Counterparty',
  'myday.entity.contact': 'Contact',
  'myday.entity.invoice': 'Invoice',
  'myday.deals': 'Deals that need attention',
  'myday.allDeals': 'All my deals',
  'myday.deals.error': 'Deals failed to load',
  'myday.deals.empty': 'All deals are in order',
  'myday.deals.emptyText': 'Every open deal has a next step, and none has overstayed its stage limit.',
  'myday.deals.deal': 'Deal',
  'myday.deals.client': 'Client',
  'myday.deals.stage': 'Stage',
  'myday.deals.amount': 'Amount',
  'myday.deals.issue': 'What is wrong',
  'myday.deals.open': 'Open',
  'myday.deals.assignStep': 'Plan a step',
  'myday.deals.more': 'Showing {shown} of {total} — the rest are in the deal list',
  'myday.deals.stuck': 'Stuck {days} d, limit {limit}',
  'myday.deals.stuckNoLimit': 'Stuck: {days} d in stage',
  'myday.deals.noStep': 'No next step · never contacted',
  'myday.deals.noStepTouched': 'No next step · last contact {days} d ago',
  'myday.meetings': 'Meetings',
  'myday.meetings.error': 'Meetings failed to load',
  'myday.meetings.empty': 'No meetings in the coming week.',
  'myday.leads': 'New leads',
  'myday.allLeads': 'All leads',
  'myday.leads.error': 'Leads failed to load',
  'myday.leads.empty': 'No new leads assigned to you.',
  'myday.leads.open': 'Open',
  'myday.invoices': 'My clients\' invoices',
  'myday.allInvoices': 'All invoices',
  'myday.invoices.error': 'Invoices failed to load',
  'myday.invoices.empty': 'Your clients have no unpaid invoices.',
  'myday.invoices.overdue': 'Overdue · {amount}',
  'myday.invoices.awaiting': 'Awaiting payment · {count}',
  'myday.invoices.rest': '{amount} outstanding',
  'myday.invoices.dueOn': 'due {date}',
  'myday.ago.minutes': '{count} min ago',
  'myday.ago.hours': '{count} h ago',
  'myday.ago.days': '{count} d ago',
  'dash.leader': 'Executive summary',
  'dash.fresh': 'Data as of {time}',
  'dash.saved': 'My dashboards',
  'dash.forbidden.title': 'The executive summary is not available to you',
  'dash.forbidden.text': 'It shows approvals, the pipeline and receivables, and you have no rights to any of these sources. Your own report dashboards are below.',
  'dash.approvals': 'Awaiting your decision',
  'dash.approvals.all': 'All approvals',
  'dash.approvals.error': 'Approvals failed to load',
  'dash.approvals.empty': 'Nothing is awaiting your approval.',
  'dash.approvals.waits': 'waiting {time}',
  'dash.approvals.step': 'Step {step} of {total}',
  'dash.approvals.reject': 'Reject…',
  'dash.plan': 'Plan vs actual',
  'dash.plan.setupTitle': 'There is no company plan in the system',
  'dash.plan.setupText': 'Targets are set in KPI for employees and departments — there is no company-wide plan to compare the actuals with. We will not draw a scale against an invented plan.',
  'dash.plan.toKpi': 'Open KPI',
  'dash.funnel': 'Pipeline — open deals',
  'dash.funnel.error': 'The pipeline failed to load',
  'dash.funnel.noFunnel': 'No pipeline set up',
  'dash.funnel.noFunnelText': 'There is no active sales pipeline — it is set up in administration.',
  'dash.funnel.empty': 'No open deals',
  'dash.funnel.emptyText': 'There are no open deals within your visibility scope.',
  'dash.funnel.conversion': '{percent}% move on this month',
  'dash.funnel.noConversion': 'nobody passed this stage this month',
  'dash.ar': 'Receivables ageing',
  'dash.ar.total': '{amount} in total',
  'dash.ar.error': 'The receivables report failed',
  'dash.ar.empty': 'No receivables',
  'dash.ar.emptyText': 'There are no unpaid invoices within your visibility scope.',
  'dash.ar.notYetDue': 'not yet due',
  'dash.ar.bucket0to30': '1–30 d',
  'dash.ar.bucket31to60': '31–60',
  'dash.ar.bucket61to90': '61–90',
  'dash.ar.bucket90plus': '90+ d',
  'dash.ar.otherCurrencies': 'Also in other currencies: {amounts}',
  'dash.ar.top': 'Largest overdue',
  'dash.ar.overdue': 'Overdue',
  'dash.ar.oldest': 'Oldest debt',
  'dash.stuck': 'Stuck deals',
  'dash.stuck.board': 'All on the board',
  'dash.stuck.error': 'Stuck deals failed to load',
  'dash.stuck.empty': 'No stuck deals: every deal is within its stage limit.',
  'dash.stuck.emptyPartial': 'No stuck deals among those checked — but the board did not return all of them: check the kanban.',
  'dash.stuck.inStage': 'In stage',
  'dash.stuck.partial': 'The first 200 deals of each stage were checked — there may be more stuck ones; the full list is on the kanban.',
  'dash.hours': '{count} h',
  'dash.days': '{count} d',
  'filter.title': 'Filter',
  'filter.allMustMatch': 'all conditions must match',
  'filter.where': 'Where',
  'filter.and': 'and',
  'filter.clearAll': 'Reset all',
  'filter.applied': 'Conditions',
  'filter.removeToken': 'Remove condition {column}',
  'view.mine': 'Mine',
  'view.sharedGroup': 'Shared',
  'view.empty': 'No saved views',
  'view.defaultMark': 'default',
  'view.modified': 'modified',
  'view.saveCurrent': 'Save as view',
  'pager.loading': 'Loading',
  'pager.start': 'start of list',
  'bulk.label': 'Actions with selected',
  'bulk.deleteAsk': 'Delete…',
  'bulk.confirmTitle': 'Delete the selected records ({count})?',
  'bulk.confirmText': 'The records will disappear from lists and reports. Only those you may delete will be deleted.',
  'column.free_quantity': 'Free',
  'stock.noFree': 'none free',
  'board.label': 'Deal board',
  'board.column': 'Stage {stage}',
  'board.columnCount': 'Deals in column: {count}',
  'board.weightedShort': 'wtd. {amount}',
  'board.weightedHint': 'Weighted amount — each deal × its probability (stage default {probability}%)',
  'board.columnMeta': 'probability {probability}% · limit {limit} d',
  'board.columnProbability': 'probability {probability}%',
  'board.summary': '{count} open · {amount} · weighted {weighted}',
  'board.dropHere': 'Drop — “{stage}”',
  'board.dropZones': 'Close a deal by dragging',
  'board.dropWon': '{stage}',
  'board.dropLost': '{stage} — we will ask why',
  'board.overdue': 'Past due',
  'board.mine': 'My deal',
  'board.mineShort': 'Me',
  'board.refresh': 'Refresh board',
  'board.empty': 'No open deals on the board',
  'board.emptyHint': 'Closed deals are not shown on the board — they are in the table.',
  'board.noFunnelsHint': 'The board needs stages, probabilities and day limits per stage. An administrator sets them up; the deal table works without a funnel.',
  // deal win forecast (#128)
  'board.cardProbability': 'Stage {probability}%',
  'board.forecastShort': 'forecast {amount}',
  'board.forecastHint': 'Each deal amount × the model forecast; the stage-weighted sum is next to it',
  'board.forecastSummary': 'by forecast {weighted}',
  'board.forecastPartial': '{covered} of {count} deals have a forecast',
  'board.forecastColumnPartial': 'forecast for {covered} of {count}',
  'record.deal.fact.forecast': 'Model forecast',
  'nav.forecastModel': 'Deal forecast',
  'forecast.short': 'forecast {probability}',
  'forecast.why': 'Why: {factors}',
  'forecast.whyTitle': 'Why this forecast',
  'forecast.noFactors': 'The deal is close to average — no factor stands out',
  'forecast.factorLine': '{factor} — {effect}',
  'forecast.effect.up': 'raises',
  'forecast.effect.down': 'lowers',
  'forecast.value.none': 'none',
  'forecast.none.pending': 'forecast not computed yet',
  'forecast.none.insufficient': 'no forecast: too few closed deals',
  'forecast.none.untrained': 'no forecast: model not trained',
  'forecast.factor.stage_probability': 'Stage probability: {value}%',
  'forecast.factor.stage_position': 'Stage position in funnel: {value}',
  'forecast.factor.deal_age_days': 'Deal age: {value} d',
  'forecast.factor.days_in_stage': 'In current stage: {value} d',
  'forecast.factor.backward_moves': 'Moves back in the funnel: {value}',
  'forecast.factor.activities_14d': 'Activities in 14 days: {value}',
  'forecast.factor.days_since_activity': 'Days since last activity: {value}',
  'forecast.factor.quote_sent': 'Quote sent: {value}',
  'forecast.factor.from_lead': 'From a lead: {value}',
  'forecast.factor.client_prior_wins': 'Earlier deals won with the client: {value}',
  'forecast.factor.lead_source': 'Lead source: {value}',
  'forecast.feature.stage_probability': 'Stage probability',
  'forecast.feature.stage_position': 'Stage position in funnel',
  'forecast.feature.deal_age_days': 'Deal age (log)',
  'forecast.feature.days_in_stage': 'Days in stage (log)',
  'forecast.feature.backward_moves': 'Moves back in the funnel',
  'forecast.feature.activities_14d': 'Activities in 14 days (log)',
  'forecast.feature.days_since_activity': 'Days since last activity',
  'forecast.feature.quote_sent': 'Quote sent',
  'forecast.feature.from_lead': 'Deal from a lead',
  'forecast.feature.client_prior_wins': 'Earlier client wins (log)',
  'forecast.feature.lead_source': 'Lead source: {value}',
  'forecast.model.lead': 'Logistic regression on the history of closed deals. The forecast is shown on the board and on the deal card next to the static stage probability, not instead of it.',
  'forecast.model.train': 'Retrain',
  'forecast.model.training': 'Training…',
  'forecast.model.forbidden': 'No access to the model report',
  'forecast.model.none.title': 'The model has not been trained yet',
  'forecast.model.none.text': 'No forecasts. The model trains weekly or on demand; it needs at least {min} closed deals with stage history.',
  'forecast.model.insufficient.title': 'Model not trained: too little data',
  'forecast.model.insufficient.text': '{message}. Attempt of {date}. There are no forecasts — not zero, no model.',
  'forecast.model.summary': 'Trained {date}: {train} deals ({trainExamples} snapshots) in training, {holdout} deals ({holdoutExamples} snapshots) held out — closed since {from}. {deals} open deals have a forecast.',
  'forecast.model.quality': 'Quality on the holdout',
  'forecast.model.col.metric': 'Metric',
  'forecast.model.col.model': 'Model',
  'forecast.model.col.baseline': 'Baseline: stage probability',
  'forecast.model.auc': 'AUC',
  'forecast.model.aucHint': 'How well the model ranks: 0.5 is a coin toss, 1 is flawless',
  'forecast.model.logLoss': 'Log-loss',
  'forecast.model.brier': 'Brier',
  'forecast.model.lowerBetter': 'Lower means the numbers themselves are closer',
  'forecast.model.undefined': 'undefined',
  'forecast.model.snapshot': 'Each closed deal gives several snapshots — on entering a stage and weekly while it stays; features use only what was known at the snapshot. The holdout is the latest closed deals, not a random sample. Amount and discount are not in the model: deal lines carry no date, so their value at a snapshot cannot be reconstructed.',
  'forecast.model.calibration': 'Calibration',
  'forecast.model.col.bucket': 'Forecast',
  'forecast.model.col.examples': 'Snapshots',
  'forecast.model.col.predicted': 'Mean forecast',
  'forecast.model.col.actual': 'Actually won',
  'forecast.model.winRates': 'Win rate: training {train}, holdout {holdout}.',
  'forecast.model.coefficients': 'Feature weights',
  'forecast.model.col.feature': 'Feature',
  'forecast.model.col.weight': 'Weight (per standardised feature)',
  'forecast.model.col.direction': 'Effect',
  // company & invoice (design)
  'merge.dialog.title': 'Merge “{duplicate}” into “{survivor}”?',
  'merge.dialog.text': 'Deals, contacts, the feed and draft invoices move to this card, and the duplicate card is deleted.',
  'record.cp.sections': 'Counterparty sections',
  'record.cp.tab.deals': 'Deals',
  'record.cp.tab.finance': 'Finance',
  'record.cp.blocked': 'Blocked',
  'record.cp.copyInn': 'Copy INN {value}',
  'record.cp.copyKpp': 'Copy KPP {value}',
  'record.cp.noResponsible': 'No account manager',
  'record.cp.newDeal': 'New deal',
  'record.cp.duplicates': 'Duplicates and merge',
  'record.cp.close': 'Close',
  'record.cp.delete': 'Delete counterparty',
  'record.cp.delete.title': 'Delete counterparty “{name}”?',
  'record.cp.delete.text': 'The card disappears from lists. A client with open deals, invoices, contracts or payments will not be deleted by the server — block it instead.',
  'record.cp.overdueAlert': 'Overdue {amount}',
  'record.cp.overdueAlertDetails': 'on {count} invoices, the oldest — {days} days.',
  'record.cp.fact.deals': 'Open deals',
  'record.cp.fact.noDeals': 'no open deals',
  'record.cp.fact.debt': 'Debt',
  'record.cp.fact.noDebt': 'none',
  'record.cp.fact.overdue': 'overdue {amount}',
  'record.cp.fact.noOverdue': 'nothing overdue',
  'record.cp.fact.lastContact': 'Last contact',
  'record.cp.fact.noContact': 'no contacts yet',
  'record.cp.fact.terms': 'Payment terms',
  'record.cp.fact.prepayment': 'prepayment',
  'record.cp.fact.deferral': '{days} days deferral',
  'record.cp.fact.limit': 'credit limit {amount}',
  'record.cp.fact.noLimit': 'no credit limit set',
  'record.cp.composer.comment': 'Comment on the client',
  'record.cp.feed.title': 'Recent events',
  'record.cp.feed.error': 'Could not load the client’s feed',
  'record.cp.feed.empty.title': 'No events yet',
  'record.cp.feed.empty.text': 'Calls, tasks and comments about the client will appear here.',
  'record.cp.openDeals': 'Open deals',
  'record.cp.allDeals': 'All client deals',
  'record.cp.deal': 'Deal',
  'record.cp.deals.error': 'Could not load the client’s deals',
  'record.cp.deals.empty.title': 'No open deals',
  'record.cp.deals.empty.text': 'Start with a new deal — it lands on the owner’s board.',
  'record.cp.deals.more': 'The first 50 open deals are shown — the rest are in the deals list.',
  'record.cp.debt': 'Receivables',
  'record.cp.allInvoices': 'All invoices',
  'record.cp.debt.error': 'Could not load receivables',
  'record.cp.debt.none': 'No debt — the client has no unpaid invoices.',
  'record.cp.debt.bar': 'Debt: not yet due {current}, overdue {overdue}',
  'record.cp.debt.current': 'not yet due {amount}',
  'record.cp.debt.overdue': 'overdue {amount}',
  'record.cp.invoice': 'Invoice',
  'record.cp.people': 'Contacts',
  'record.cp.people.error': 'Could not load contacts',
  'record.cp.call': 'Call: {name}',
  'record.cp.write': 'Email: {name}',
  'record.cp.requisites': 'Details',
  'record.cp.requisites.error': 'Could not load company details',
  'record.cp.requisites.empty': 'Company details are not filled in.',
  'record.cp.allFields': 'All fields',
  'record.cp.fewerFields': 'Summary',
  'record.cp.innKpp': 'INN / KPP',
  'record.cp.contracts': 'Contracts',
  'record.cp.contracts.none': 'No contract.',
  'record.cp.contract': 'Contract No. {number}',
  'record.cp.validUntil': 'until {date}',
  'record.cp.allDocuments': 'All',
  'record.cp.credit': 'Credit and terms',
  'record.cp.finance.error': 'Could not load the client’s finance',
  'record.cp.primaryDocuments': 'Primary documents',
  'record.cp.documents.error': 'Could not load documents',
  'record.cp.documents.empty': 'No primary documents for this client.',
  'record.inv.title': 'Invoice',
  'record.inv.sections': 'Invoice sections',
  'record.inv.tab.payments': 'Payments',
  'record.inv.client': 'Client',
  'record.inv.deal': 'deal',
  'record.inv.contract': 'contract',
  'record.inv.open': 'open',
  'record.inv.issued': 'issued {date}',
  'record.inv.payBy': 'due by',
  'record.inv.overdueDays': 'Overdue {days} days',
  'record.inv.overdueBy': 'overdue by {days} days',
  'record.inv.awaiting': 'Awaiting payment',
  'record.inv.awaitingDays': 'Awaiting payment · {days} days',
  'record.inv.dueToday': 'due today',
  'record.inv.dueIn': 'due in {days} days',
  'record.inv.settled': 'paid in full',
  'record.inv.allocate': 'Allocate payment',
  'record.inv.allocated': 'The payment was allocated to the invoice.',
  'record.inv.deallocated': 'Allocation removed: the amount returned to the payment and the invoice.',
  'record.inv.cancel': 'Cancel invoice',
  'record.inv.cancelContinue': 'Cancel invoice…',
  'record.inv.cancel.title': 'Cancel invoice {number}?',
  'record.inv.cancel.text': 'The invoice stays in the register as cancelled, with the reason: “{reason}”.',
  'record.inv.cancelledBecause': 'The invoice is cancelled. Reason: {reason}',
  'record.inv.amounts': 'Invoice amounts',
  'record.inv.total': 'Total incl. VAT',
  'record.inv.vatSub': 'VAT {amount}',
  'record.inv.paidPercent': '{percent} % paid',
  'record.inv.advanceHint': 'The client has an unallocated payment No. {number} of {date}: {amount} left.',
  'record.inv.allocateHere': 'Allocate {amount} to this invoice',
  'record.inv.vatPerLine': 'VAT is calculated per line, on the discounted amount',
  'record.inv.payments': 'Payments and allocation',
  'record.inv.allPayments': 'All payments',
  'record.inv.payments.error': 'Could not load the invoice’s payments',
  'record.inv.payments.emptyDue': 'Payment is due on {date}.',
  'record.inv.paymentAmount': 'Payment amount',
  'record.inv.toThisInvoice': 'To this invoice',
  'record.inv.paymentLeft': 'Payment balance',
  'record.inv.dispatches': 'Sending and reminders',
  'record.inv.sent': 'Invoice sent to the client',
  'record.inv.notSent': 'The invoice has not been sent yet',
  'record.inv.dunning.error': 'Could not load reminders',
  'record.inv.dunning.done': 'done {at}',
  'record.inv.dunning.planned': 'planned for {date}',
  'record.inv.composer.comment': 'Comment on the invoice',
  'record.inv.feed.error': 'Could not load the invoice’s feed',
  'record.inv.feed.empty': 'No events for this invoice yet',
  'record.inv.details': 'Invoice fields',
  'record.inv.primaryDocuments': 'Primary documents',
  'record.inv.documents.error': 'Could not load the invoice’s documents',
  'record.inv.documents.empty': 'No documents have been issued for this invoice.',

  // --- payments & service screens (BankRecon, Cashbook, Fiscal, Err403/404, Login, CreateRecord) ---
  'payments.forbidden.hint': 'Your role does not grant this section. The data exists, it is just not shown to this role; an administrator grants access.',
  'payments.error.title': 'Could not load the data',
  'payments.retry': 'Retry',
  'payments.recon.noOrg.title': 'Choose an organisation — each has its own accounts and statements',
  'payments.recon.noOrg.text': 'Organisations are separate legal entities with their own bank accounts, statements and queue. They are never added together.',
  'payments.recon.noAccount.title': 'The organisation has no bank account',
  'payments.recon.noAccount.text': 'There is nothing to match a statement to: add the organisation’s bank account, then a Client-Bank statement can be uploaded here.',
  'payments.recon.chooseAccount': 'Choose the bank account the statement belongs to',
  'payments.recon.accountShort': 'acc.',
  'payments.recon.nothingToPost': 'Nothing to post: no unposted statement lines',
  'payments.recon.filter': 'Filter by status',
  'payments.recon.chip.all': 'All',
  'payments.recon.status.line': 'Not posted',
  'payments.recon.status.line.detail': 'the bank sent it, no payment yet',
  'payments.recon.status.attention': 'Needs a decision',
  'payments.recon.status.attention.detail': 'payer not recognised',
  'payments.recon.search': 'Search statement lines',
  'payments.recon.search.placeholder': 'Counterparty, tax ID, number or amount',
  'payments.recon.filtered.empty': 'Nothing matches the filter',
  'payments.recon.empty.title': 'The queue is clear',
  'payments.recon.footnote': 'Statement lines are never edited — only the allocation changes. Hover the purpose to read it in full.',
  'payments.recon.col.date': 'Date',
  'payments.recon.col.number': 'Doc no.',
  'payments.recon.col.counterparty': 'Counterparty',
  'payments.recon.col.purpose': 'Payment purpose',
  'payments.recon.col.in': 'In',
  'payments.recon.col.out': 'Out',
  'payments.recon.col.status': 'Status',
  'payments.recon.col.action': 'Action',
  'payments.recon.notFoundByInn': 'Not found by tax ID {inn}',
  'payments.recon.noInn': 'No tax ID in the statement',
  'payments.recon.open': 'Open',
  'payments.recon.total': 'Queue total · {count}',
  'payments.recon.total.filtered': 'Filtered total · {count}',
  'payments.recon.postAll.title': 'Post {count} statement lines?',
  'payments.recon.postAll.confirm': 'Post {count}',
  'payments.recon.postAll.text': 'Each line becomes a payment and settles invoices automatically. Lines that do not match stay in the list — the result names them.',
  'payments.recon.postAll.untouched': 'Payments needing a decision ({count}) are left untouched in the list.',
  'payments.import.zone': 'Statement upload',
  'payments.import.drop': 'Drop a Client-Bank statement file here',
  'payments.import.busy': 'Uploading the statement…',
  'payments.import.format': '1CClientBankExchange format, a UTF-8 .txt file. Repeats are recognised by number, date, amount and account.',
  'payments.import.choose': 'Choose a file',
  'payments.import.more': 'Upload another',
  'payments.import.at': 'uploaded at {time}',
  'payments.cash.noOrg.title': 'Choose an organisation — each has its own cash desk; there is no combined balance',
  'payments.cash.noOrg.text': 'Organisations are separate legal entities with their own cash. Their cash is never added together.',
  'payments.cash.newIncoming': 'Cash in',
  'payments.cash.newOutgoing': 'Cash out',
  'payments.cash.prevDay': 'Previous day',
  'payments.cash.nextDay': 'Next day',
  'payments.cash.prevMonth': 'Previous month',
  'payments.cash.nextMonth': 'Next month',
  'payments.cash.date': 'Date',
  'payments.cash.period': 'Period',
  'payments.cash.day': 'Day',
  'payments.cash.month': 'Month',
  'payments.cash.currency': 'Cash currency: {currency}',
  'payments.cash.currencyLabel': 'Currency',
  'payments.cash.facts': 'Cash movement for {period}',
  'payments.cash.in': '+ In',
  'payments.cash.out': '− Out',
  'payments.cash.net': '= Net for the period',
  'payments.cash.net.hint': 'from the server for {period}',
  'payments.cash.items': 'items: {count}',
  'payments.cash.empty.title': 'No entries for {period}',
  'payments.cash.empty.text': 'The first entry appears here and goes straight into the cash book.',
  'payments.cash.col.date': 'Entry · date',
  'payments.cash.col.kind': 'Kind',
  'payments.cash.col.item': 'Cash-flow item · basis',
  'payments.cash.col.in': 'In',
  'payments.cash.col.out': 'Out',
  'payments.cash.total': 'Total for {period} · entries: {count}',
  'payments.cash.reversedMark': 'reversed',
  'payments.cash.rowMenu': 'Actions for entry {id}',
  'payments.cash.byItemIn': 'Income by item',
  'payments.cash.byItemOut': 'Spending by item',
  'payments.cash.noIn': 'No income in the period.',
  'payments.cash.noOut': 'No spending in the period.',
  'payments.cash.org': 'Cash desk',
  'payments.cash.reverse.title': 'Reverse entry {id}?',
  'payments.cash.reverse.text': 'The journal is never edited: a second, mirror entry is written and both stay visible. A reversal can only be undone by another entry.',
  'payments.cash.basis': 'Basis',
  'payments.cash.basis.help': 'Required: an unexplained manual entry is the one thing the journal cannot digest.',
  'payments.cash.record': 'Record',
  'payments.fiscal.retry.nothing': 'Nothing to retry: only abandoned receipts are left',
  'payments.fiscal.empty.text': 'If a receipt gets stuck on its way to the OFD, it appears here by itself.',
  'payments.fiscal.abandoned.title': 'Abandoned receipts: {count} — they are no longer sent automatically.',
  'payments.fiscal.abandoned.text': 'The OFD deadline is 30 days; such a receipt is closed with a correction receipt.',
  'payments.fiscal.chip.all': 'All problems',
  'payments.fiscal.chip.retrying': 'Awaiting retry',
  'payments.fiscal.chip.failed': 'Send error',
  'payments.fiscal.chip.abandoned': 'Abandoned',
  'payments.fiscal.search': 'Find a receipt',
  'payments.fiscal.search.placeholder': 'Fiscal no., amount, error text',
  'payments.fiscal.col.receipt': 'Receipt / FD',
  'payments.fiscal.col.created': 'Date, time',
  'payments.fiscal.col.error': 'Last error',
  'payments.fiscal.payment': 'payment',
  'payments.fiscal.attempts': 'attempts: {count}',
  'payments.fiscal.next': 'next {at}',
  'payments.fiscal.noMoreRetries': 'no more automatic retries',
  'payments.fiscal.footnote': 'Not delivered to the OFD: {count}. A receipt that ran out of attempts is abandoned and no longer sent automatically.',
  'err.home': 'To start page',
  'err.back': 'Back',
  'err.support': 'For support: {code}',
  'err.copy': 'Copy the error code',
  'err.copied': 'Code copied',
  'err.sections': 'Main sections',
  'err.requested': 'Requested',
  'err.yourRoles': 'Your roles',
  'err.403.tip': 'Access is granted by the system administrator. The server checks access regardless of this page.',
  'err.404.kind': 'Not found',
  'err.404.lead.before': 'There is nothing at',
  'err.404.lead.after': '. Usually for one of two reasons:',
  'err.404.stale': 'The link is out of date',
  'err.404.stale.text': 'The section moved or the address has a typo — it happens with links from old emails and bookmarks.',
  'err.404.deleted': 'The record was deleted or is not available to you',
  'err.404.deleted.text': 'Deleted deals, invoices and counterparties do not open by link; the server does not show records outside your scope at all.',
  'err.404.find': 'Find a record',
  'err.404.find.placeholder': 'Section or command — search from any page',
  'auth.signIn.title': 'Sign in',
  'auth.signIn.help': 'Email and password are entered on the corporate sign-in page — the CRM never sees your password.',
  'auth.language': 'Interface language',
  'auth.logoutFailed.title': 'Sign-out not confirmed',
  'create.close': 'Close without saving',
  'create.more': 'More fields',
  'create.saving': 'Creating…',
  'create.saving.note': 'Checking and saving…',
  'create.hint.submit': '— create',
  'create.hint.cancel': '— cancel',
  'create.dup.open': 'Open',
  'create.cp.innHelp': '10 digits — company, 12 — sole trader or individual',
  'create.cp.needName': 'Enter a name',
  'create.cp.ogrn': 'OGRN',
  'create.cp.website': 'Website',
  'create.cp.more.hint': '· phone, email, website, full name, actual address',
  'lead.create.what': 'What they want',
  'lead.create.needTitle': 'Describe what they want',
  'lead.create.innHelp': 'Optional; a tax ID also counts as a contact',
  'lead.create.responsibleYou': 'You',
  'lead.create.responsibleMe': 'A manually created lead goes to whoever created it',
  'deal.create.needTitle': 'Enter the deal title',
  'deal.create.needFunnel': 'No funnel: create one in administration',
  'deal.create.stageHelp': 'The funnel’s first stage, probability {probability} %',
  'deal.create.currencyHelp': 'Empty — the default currency',
  'deal.create.openDeals': 'The client already has open deals ({count}) — maybe add lines to one of them?',
  'deal.create.separate': 'No, create a separate one',
  'deal.create.separateNote': 'A separate deal will be created; the client’s open deals stay as they are and are all visible on the client card.',
  // Warehouse document cards on the design system (Receiving, Shipment, Picking, Inventory, Transfer.dc.html)
  'record.wh.stages': 'Document stages',
  'record.wh.details': 'Details',
  'record.wh.cancelledEnd': 'Cancelled',
  'record.wh.none': 'none',
  'record.wh.of': '{done} of {total}',
  'record.wh.pieces': '{qty} pcs',
  'record.wh.kg': '{qty} kg',
  'record.wh.m3': '{qty} m³',
  'record.wh.days': '{days} d',
  'record.wh.total': 'Total',
  'record.wh.positions': 'Positions',
  'record.wh.warehouseNamed': 'warehouse “{name}”',
  'record.wh.rowFilter': 'Which rows to show',
  'record.wh.filter.all': 'All',
  'record.wh.filter.withDiff': 'With discrepancies',
  'record.wh.filter.pending': 'In progress',
  'record.wh.rec.title': 'Goods receipt',
  'record.wh.rec.sections': 'Receipt sections',
  'record.wh.rec.supplier': 'Supplier',
  'record.wh.rec.noSupplier': 'no supplier',
  'record.wh.rec.supplierDoc': 'supplier document No. {number}',
  'record.wh.rec.byOrder': 'by purchase order',
  'record.wh.rec.keeper': 'storekeeper {name}',
  'record.wh.rec.start': 'Start receiving',
  'record.wh.rec.complete': 'Post the receipt',
  'record.wh.rec.completed': 'Receipt posted: the goods are on stock',
  'record.wh.rec.cancel': 'Cancel the receipt…',
  'record.wh.rec.cancel.title': 'Cancel receipt {number}?',
  'record.wh.rec.cancel.text': 'Lines and counts stay in the document; nothing goes to stock.',
  'record.wh.rec.nothingCounted': 'Nothing to post yet: no line has been counted on a terminal.',
  'record.wh.rec.positions': 'Positions',
  'record.wh.rec.positionsSub': '{counted} counted · {pending} in progress',
  'record.wh.rec.expectedAccepted': 'Expected / accepted, pcs',
  'record.wh.rec.rejectedSub': 'defects {qty}',
  'record.wh.rec.diffCount': 'Lines with discrepancies: {count}',
  'record.wh.rec.diffSub': 'shortage {shortage} · surplus {surplus} · defects {defect}',
  'record.wh.rec.receivedAt': 'Received',
  'record.wh.rec.notReceived': 'not posted yet',
  'record.wh.rec.lines': 'Receipt lines',
  'record.wh.rec.difference': 'Difference',
  'record.wh.rec.progress': 'Progress',
  'record.wh.rec.total': 'Total · lines: {count}',
  'record.wh.rec.countedOf': 'counted {counted} of {total}',
  'record.wh.rec.notAccepted': 'not accepted yet',
  'record.wh.rec.shortageBy': '{qty} · shortage',
  'record.wh.rec.surplusBy': '{qty} · surplus',
  'record.wh.rec.mismatch': 'does not match expected',
  'record.wh.rec.matches': 'matches',
  'record.wh.rec.empty.title': 'The receipt has no lines',
  'record.wh.rec.codes': 'Marking codes',
  'record.wh.rec.codesMissing': 'Codes are scanned on the terminal. The server does not yet expose the scanned codes of a receipt, so the counter and duplicates cannot be shown here.',
  'record.wh.rec.actError': 'Could not load the discrepancy report',
  'record.wh.rec.amount': 'Qty',
  'record.wh.rec.moneyMissing': 'The server does not price discrepancies at purchase cost: the report shows quantities.',
  'record.wh.rec.putaway': 'Where to put away',
  'record.wh.rec.putawayEmpty': 'Nothing to put away.',
  'record.wh.rec.crossDock': 'cross-dock, no put-away',
  'record.wh.rec.confirm.title': 'Post the receipt?',
  'record.wh.rec.confirm.withDiff': 'Post with discrepancies?',
  'record.wh.rec.confirm.withDiffAction': 'Post with discrepancies',
  'record.wh.rec.confirm.diff': 'Shortage {shortage} pcs, surplus {surplus} pcs, defects {defect} pcs.',
  'record.wh.rec.confirm.pending': 'Lines not counted: {count} — nothing from them goes to stock.',
  'record.wh.rec.confirm.balance': 'Accepted goods go to stock, warehouse “{warehouse}”.',
  'record.wh.rec.confirm.final': 'A posted receipt is undone only by a return to the supplier.',
  'record.wh.rec.stage.draft': 'Draft',
  'record.wh.rec.stage.in_progress': 'Receiving',
  'record.wh.rec.stage.completed': 'Received',
  'record.wh.rec.stage.countingNow': 'counting on terminal',
  'record.wh.rec.stage.afterPosting': 'after posting',
  'record.wh.ship.title': 'Shipment',
  'record.wh.ship.sections': 'Shipment sections',
  'record.wh.ship.client': 'Client',
  'record.wh.ship.byOrder': 'by order',
  'record.wh.ship.post': 'Post the shipment',
  'record.wh.ship.posted': 'Shipment posted: stock written off, document issued',
  'record.wh.ship.postHint': 'Posting writes stock off and issues the UPD; handing over to the carrier is a separate step.',
  'record.wh.ship.packingOnTerminal': 'The shipment is not packed yet: packing happens at the bench on a terminal, posting comes after it.',
  'record.wh.ship.confirm.title': 'Post shipment {number}?',
  'record.wh.ship.confirm.text': '{qty} pcs in {positions} positions will be written off warehouse “{warehouse}”; a UPD will be issued.',
  'record.wh.ship.confirm.separate': 'Handing over to the carrier is a separate action after posting.',
  'record.wh.ship.returned': 'Returned',
  'record.wh.ship.stage.packed': 'Packed',
  'record.wh.ship.stage.shipped': 'Posted',
  'record.wh.ship.stage.in_transit': 'Handed to carrier',
  'record.wh.ship.stage.delivered': 'Delivered',
  'record.wh.ship.stage.packing': 'packing on terminal',
  'record.wh.ship.stage.packedMeta': 'places: {count}',
  'record.wh.ship.afterPacking': 'after packing',
  'record.wh.ship.afterWeighing': 'after weighing',
  'record.wh.ship.gross': 'Gross weight',
  'record.wh.ship.netSub': 'net {qty} kg',
  'record.wh.ship.volume': 'Volume',
  'record.wh.ship.noCarrier': 'not chosen',
  'record.wh.ship.track': 'tracking',
  'record.wh.ship.copyTrack': 'Copy tracking number {number}',
  'record.wh.ship.noTrack': 'the carrier does not number the shipment',
  'record.wh.ship.trackAfterHandOver': 'tracking — after hand-over',
  'record.wh.ship.items': 'Shipment contents',
  'record.wh.ship.noLinesText': 'Shipment lines come from the order after reservation and picking.',
  'record.wh.ship.placesOf': 'Places',
  'record.wh.ship.placesCount': 'places: {count}',
  'record.wh.ship.places': 'Packages',
  'record.wh.ship.inside': 'Contents',
  'record.wh.ship.packingError': 'Could not load the packing list',
  'record.wh.ship.weightNote': 'Gross {gross} kg, net {net} kg for the whole shipment. Per-place dimensions and weight are not exposed by the server.',
  'record.wh.ship.notWeighed': 'The shipment has not been weighed yet.',
  'record.wh.ship.handOverHint': 'The request goes to the carrier once: a repeat would bring a second courier.',
  'record.wh.ship.documents': 'Related documents',
  'record.wh.ship.order': 'Order',
  'record.wh.ship.noDocument': 'No UPD yet',
  'record.wh.ship.documentIssued': 'issued on posting',
  'record.wh.ship.documentOnPosting': 'will be issued on posting',
  'record.wh.pick.title': 'Pick task',
  'record.wh.pick.sections': 'Task sections',
  'record.wh.pick.picker': 'picker {name}',
  'record.wh.pick.noPicker': 'no picker assigned',
  'record.wh.pick.reassign': 'Reassign the picker',
  'record.wh.pick.complete': 'Complete picking',
  'record.wh.pick.completed': 'Picking completed',
  'record.wh.pick.completedShort': 'Picking completed, lines short: {count}',
  'record.wh.pick.left': 'Cannot complete yet: {count} lines unresolved. They are confirmed by scanning on a terminal.',
  'record.wh.pick.rows': 'Lines',
  'record.wh.pick.rowsSub': '{taken} taken · {skipped} skipped · {left} left',
  'record.wh.pick.done': 'Picked',
  'record.wh.pick.doneLabel': 'Lines resolved: {done} of {total}',
  'record.wh.pick.shortSub': 'short: {count}',
  'record.wh.pick.skipped': 'Skipped',
  'record.wh.pick.skippedTab': 'Skips',
  'record.wh.pick.time': 'Time in progress',
  'record.wh.pick.since': 'since {at}',
  'record.wh.pick.notStarted': 'not started yet',
  'record.wh.pick.emptyText': 'No route yet: the positions are not reserved at the warehouse.',
  'record.wh.pick.route': 'Picking route',
  'record.wh.pick.routeFallback': 'server route unavailable — lines in task order',
  'record.wh.pick.routeNote': 'Order is row → rack → level as the server builds it. Shortages and skips do not stop the route.',
  'record.wh.pick.taken': 'Taken {qty}',
  'record.wh.pick.takenOf': 'Taken {picked} of {qty}',
  'record.wh.pick.next': 'Next',
  'record.wh.pick.ahead': 'Ahead',
  'record.wh.pick.noSkipped': 'No skipped lines',
  'record.wh.pick.skippedAt': 'The picker skipped the line at cell',
  'record.wh.pick.stockForbidden': 'Where else the item lies is visible with the stock right.',
  'record.wh.pick.stockError': 'Could not load the item’s stock',
  'record.wh.pick.noStockElsewhere': 'The warehouse has no more of this item.',
  'record.wh.pick.elsewhere': 'Where else the item is',
  'record.wh.pick.onBooks': 'On books',
  'record.wh.pick.available': 'Available',
  'record.wh.pick.addCellMissing': 'A cell cannot be added to the route from the office: there is no such operation.',
  'record.wh.pick.pickerPanel': 'Picker',
  'record.wh.pick.noPickerText': 'No picker assigned — the task will not reach a terminal.',
  'record.wh.pick.cancel.title': 'Cancel task {number}?',
  'record.wh.pick.cancel.taken': 'Lines already taken: {count} — the goods go back to their cells.',
  'record.wh.pick.cancel.final': 'A cancelled task cannot be resumed — only a new one created.',
  'record.wh.st.title': 'Stocktake',
  'record.wh.st.sections': 'Stocktake sections',
  'record.wh.st.start': 'Start counting',
  'record.wh.st.started': 'Counting started: the sheet went to terminals',
  'record.wh.st.startBlocked': 'The stocktake has no positions — nothing to count.',
  'record.wh.st.finish': 'Finish counting',
  'record.wh.st.finished': 'Counting finished: the variance report is ready',
  'record.wh.st.finishBlocked': 'Cannot finish yet: {count} positions not counted.',
  'record.wh.st.approve': 'Approve results…',
  'record.wh.st.positions': 'Positions on the sheet',
  'record.wh.st.countedAt': 'counting finished {at}',
  'record.wh.st.left': 'not counted: {count}',
  'record.wh.st.variances': 'Variances',
  'record.wh.st.variancesSub': 'shortages {shortages} · surpluses {surpluses}',
  'record.wh.st.hidden': 'hidden',
  'record.wh.st.hiddenUntil': 'until counting is finished',
  'record.wh.st.startedAt': 'Started',
  'record.wh.st.notStarted': 'not started yet',
  'record.wh.st.sheetError': 'Could not load the count sheet',
  'record.wh.st.emptyText': 'No stock position made it into the stocktake.',
  'record.wh.st.filterUncounted': 'Not counted',
  'record.wh.st.notCounted': 'not counted',
  'record.wh.st.sheetNote': 'Quantities are entered on terminals: cell → item → quantity.',
  'record.wh.st.sheetDone': 'Counting is finished — variances are in the variance report.',
  'record.wh.st.varianceLater': 'The variance report opens once counting is finished.',
  'record.wh.st.varianceError': 'Could not load the variance report',
  'record.wh.st.inPieces': 'in pieces; the report carries no book prices',
  'record.wh.st.shortageTotal': 'Shortage · positions: {count}',
  'record.wh.st.surplusTotal': 'Surplus · positions: {count}',
  'record.wh.st.confirm.title': 'Approve the stocktake results?',
  'record.wh.st.confirm.action': 'Approve and change stock',
  'record.wh.st.confirm.totals': 'Stock of warehouse “{warehouse}” will change: shortage {shortage} pcs, surplus {surplus} pcs.',
  'record.wh.st.confirm.noVariances': 'No variances — stock will not change.',
  'record.wh.st.confirm.final': 'Only a new stocktake can undo this.',
  'record.wh.st.cancel.title': 'Cancel stocktake {number}?',
  'record.wh.st.cancel.text': 'What was counted stays in the document; stock does not change.',
  'record.wh.st.stage.draft': 'Preparation',
  'record.wh.st.stage.in_progress': 'Counting',
  'record.wh.st.stage.counted': 'Reconciliation',
  'record.wh.st.stage.approved': 'Approved',
  'record.wh.st.stage.changesStock': 'stock will change',
  'record.wh.tr.title': 'Transfer',
  'record.wh.tr.sections': 'Transfer sections',
  'record.wh.tr.lossBadge': 'Transit losses',
  'record.wh.tr.dispatchedMeta': 'dispatched: {at}',
  'record.wh.tr.complete': 'Complete receiving',
  'record.wh.tr.completed': 'Transfer received, no losses',
  'record.wh.tr.completedLoss': 'Transfer received, lines with transit losses: {count}',
  'record.wh.tr.completeBlocked': 'Cannot complete yet: {count} lines wait to be counted on the receiver’s terminal.',
  'record.wh.tr.positions': 'positions: {count}',
  'record.wh.tr.received': 'Received',
  'record.wh.tr.waitingSub': '{qty} pcs still wait to be received',
  'record.wh.tr.afterDispatch': 'after dispatch',
  'record.wh.tr.lossSub': 'lines with losses: {count}',
  'record.wh.tr.lossOnReceipt': 'recorded on receiving',
  'record.wh.tr.travel': 'In transit',
  'record.wh.tr.onTheWay': 'on the way',
  'record.wh.tr.lines': 'Transfer lines',
  'record.wh.tr.filterWaiting': 'Awaiting receipt',
  'record.wh.tr.filterLoss': 'With losses',
  'record.wh.tr.toCell': 'Cell at “{warehouse}”',
  'record.wh.tr.lineStatus': 'Line status',
  'record.wh.tr.total': 'Total · positions: {count}',
  'record.wh.tr.totalStatus': 'received {counted} of {total}',
  'record.wh.tr.notSent': 'Not sent',
  'record.wh.tr.waiting': 'Awaiting receipt',
  'record.wh.tr.acceptedWithLoss': 'Received with losses',
  'record.wh.tr.emptyText': 'A transfer without lines cannot be dispatched.',
  'record.wh.tr.lossPanel': 'Transit losses',
  'record.wh.tr.pieces': 'Pcs',
  'record.wh.tr.noLossYet': 'No losses on the counted lines.',
  'record.wh.tr.noLossFinal': 'Received with no transit losses.',
  'record.wh.tr.actMissing': 'A loss is a claim against the carrier. The API does not yet publish a signed loss report.',
  'record.wh.tr.dispatch.title': 'Dispatch transfer {number}?',
  'record.wh.tr.dispatch.text': '{qty} pcs in {positions} positions leave “{from}” for “{to}”.',
  'record.wh.tr.cancel.title': 'Cancel transfer {number}?',
  'record.wh.tr.cancel.text': 'The draft stays in the register as cancelled; stock has not changed.',
  'record.wh.tr.stage.draft': 'Draft',
  'record.wh.tr.stage.in_transit': 'In transit',
  'record.wh.tr.stage.partial': 'Partly received',
  'record.wh.tr.stage.received': 'Received',
  // --- HR cards on the design system (Employee/Department/Vacancy/LeaveRequest/EmployeeKpi)
  'record.hr.close': 'Close',
  'record.hr.escHint': 'Esc closes without saving',
  'record.hr.days': '{days} d',
  'record.hr.details': 'Details',
  'record.hr.bonus.open': 'Pay a bonus…',
  'record.hr.bonus.title': 'Pay a bonus — {name}',
  'record.hr.bonus.subtitle': 'The server computes it: fund × KPI achievement for the period',
  'record.hr.bonus.from': 'Period from',
  'record.hr.bonus.to': 'to',
  'record.hr.bonus.fund': 'Bonus fund',
  'record.hr.bonus.fundHelp': 'Required: the fund is a money decision and has no default',
  'record.hr.bonus.calculate': 'Calculate',
  'record.hr.bonus.settle': 'Pay {amount}',
  'record.hr.bonus.preview': 'Server calculation',
  'record.hr.bonus.coefficient': 'coefficient',
  'record.hr.bonus.settled': 'Bonus paid: {amount}',
  'record.hr.emp.loading': 'Loading the employee card',
  'record.hr.emp.sections': 'Employee card sections',
  'record.hr.emp.manager': 'manager',
  'record.hr.emp.managerFact': 'Manager',
  'record.hr.emp.personnelNumber': 'Personnel no.',
  'record.hr.emp.personnelNumberShort': 'personnel no. {number}',
  'record.hr.emp.tenure': 'With the company',
  'record.hr.emp.tenureLine': 'With the company {tenure} (since {date})',
  'record.hr.emp.startsOn': 'Starts on {date}',
  'record.hr.emp.notStarted': 'not started yet',
  'record.hr.emp.lessThanMonth': 'under a month',
  'record.hr.emp.years': '{n} y',
  'record.hr.emp.months': '{n} mo',
  'record.hr.emp.since': 'since {date}',
  'record.hr.emp.orderNo': 'order no. {number}',
  'record.hr.emp.leaveLeft': 'Leave left',
  'record.hr.emp.leaveOthers': 'annual · {days} d of other kinds',
  'record.hr.emp.leaveFailed': 'balance did not load',
  'record.hr.emp.leaveNone': 'no balance granted this year',
  'record.hr.emp.transfer': 'Transfer…',
  'record.hr.emp.transferred': 'Transfer recorded from {date}',
  'record.hr.emp.terminate': 'Terminate…',
  'record.hr.emp.terminateConfirm': 'Terminate',
  'record.hr.emp.terminated': 'Termination recorded, last day {date}',
  'record.hr.emp.assignments': 'Assignment history',
  'record.hr.emp.assignmentsFailed': 'Could not load the assignment history',
  'record.hr.emp.noAssignmentsText': 'An assignment appears on hiring and on every transfer.',
  'record.hr.emp.salaryNote': 'salary per month, before tax',
  'record.hr.emp.period': 'Period',
  'record.hr.emp.event': 'Event',
  'record.hr.emp.current': 'Current',
  'record.hr.emp.events': 'HR events',
  'record.hr.emp.noEvents': 'No HR events yet.',
  'record.hr.emp.reportsFailed': 'Could not load direct reports',
  'record.hr.emp.noReportsText': '{name} manages no department or team. Reports appear once they are made a head in the org chart.',
  'record.hr.emp.kpiYear': 'KPI for {year}',
  'record.hr.pdn.oneCall': 'The server decrypts all four fields in one call and writes one audit entry in your name.',
  'record.hr.pdn.hidesIn': 'Values hide after 60 s; showing them again is a new audit entry.',
  'record.hr.pdn.empty': 'not filled in',
  'record.hr.pdn.failed': 'Could not show personal data',
  'record.hr.transfer.overline': 'Staff transfer',
  'record.hr.transfer.title': 'Transfer — {name}',
  'record.hr.transfer.now': 'Now: {position} · {department} · {salary}',
  'record.hr.transfer.date': 'Effective from',
  'record.hr.transfer.submit': 'Record transfer',
  'record.hr.terminate.title': 'Terminate {name}?',
  'record.hr.terminate.lastDay': 'Last working day',
  'record.hr.terminate.text': 'The account is blocked and the assignment closed on the last day.',
  'record.hr.leave.balances': 'Leave balances',
  'record.hr.leave.balancesNote': 'per calendar year · days',
  'record.hr.leave.balancesFailed': 'Could not load balances',
  'record.hr.leave.noBalancesText': 'HR grants the balance per year.',
  'record.hr.leave.nearest': 'Nearest request',
  'record.hr.leave.nearestFailed': 'Could not load requests',
  'record.hr.leave.noNearest': 'No upcoming absence requests.',
  'record.hr.leave.workingDays': '{days} working d',
  'record.hr.leave.openRequest': 'Open request',
  'record.hr.leave.request': 'Request',
  'record.hr.leave.title': '{type} {from} — {to}',
  'record.hr.leave.rowMissingTitle': 'The request cannot be read',
  'record.hr.leave.rejectOpen': 'Reject…',
  'record.hr.leave.rejectTitle': 'Reject the request of {name}?',
  'record.hr.leave.rejectConfirm': 'Reject request',
  'record.hr.leave.rejectText': 'The request closes as rejected; the employee can submit a new one.',
  'record.hr.leave.stages': 'Request stages',
  'record.hr.leave.submitted': 'Submitted',
  'record.hr.leave.period': 'Period',
  'record.hr.leave.calendarDays': '{days} calendar days · back {back}',
  'record.hr.leave.workingDaysFact': 'Working days',
  'record.hr.leave.workingNote': 'by the production calendar',
  'record.hr.leave.balanceAfter': 'Balance of this kind',
  'record.hr.leave.balancesTab': 'Leave balance',
  'record.hr.leave.sections': 'Request sections',
  'record.hr.leave.comment': 'Employee comment',
  'record.hr.leave.clashesFailed': 'Could not load overlaps',
  'record.hr.leave.clashCount': 'Overlaps with colleagues: {count}',
  'record.hr.leave.overlapLabel': 'Department absences during the request',
  'record.hr.leave.scaleCaption': 'Employee · period days',
  'record.hr.leave.thisRequest': 'this request',
  'record.hr.leave.clash': 'overlap',
  'record.hr.leave.legendClash': 'overlap — absent at the same time',
  'record.hr.leave.legendWeekend': 'grey numbers are Saturdays and Sundays',
  'record.hr.leave.routeFailed': 'Could not build the route',
  'record.hr.leave.approverUser': 'approved by a named account',
  'record.hr.leave.approverRole': 'approved by anyone in the role',
  'record.hr.leave.waiting': 'Waiting',
  'record.hr.leave.routeNote': 'The route is built from the org chart by the same rule as on submission. The decision is a single action — the server keeps no per-step marks.',
  'record.hr.leave.timesheetTitle': 'Timesheet {from} — {to}',
  'record.hr.leave.timesheetFailed': 'Could not load the timesheet',
  'record.hr.leave.noTimesheetText': 'The timesheet is filled in on approval.',
  'record.hr.timesheet.code.work': 'W',
  'record.hr.timesheet.code.vacation': 'V',
  'record.hr.timesheet.code.sick': 'S',
  'record.hr.timesheet.code.day_off': 'DO',
  'record.hr.timesheet.code.holiday': 'H',
  'record.hr.timesheet.code.absence': 'A',
  'record.hr.timesheet.code.business_trip': 'BT',
  'record.hr.dept.loading': 'Loading the org chart',
  'record.hr.dept.sections': 'Department sections',
  'record.hr.dept.structure': 'Structure',
  'record.hr.dept.staff': 'Staff',
  'record.hr.dept.staffTitle': 'Department staff',
  'record.hr.dept.staffFailed': 'Could not load staff',
  'record.hr.dept.staffMore': 'First 100 shown — the full list is in Employees filtered by department.',
  'record.hr.dept.noStaff': 'No staff in this department',
  'record.hr.dept.headcount': 'Headcount',
  'record.hr.dept.headcountNote': 'employed, visible to you',
  'record.hr.dept.headcountFailed': 'headcount did not load',
  'record.hr.dept.children': 'Sub-units',
  'record.hr.dept.openVacancies': 'Open vacancies',
  'record.hr.dept.vacanciesFailed': 'Could not load vacancies',
  'record.hr.dept.noVacancies': 'No open vacancies.',
  'record.hr.dept.about': 'About',
  'record.hr.dept.headMeta': 'head',
  'record.hr.dept.partOf': 'part of',
  'record.hr.dept.root': 'top level',
  'record.hr.dept.costCenterMeta': 'cost centre',
  'record.hr.dept.units': '{count} units',
  'record.hr.dept.unit': 'Unit',
  'record.hr.dept.cc': 'CC',
  'record.hr.dept.expandAll': 'Expand all',
  'record.hr.dept.collapseAll': 'Collapse all',
  'record.hr.dept.expand': 'Expand: {name}',
  'record.hr.dept.collapse': 'Collapse: {name}',
  'record.hr.dept.treeNote': 'Headcount is the unit own employees, without sub-units. There is no staffing schedule in the system.',
  'record.hr.dept.moveOpen': 'Move under another unit…',
  'record.hr.dept.moveTitle': 'Move “{name}”',
  'record.hr.dept.moveSubtitle': 'The whole subtree moves',
  'record.hr.dept.moveToRoot': 'Move to the top',
  'record.hr.vac.sections': 'Vacancy sections',
  'record.hr.vac.stages': 'Vacancy status',
  'record.hr.vac.open': 'Open for applications',
  'record.hr.vac.opened': 'Vacancy opened',
  'record.hr.vac.hold': 'Put on hold',
  'record.hr.vac.held': 'Vacancy on hold',
  'record.hr.vac.openedOn': 'opened {date}',
  'record.hr.vac.targetMeta': 'target {date}',
  'record.hr.vac.openFact': 'Open for',
  'record.hr.vac.candidates': 'Applications',
  'record.hr.vac.candidatesNote': 'in total, incl. rejections',
  'record.hr.vac.salaryRange': 'Salary range',
  'record.hr.vac.hiringManager': 'hiring manager',
  'record.hr.vac.recruiter': 'recruiter',
  'record.hr.vac.recruiterShort': 'recruiter {name}',
  'record.hr.vac.board': 'Candidates by stage',
  'record.hr.vac.boardFailed': 'Could not load candidates',
  'record.hr.vac.noApplicationsText': 'No open applications. Rejections and hires are counted in the funnel.',
  'record.hr.vac.columnEmpty': 'Empty',
  'record.hr.vac.candidate': 'Candidate {id}',
  'record.hr.vac.cardActions': 'Application actions',
  'record.hr.vac.moveTo': 'Move to “{stage}”',
  'record.hr.vac.rejectOpen': 'Reject…',
  'record.hr.vac.rejectTitle': 'Reject candidate',
  'record.hr.vac.revokeTitle': 'Revoke consent to personal data processing?',
  'record.hr.vac.revokeText': 'The candidate can no longer be worked with; their data is anonymised.',
  'record.hr.vac.funnelTitle': 'Hiring funnel',
  'record.hr.vac.funnelNote': 'all applications, incl. rejections',
  'record.hr.vac.funnelFailed': 'Could not load the funnel',
  'record.hr.vac.funnelEmpty': 'The funnel appears with the first application.',
  'record.hr.kpi.title': 'KPI · {subject} · {period}',
  'record.hr.kpi.sections': 'KPI sections',
  'record.hr.kpi.stages': 'KPI period stages',
  'record.hr.kpi.stageSet': 'Target set',
  'record.hr.kpi.stagePeriod': 'Period',
  'record.hr.kpi.stageBonus': 'Bonus',
  'record.hr.kpi.notSettled': 'not paid',
  'record.hr.kpi.bonusHidden': 'hidden by permissions',
  'record.hr.kpi.overall': 'Overall achievement',
  'record.hr.kpi.overallNote': 'weighted, computed by the server',
  'record.hr.kpi.actualOfTarget': 'actual / target',
  'record.hr.kpi.period': 'Period',
  'record.hr.kpi.periods': 'Targets by period',
  'record.hr.kpi.linesTitle': 'Indicators for {period}',
  'record.hr.kpi.lines': 'Indicators',
  'record.hr.kpi.failed': 'Could not load KPI',
  'record.hr.kpi.noTargetsText': 'No targets are set for this period.',
  'record.hr.kpi.noPeriod': 'The target has no period',
  'record.hr.kpi.met': 'met',
  'record.hr.kpi.below': 'below target',
  'record.hr.kpi.noFact': 'no actual',
  'record.hr.kpi.recompute': 'Recompute actuals',
  'record.hr.kpi.recomputed': 'Targets recomputed: {count}',
  'record.hr.kpi.setActual': 'Set actual manually…',
  'record.hr.kpi.actualSaved': 'Actual saved',
  'record.hr.kpi.was': 'Was',
  'record.hr.kpi.becomes': 'Becomes',
  'record.hr.kpi.manualHelp': 'Only for an indicator without a source: recomputation will not overwrite it.',
  'record.hr.kpi.bonusTitle': 'Bonus',
  // ------------------------------------------------------------------ Sales and finance record cards (Lead, Contact, Quote, Product, PrimaryDoc, Contract, Payment .dc.html)
  'record.feed.loadError': 'Could not load the feed',
  'record.dur.m': '{m} min',
  'record.dur.hm': '{h} h {m} min',
  'record.dur.dh': '{d} d {h} h',
  'record.lead.sections': 'Lead sections',
  'record.lead.stages': 'Lead stages',
  'record.lead.stage.since': 'since {at}',
  'record.lead.qualify': 'Qualify',
  'record.lead.convert': 'Convert to deal',
  'record.lead.convertContinue': 'Convert to deal…',
  'record.lead.convert.title': 'Convert the lead to a deal',
  'record.lead.convert.text': 'The counterparty, contact and deal are created in one operation — all or nothing. The counterparty is matched by INN.',
  'record.lead.convert.noFunnel': 'No funnel for the deal',
  'record.lead.responded': 'Responded to client',
  'record.lead.call': 'Call',
  'record.lead.mergeContinue': 'Merge with a duplicate…',
  'record.lead.merge': 'Merge',
  'record.lead.merge.title': 'Mark this lead as a duplicate of “{title}”?',
  'record.lead.merge.text': 'This lead will be closed, not deleted: its tags stay in reports. Missing phone, e-mail and INN move to the original lead.',
  'record.lead.rejectContinue': 'Reject…',
  'record.lead.reject': 'Reject',
  'record.lead.reject.title': 'Reject the lead “{title}”?',
  'record.lead.reject.text': 'The lead will be closed as “Rejected”. Nothing is sent to the client.',
  'record.lead.reject.placeholder': 'What the client said, why it does not fit',
  'record.lead.reject.help': 'Goes into the rejections-by-source report used to decide whether to keep the campaign.',
  'record.lead.reject.missing': 'A rejection cannot be saved without a reason',
  'record.lead.converted': 'The lead was converted: counterparty, contact and deal were created.',
  'record.lead.isDuplicate': 'The lead was marked as a duplicate of another one and closed.',
  'record.lead.openOriginal': 'Open original',
  'record.lead.inn': 'INN {inn}',
  'record.lead.notCounterparty': 'not a counterparty yet',
  'record.lead.unassigned': 'Unassigned',
  'record.lead.fact.source': 'Source and channel',
  'record.lead.fact.received': 'Received',
  'record.lead.fact.sla': 'First-response SLA',
  'record.lead.fact.responsible': 'Owner',
  'record.lead.fact.territory': 'Territory',
  'record.lead.sla.left': '{duration} left',
  'record.lead.sla.over': 'Overdue by {duration}',
  'record.lead.sla.met': 'Responded in {duration}',
  'record.lead.sla.aria': 'First-response SLA: {text}',
  'record.lead.sla.until': 'until {at}',
  'record.lead.sla.breached': 'breached',
  'record.lead.sla.done': 'met',
  'record.lead.next.missingHint': 'While the SLA runs the lead needs a next step — otherwise the client waits for an answer nobody plans.',
  'record.lead.composer.comment': 'Comment on the lead',
  'record.lead.lastEvents': 'Latest events',
  'record.lead.allFeed': 'Whole feed',
  'record.lead.feed.empty': 'No events yet',
  'record.lead.feed.emptyText': 'Calls, e-mails and status changes will appear here — start with the first call while the SLA runs.',
  'record.lead.tab.similar': 'Similar',
  'record.lead.similar': 'Similar leads',
  'record.lead.similar.checked': 'Checked by INN, phone and e-mail',
  'record.lead.similar.none': 'No matches found',
  'record.lead.similar.noneText': 'No other leads share this INN, phone or e-mail.',
  'record.lead.similar.error': 'Could not check for matches',
  'record.lead.similar.by.phone': 'Possible duplicate: same phone',
  'record.lead.similar.by.email': 'Possible duplicate: same e-mail',
  'record.lead.similar.by.inn': 'Possible duplicate: same INN',
  'record.lead.counterparties': 'Similar counterparties',
  'record.lead.counterparties.none': 'No counterparties with this INN, phone or e-mail — conversion will create a new one.',
  'record.lead.utm': 'Source and tags',
  'record.lead.details': 'Details',
  'record.contact.sections': 'Contact sections',
  'record.contact.call': 'Call',
  'record.contact.mail': 'Write e-mail',
  'record.contact.task': 'New task',
  'record.contact.primary': 'Primary contact',
  'record.contact.delete': 'Delete contact',
  'record.contact.delete.title': 'Delete the contact “{name}”?',
  'record.contact.delete.text': 'The contact takes part in deals: {count}. While they participate in an open deal the server refuses — replace them first. In closed deals the deleted contact stays marked.',
  'record.contact.fact.phones': 'Phones',
  'record.contact.mobile': 'mobile',
  'record.contact.work': 'work',
  'record.contact.fact.last': 'Last touch',
  'record.contact.fact.noTouches': 'no touches yet',
  'record.contact.deals': 'Deals they take part in',
  'record.contact.deals.empty': 'The contact takes part in no deals yet',
  'record.contact.deals.emptyText': 'Add them to a deal of their company with a role — then calls with them show up in the deal.',
  'record.contact.col.deal': 'Deal',
  'record.contact.lastEvents': 'Latest events',
  'record.contact.feed.empty': 'No events yet',
  'record.contact.feed.emptyText': 'Calls, e-mails and comments about the contact will appear here.',
  'record.contact.next.missingHint': 'Set a next step so the conversation does not stall.',
  'record.contact.composer.comment': 'Comment on the contact',
  'record.contact.colleagues': 'Colleagues',
  'record.contact.colleagues.none': 'The company has no other contacts.',
  'record.contact.colleagues.error': 'Could not load colleagues',
  'record.contact.callTo': 'Call {name}',
  'record.contact.mailTo': 'E-mail {name}',
  'record.contact.tab.details': 'Details',
  'record.contact.details': 'Details',
  'record.quote.title': 'Quote',
  'record.quote.sections': 'Quote sections',
  'record.quote.stages': 'Quote stages',
  'record.quote.deal': 'deal',
  'record.quote.dealLink': 'open',
  'record.quote.from': 'from {org}',
  'record.quote.needsApproval': 'Pending approval',
  'record.quote.send': 'Send to client',
  'record.quote.sent': 'The quote was sent to the client.',
  'record.quote.why.empty': 'Cannot send: the quote has no lines',
  'record.quote.why.approval': 'Can be sent once the approval is decided',
  'record.quote.submitApproval': 'Submit for approval',
  'record.quote.approval.submitted': 'The quote was submitted for approval.',
  'record.quote.approval.notRequired': 'No threshold is crossed — no approval needed, the quote can be sent.',
  'record.quote.markAccepted': 'Mark accepted',
  'record.quote.markRejected': 'Rejected',
  'record.quote.accepted': 'Quote accepted: the invoice will appear in billing once the event is processed.',
  'record.quote.pendingAlert': 'The discount or amount crossed a threshold — the quote can be sent after approval.',
  'record.quote.stage.noLines': 'no lines',
  'record.quote.stage.onApproval': 'on approval',
  'record.quote.stage.answer': 'Accepted / Rejected',
  'record.quote.stage.until': 'answer by {date}',
  'record.quote.fact.total': 'Total incl. VAT',
  'record.quote.fact.totalSub': 'net {net} · VAT {vat}',
  'record.quote.fact.discount': 'Discount',
  'record.quote.fact.discountSub': '{share} % of the quote, net',
  'record.quote.noDiscount': 'none',
  'record.quote.fact.validUntil': 'Valid until',
  'record.quote.fact.sent': 'Sent',
  'record.quote.notSent': 'not sent',
  'record.quote.locked': 'Content is fixed by sending',
  'record.quote.lockedApproval': 'Editing is closed during approval',
  'record.quote.lines.empty': 'The quote has no lines',
  'record.quote.lines.emptyText': 'Lines are copied from the deal when the quote is created. A quote without lines cannot be sent.',
  'record.quote.productUnknown': 'Product not found',
  'record.quote.col.price': 'Price net',
  'record.quote.col.discount': 'Discount',
  'record.quote.col.net': 'Net',
  'record.quote.col.vat': 'VAT',
  'record.quote.col.total': 'Total',
  'record.quote.approval': 'Discount approval',
  'record.quote.approval.none': 'Not requested',
  'record.quote.approval.noneText': 'No approval was requested. The threshold is checked when sending.',
  'record.quote.approval.error': 'Could not load the approval',
  'record.quote.approval.byRole': 'Approver by role',
  'record.quote.approval.waiting': 'awaiting decision',
  'record.quote.approval.ahead': 'after the previous step',
  'record.quote.approval.status.pending': 'Pending',
  'record.quote.approval.status.approved': 'Approved',
  'record.quote.approval.status.rejected': 'Rejected',
  'record.quote.approval.status.cancelled': 'Cancelled',
  'record.quote.approval.step.approved': 'Approved',
  'record.quote.approval.step.rejected': 'Rejected',
  'record.quote.approval.step.skipped': 'Skipped',
  'record.quote.approval.step.waiting': 'Waiting',
  'record.quote.approval.step.ahead': 'Ahead',
  'record.quote.tab.details': 'Details',
  'record.quote.details': 'Quote fields',
  'record.product.sections': 'Product sections',
  'record.product.active': 'Active',
  'record.product.inactive': 'Inactive',
  'record.product.fact.free': 'Free in total',
  'record.product.fact.freeSub': 'of {quantity} · reserved {reserved}',
  'record.product.noStock': 'no stock',
  'record.product.belowMin': 'below minimum',
  'record.product.belowMinAlert': 'Free {free} with a minimum of {min} — time to restock.',
  'record.product.minNotSet': 'not set',
  'record.product.stock': 'Stock by warehouse',
  'record.product.stock.empty': 'No stock in any warehouse',
  'record.product.stock.emptyText': 'Stock will appear after receiving.',
  'record.product.stock.error': 'Could not load stock',
  'record.product.stock.forbidden': 'Warehouse stock is not available to you',
  'record.product.stockTotal': 'Total',
  'record.product.free': 'Free',
  'record.product.tab.details': 'Specification',
  'record.product.details': 'Product fields',
  'record.doc.sections': 'Document sections',
  'record.doc.stages': 'Document stages',
  'record.doc.from': 'of {date}',
  'record.doc.seller': 'seller',
  'record.doc.buyer': 'buyer',
  'record.doc.toInvoice': 'for invoice',
  'record.doc.contract': 'contract',
  'record.doc.stage.draft': 'Draft',
  'record.doc.stage.issued': 'Issued',
  'record.doc.stage.edi': 'Sent via EDI',
  'record.doc.stage.signed': 'Signed',
  'record.doc.stage.mismatch': 'signature mismatch',
  'record.doc.fact.total': 'Total incl. VAT',
  'record.doc.fact.lines': '{count} lines',
  'record.doc.fact.vat': 'VAT',
  'record.doc.fact.net': 'net {amount}',
  'record.doc.fact.date': 'Document date',
  'record.doc.fact.basis': 'Basis',
  'record.doc.sig.draft': 'It can be signed once the document is issued.',
  'record.doc.sig.unsignedText': 'The document is issued but not signed — there is nothing to check the content against yet.',
  'record.doc.sig.okText': 'Signed {at} · content unchanged',
  'record.doc.signature': 'Signature and EDI',
  'record.doc.original': 'original',
  'record.doc.tab.lines': 'Lines',
  'record.doc.tab.signatures': 'Signatures and EDI',
  'record.doc.lines': 'Document lines',
  'record.doc.lines.hint': 'prices net · VAT per line',
  'record.doc.lines.emptyText': 'Lines come from the shipment when the document is issued.',
  'record.doc.lines.notSigned': 'The current lines differ from the signed version',
  'record.doc.col.net': 'Net',
  'record.doc.reissueContinue': 'Reissue…',
  'record.doc.reissue.overline': 'Reissuing a document',
  'record.doc.reissue.title': 'Reissue {number}',
  'record.doc.reissue.text': 'Reissue of {number} of {date}: the new document refers to the original, the original is cancelled.',
  'record.doc.reissue.placeholder': 'What was corrected and why',
  'record.doc.reissue.help': 'Required: without a reason a reissue is indistinguishable from an unrelated document with the same lines.',
  'record.doc.reissue.missing': 'Enter the reason for reissue',
  'record.doc.ediContinue': 'Mark sent via EDI…',
  'record.doc.edi.title': 'Sending {number} via EDI',
  'record.doc.edi.help': 'The operator’s message id — it is used later to find out whether the document arrived.',
  'record.doc.edi.missing': 'Enter the message id',
  'record.doc.cancelContinue': 'Cancel…',
  'record.doc.cancel.title': 'Cancel {number}?',
  'record.doc.cancel.text': 'The document stays in the register as cancelled.',
  'record.doc.cancelled': 'The document is cancelled.',
  'record.doc.reissues.error': 'Could not load the reissue chain',
  'record.contract.title': 'Contract {number}',
  'record.contract.sections': 'Contract sections',
  'record.contract.stages': 'Contract lifecycle',
  'record.contract.organization': 'organization {org}',
  'record.contract.currency': 'currency',
  'record.contract.openFrom': 'from {date}, open-ended',
  'record.contract.since': 'since {date}',
  'record.contract.until': 'until {date}',
  'record.contract.stage.closed': 'Expired / Terminated',
  'record.contract.fact.term': 'Term',
  'record.contract.daysLeft': '{days} days left',
  'record.contract.expiredDays': 'expired {days} days ago',
  'record.contract.days': '{days} days',
  'record.contract.noAmount': 'no amount',
  'record.contract.activateContinue': 'Activate…',
  'record.contract.activate.overline': 'Activation',
  'record.contract.activate.openHelp': 'Empty — open-ended contract',
  'record.contract.activate.missing': 'Enter the signing date',
  'record.contract.prolongContinue': 'Extend…',
  'record.contract.prolong.overline': 'Extending the contract',
  'record.contract.prolong.title': 'Extend contract {number}',
  'record.contract.prolong.current': 'Current end date',
  'record.contract.prolong.help': 'Forward only: the new date is later than the current one. Shortening is termination.',
  'record.contract.prolong.missing': 'Enter the new end date',
  'record.contract.terminateContinue': 'Terminate…',
  'record.contract.terminate.title': 'Terminate contract {number}?',
  'record.contract.terminate.text': 'From the termination date no orders can be placed under the contract. Debts on issued invoices remain.',
  'record.contract.terminate.date': 'Termination date',
  'record.contract.terminate.help': 'Goes to the journal: the contract has no column for it.',
  'record.contract.terminate.missing': 'Enter the date and reason',
  'record.contract.terminate.irreversible': 'This cannot be undone — relations resume only with a new contract.',
  'record.contract.terminated': 'The contract is terminated.',
  'record.contract.tab.documents': 'Contract documents',
  'record.contract.invoices.empty': 'No invoices under the contract',
  'record.contract.documents.empty': 'No primary documents under the contract',
  'record.contract.documents.error': 'Could not load documents',
  'record.contract.documents.forbidden': 'Invoices and documents are not available to you',
  'record.contract.col.date': 'Date',
  'record.contract.col.total': 'Total',
  'record.contract.col.due': 'Due',
  'record.pay.title': 'Payment',
  'record.pay.sections': 'Payment sections',
  'record.pay.stages': 'Payment processing stages',
  'record.pay.stage.pending': 'Awaiting confirmation',
  'record.pay.stage.confirmed': 'Confirmed',
  'record.pay.stage.partial': 'Partly allocated',
  'record.pay.stage.matched': 'Allocated',
  'record.pay.noPayer': 'Payer not recognised',
  'record.pay.purposeQuoted': 'purpose “{purpose}”',
  'record.pay.confirm': 'Confirm payment',
  'record.pay.confirmed': 'Payment confirmed — it can be allocated.',
  'record.pay.autoMatch': 'Match invoices',
  'record.pay.matched': 'Allocated to invoices: {count}.',
  'record.pay.notMatched': 'Auto-matching found nothing — allocate manually.',
  'record.pay.reverseContinue': 'Reverse…',
  'record.pay.reverse': 'Reverse',
  'record.pay.reverse.title': 'Reverse payment {number}?',
  'record.pay.reverse.text': 'Allocations of {allocated} are removed and returned to invoices. The payment stays in the journal as “Reversed”.',
  'record.pay.reversed': 'The payment was reversed.',
  'record.pay.reversedText': 'The payment is reversed: allocations removed.',
  'record.pay.fact.amount': 'Amount',
  'record.pay.fact.allocated': 'Allocated',
  'record.pay.fact.unallocated': 'Unallocated',
  'record.pay.unallocatedShare': 'unallocated — {share} %',
  'record.pay.fullyAllocated': 'fully allocated',
  'record.pay.fact.account': 'Recipient account',
  'record.pay.fact.date': 'Payment date',
  'record.pay.valueDate': 'credited {date}',
  'record.pay.tab.alloc': 'Allocation',
  'record.pay.tab.details': 'Payment details',
  'record.pay.details': 'Payment order details',
  'record.pay.payerAccount': 'Payer account',
  'record.pay.alloc.title': 'Payer’s unpaid invoices',
  'record.pay.alloc.count': '{count} invoices',
  'record.pay.alloc.empty': '{payer} has no unpaid invoices',
  'record.pay.alloc.emptyText': 'The unallocated remainder stays as the counterparty’s advance and is offset against the next invoice.',
  'record.pay.alloc.noPayer': 'Payer not determined',
  'record.pay.alloc.noPayerText': 'A payment without a counterparty cannot be allocated: it is in the manual reconciliation queue on the bank reconciliation screen.',
  'record.pay.alloc.forbidden': 'Invoices are not available to you',
  'record.pay.alloc.error': 'Could not load the payer’s invoices',
  'record.pay.alloc.notAllocatable': 'The payment cannot be allocated in its current state — e.g. it is not confirmed yet.',
  'record.pay.alloc.summary': 'Allocated {allocated} of {amount} · {left} left',
  'record.pay.alloc.advance': 'The remainder of {left} stays as the counterparty’s advance.',
  'record.pay.col.invoice': 'Invoice',
  'record.pay.col.total': 'Invoice total',
  'record.pay.col.outstanding': 'Outstanding',
  'record.pay.col.allocate': 'Allocate',
  'record.pay.allocate': 'Allocate',
  'record.pay.amountFor': 'Amount for invoice {number}',
  // ---------- рабочие и аналитические экраны (партия C: согласования, задачи, уведомления, отчёты, рассылки)
  'wa.cancel': 'Cancel',
  'approvals.lead': 'Decisions waiting for you: discounts, payment terms, documents and requests above the approval thresholds.',
  'approvals.loading': 'Loading approvals',
  'approvals.forbidden.title': 'The Approvals section is not available to you',
  'approvals.forbidden.text': 'Approvals are available to roles with the approval right. If you stand in for a manager, ask them to set up a delegation — their queue will appear for you for that period.',
  'approvals.toMyDay': 'To My day',
  'approvals.error.title': 'Could not load the approval queue',
  'approvals.error.text': 'The approvals service did not respond. Decisions made before the failure are saved.',
  'approvals.tab.queue': 'My queue',
  'approvals.tab.delegation': 'Delegation',
  'approvals.queue.emptyText': 'New requests will arrive as notifications and appear here.',
  'approvals.queue.setupDelegation': 'Set up delegation',
  'approvals.queue.noMatch': 'Nothing matches the search.',
  'approvals.queue.footer': 'A decision goes straight to the requester and the next step of the chain.',
  'approvals.search': 'Search the queue',
  'approvals.searchPlaceholder': 'Document, client, No.',
  'approvals.chip.long': 'Waiting over a day',
  'approvals.bulk.label': 'Actions on selected requests',
  'approvals.bulk.selected': '{count} selected',
  'approvals.bulk.approve': 'Approve {count}',
  'approvals.bulk.clear': 'Clear selection',
  'approvals.bulk.hint': 'Reject one at a time, with a reason.',
  'approvals.selectAll': 'Select all requests',
  'approvals.select': 'Select {name}',
  'approvals.col.document': 'Document',
  'approvals.col.amount': 'Amount',
  'approvals.col.waits': 'Waiting',
  'approvals.col.step': 'Chain step',
  'approvals.col.decision': 'Decision',
  'approvals.waitLong': '{time} — over a day',
  'approvals.since': 'since {at}',
  'approvals.stepOf': 'Step {step} of {total}',
  'approvals.previousStep': 'before — {name} ✓',
  'approvals.rejectOpen': 'Reject…',
  'approvals.decideTitle': 'Decision on {name}',
  'approvals.commentPlaceholder': 'For example: margin below threshold, a smaller discount is fine with prepayment',
  'approvals.needCommentFor': 'Give a reason for rejecting — {name} will see it',
  'approvals.commentHelp': 'Required to reject, optional to approve.',
  'approvals.approveWithComment': 'Approve with comment',
  'approvals.keys': 'Ctrl ↵ — reject · Esc — cancel',
  'approvals.byRole': 'approver by role',
  'approvals.leaveDays': '{days} working days',
  'approvals.wait.minutes': '{count} min',
  'approvals.wait.hours': '{count} h',
  'approvals.wait.days': '{count} d',
  'approvals.delegation.badge': 'Delegation {period}: {name}',
  'approvals.delegation.error': 'Could not load delegations',
  'approvals.delegation.planned': 'Scheduled',
  'approvals.delegation.past': 'Past delegations',
  'approvals.delegation.noPast': 'No past delegations.',
  'approvals.delegation.thresholdsNote': 'The thresholds that route a request to you are set by the administrator in Approval thresholds. Here you only change who decides while you are away.',
  'approvals.delegation.revokeAsk': 'Revoke…',
  'approvals.delegation.revokeTitle': 'Revoke the delegation to {name}?',
  'approvals.delegation.revokeText': 'The signing right returns to you at once. The record stays in the history: who signed during this period must be visible a year later.',
  'approvals.delegation.new': 'New delegation',
  'approvals.delegation.noDirectory': 'There is nobody to choose from',
  'approvals.delegation.noDirectoryText': 'A delegate is a user account, and the user directory is open only with the Users right. Ask the administrator to set up the delegation or grant that right.',
  'approvals.delegation.toHelp': 'Active accounts only. Roles are not passed on — only your queue.',
  'approvals.delegation.from': 'From',
  'approvals.delegation.until': 'Until',
  'approvals.delegation.untilHelp': 'Empty — until revoked.',
  'approvals.delegation.badRange': 'The end date is before the start',
  'approvals.delegation.info': 'The delegate’s decisions are recorded in the documents’ history under their name; a decision made by the delegate cannot be undone.',
  'approvals.delegation.notify': 'The delegate sees your queue from the first day',
  'approvals.delegation.save': 'Save delegation',
  'approvals.delegation.fromOpen': 'from {from}, open-ended',
  'tasks.lead': 'Your open tasks. Overdue ones are always on top; X marks the selected one done.',
  'tasks.forbidden.title': 'Tasks are not available to you',
  'tasks.forbidden.text': 'No right to activities. A manager or administrator grants it.',
  'tasks.error.title': 'Could not load tasks',
  'tasks.error.text': 'The server did not respond. Tasks marked done before the failure are saved — retry.',
  'tasks.noEmployeeCard.text': 'Tasks are assigned to employees, and this account is not linked to an employee card — so it has no tasks and cannot have any. The administrator can link the account to an employee.',
  'tasks.segment': 'Period',
  'tasks.seg.all': 'All open',
  'tasks.seg.today': 'Today',
  'tasks.seg.overdue': 'Overdue',
  'tasks.seg.upcoming': 'Upcoming',
  'tasks.kind.call': 'Calls',
  'tasks.kind.meeting': 'Meetings',
  'tasks.kind.email': 'Emails',
  'tasks.kind.task': 'Tasks',
  'tasks.kind.note': 'Notes',
  'tasks.search': 'Search tasks',
  'tasks.loading': 'Loading tasks',
  'tasks.emptyText': 'Nothing overdue either. New tasks will appear here as soon as they are set.',
  'tasks.emptyFiltered': 'No tasks match this filter',
  'tasks.emptyFilteredText': 'There are open tasks in other groups.',
  'tasks.showAll': 'Show all · {count}',
  'tasks.list': 'Task list',
  'tasks.group.overdue': 'Overdue · {count}',
  'tasks.group.today': 'Today · {count}',
  'tasks.group.tomorrow': 'Tomorrow · {count}',
  'tasks.group.later': 'Later and undated · {count}',
  'tasks.overline': 'Task · {kind}',
  'tasks.overdueFlag': 'past due',
  'tasks.body': 'Description',
  'tasks.related': 'Related record',
  'tasks.today': 'Today',
  'tasks.tomorrow': 'Tomorrow',
  'notifications.lead': 'Events on your records, mentions by colleagues and system messages. Unread ones are highlighted and marked with a dot.',
  'notifications.forbidden.title': 'Notifications are not available to you',
  'notifications.forbidden.text': 'No right to the notification centre. The administrator grants it.',
  'notifications.error.title': 'Could not load notifications',
  'notifications.error.text': 'The server did not respond. Read marks did not change; new notifications keep arriving.',
  'notifications.show': 'Show',
  'notifications.seg.all': 'All',
  'notifications.seg.unread': 'Unread',
  'notifications.seg.mention': 'Mentions',
  'notifications.kind.info': 'System',
  'notifications.kind.warning': 'Warnings',
  'notifications.kind.task': 'Tasks',
  'notifications.kind.approval': 'Approvals',
  'notifications.kind.mention': 'Mentions',
  'notifications.kind.order': 'Orders',
  'notifications.loading': 'Loading notifications',
  'notifications.emptyText': 'New events appear here at once — live delivery needs no page reload.',
  'notifications.emptyFiltered': 'No new notifications',
  'notifications.emptyFilteredText': 'Nothing matches this filter; {count} notifications in total.',
  'notifications.showAll': 'Show all · {count}',
  'notifications.feed': 'Notification feed',
  'notifications.footer': 'A notification opens the record; reply to a mention in its discussion.',
  'notifications.unreadMark': 'Unread',
  'notifications.open': 'Open',
  'notifications.day.today': 'Today · {count}',
  'notifications.day.yesterday': 'Yesterday, {date} · {count}',
  'notifications.day.earlier': 'Earlier · {count}',
  'notifications.settings.open': 'Delivery settings',
  'notifications.settings.title': 'Where notifications go',
  'notifications.settings.lead': 'The notification centre always shows everything. Email can be switched on per kind — the letter arrives even when the CRM is closed.',
  'notifications.settings.loading': 'Loading settings',
  'notifications.settings.address': 'Letters go to {address}',
  'notifications.settings.noAddress': 'Your account has no email address — there is nowhere to send letters. An administrator sets the address.',
  'notifications.settings.mailOff': 'Company mail is not connected right now: letters do not go out and are recorded as refused. An administrator connects it.',
  'notifications.settings.table': 'Channels per notification kind',
  'notifications.settings.kind': 'Kind',
  'notifications.settings.inApp': 'In the centre',
  'notifications.settings.email': 'By email',
  'notifications.settings.inAppFor': '{kind}: in the notification centre (always)',
  'notifications.settings.emailFor': '{kind}: by email',
  'notifications.settings.save': 'Save',
  'notifications.settings.saved': 'Saved',
  'notifications.settings.unsubscribeNote': 'Every letter has an "Unsubscribe" link — it switches email off for its kind without signing in.',
  'notifications.kind.task_assigned': 'Assigned tasks',
  'notifications.settings.push': 'Push',
  'notifications.settings.pushFor': '{kind}: push to browser and phone',
  'notifications.settings.pushDevices': 'Push goes to devices: {count}',
  'notifications.settings.noPushDevices': 'Push has nowhere to go yet: enable browser notifications below or sign in to the mobile app.',
  'notifications.push.title': 'Browser notifications',
  'notifications.push.enable': 'Enable notifications in this browser',
  'notifications.push.disable': 'Disable',
  'notifications.push.on': 'Notifications are on in this browser — they arrive even with the CRM tab closed.',
  'notifications.push.notConnected': 'Browser notifications are not connected by an administrator (no VAPID keys).',
  'notifications.push.unsupported': 'This browser cannot do push notifications (or the CRM is not opened over https).',
  'notifications.push.denied': 'Notifications for the CRM site are blocked in the browser. Only the site settings of the browser can allow them.',
  'notifications.push.failed': 'Could not enable browser notifications. Try again.',
  'notifications.push.devices': 'My devices',
  'notifications.push.disabled': 'disabled: {reason}',
  'notifications.push.remove': 'Remove device {device}',
  'notifications.push.removeShort': 'Remove',
  'notifications.push.channel.webpush': 'Browser',
  'notifications.push.channel.fcm': 'Android (FCM)',
  'notifications.push.channel.rustore': 'Android (RuStore)',
  'rk.noValue': 'no data',
  'rk.error.text': 'The server did not respond. Other blocks are up to date.',
  'rk.days': '{days} d',
  'rk.quarter': 'Q{q} {year}',
  'rk.period.step': 'Period step',
  'rk.period.month': 'Month',
  'rk.period.quarter': 'Quarter',
  'rk.period.year': 'Year',
  'rk.period.prev': 'Previous period',
  'rk.period.next': 'Next period',
  'sr.total': 'Total',
  'sr.cut': 'Breakdown',
  'sr.dim.PRODUCT': 'Product',
  'sr.dim.PRODUCT_CATEGORY': 'Category',
  'sr.dim.EMPLOYEE': 'Manager',
  'sr.dim.COUNTERPARTY': 'Client',
  'sr.dim.DEPARTMENT': 'Department',
  'sr.dim.TERRITORY': 'Territory',
  'sr.empty.title': 'No data for {period} yet',
  'sr.empty.text': 'No shipments, deals or acquisition spend in the period.',
  'sr.empty.prev': 'Open {period}',
  'sr.fact.revenue': 'Revenue excl. VAT',
  'sr.fact.margin': 'Gross profit',
  'sr.fact.marginPct': 'margin {pct}',
  'sr.fact.won': 'Deals won',
  'sr.fact.cycle': 'Won deal cycle',
  'sr.fact.cycleSub': 'median · average {avg}',
  'sr.fact.lost': 'Lost',
  'sr.fact.lostSub': '{sum} · most often — {reason}',
  'sr.pnl.title': 'Profit and loss — {cut}',
  'sr.pnl.noVat': 'amounts excl. VAT',
  'sr.pnl.gross': 'Gross profit',
  'sr.pnl.share': 'Revenue share',
  'sr.pnl.shareOf': 'Revenue share {pct}',
  'sr.pnl.unassigned': 'Not set',
  'sr.pnl.footer': 'Cost is a snapshot at the deal date. Margin of a line without cost is a dash, not zero.',
  'sr.pnl.noNames': 'This breakdown has no reference list of its own — rows are labelled by identifier.',
  'sr.pnl.error': 'P&L could not be built',
  'sr.pnl.empty': 'No sales in the period',
  'sr.funnel.title': 'Funnel conversion by stage',
  'sr.funnel.none': 'No funnels',
  'sr.funnel.noneText': 'The administrator creates a funnel in Funnels and stages.',
  'sr.funnel.error': 'Conversion could not be calculated',
  'sr.funnel.empty': 'The funnel has no stages',
  'sr.cycle.error': 'Deal cycle could not be calculated',
  'sr.cycle.deals': 'over {count} won deals',
  'sr.cycle.perStage': 'Days in stage, average',
  'sr.cac.title': 'CAC and LTV/CAC by channel',
  'sr.cac.error': 'CAC could not be calculated',
  'sr.cac.empty': 'No new clients in the period',
  'sr.cac.new': 'New',
  'sr.cac.noChannel': 'No channel',
  'sr.cac.pays': 'pays off',
  'sr.cac.edge': 'borderline',
  'sr.cac.loss': 'does not pay off',
  'sr.cac.footer': 'CAC is channel spend ÷ new clients. LTV is by margin, not revenue. A channel without spend is a dash, not free clients.',
  'sr.cac.thresholds': 'LTV/CAC of 3+ pays off, 1 to 3 is borderline, under 1 does not pay off.',
  'sr.losses.count': '{count} deals · {sum}',
  'sr.losses.by': 'Bar length',
  'sr.losses.byCount': 'By count',
  'sr.losses.byAmount': 'By amount',
  'sr.losses.footer': 'The manager picks the reason when closing a deal, from the reasons list.',
  'sr.losses.error': 'Loss reasons could not be loaded',
  'sr.losses.empty': 'No lost deals in the period',
  'fr.lead': 'How much we are owed and when, and how much money came in and is expected. Actuals and forecast are separate series and are not added up.',
  'fr.loading': 'Loading finance reports',
  'fr.ar.title': 'Receivables by age',
  'fr.ar.count': '{count} clients',
  'fr.ar.openInvoices': 'Open invoices',
  'fr.ar.forbidden': 'Receivables are not available to you',
  'fr.ar.error': 'Receivables could not be loaded',
  'fr.ar.empty': 'No unpaid invoices',
  'fr.ar.emptyText': 'Receivables appear with the first invoice that is not yet paid.',
  'fr.ar.mixedCurrency': 'Invoices in several currencies: bucket totals are not added up — adding roubles to euros would invent a rate. Amounts are shown per client.',
  'fr.ar.overdueFlag': 'Overdue {sum} · {pct} · {count} clients',
  'fr.ar.buckets': 'Receivables by bucket',
  'fr.ar.term': 'Term',
  'fr.ar.shareBar': 'Share of all receivables',
  'fr.ar.share': 'Share',
  'fr.ar.clients': 'Clients',
  'fr.ar.totalNote': 'a client with several invoices can fall into several terms',
  'fr.ar.debtors': 'Debtors — by overdue amount',
  'fr.ar.noOverdue': 'No overdue debts.',
  'fr.ar.debtTotal': 'Total debt',
  'fr.bucket.notYetDue': 'Not yet due',
  'fr.dds.title': 'Cash flow',
  'fr.dds.forbidden': 'Cash flow is not available to you',
  'fr.dds.chooseOrg': 'Choose an organisation',
  'fr.dds.chooseOrgText': 'Cash is counted per legal entity. There are several, and picking the first one would show someone else’s money — choose whose to view.',
  'fr.dds.legend': 'Chart legend',
  'fr.dds.fact': 'Actual from statements — {period}',
  'fr.dds.raw': 'Raw forecast — all expected payments, 6 weeks',
  'fr.dds.weighted': 'Weighted forecast — by probability, 6 weeks',
  'fr.dds.factShort': 'actual',
  'fr.dds.rawShort': 'raw forecast',
  'fr.dds.weightedShort': 'weighted forecast',
  'fr.dds.thousands': 'thousand {currency}',
  'fr.dds.factTitle': 'Actual — {period}',
  'fr.dds.planTitle': 'Six-week forecast',
  'fr.dds.factTable': 'Actual cash flow by item',
  'fr.dds.planTable': 'Forecast of receipts and payments',
  'fr.dds.factError': 'Actuals could not be loaded',
  'fr.dds.planError': 'Forecast could not be loaded',
  'fr.dds.factEmpty': 'No account movements in the period',
  'fr.dds.planEmpty': 'No expected payments in the next 6 weeks',
  'fr.dds.rawCol': 'Raw',
  'fr.dds.weightedCol': 'Weighted',
  'fr.org.forbidden': 'The organisation list is not available',
  'fr.org.error': 'Organisations could not be loaded',
  'wr.lead': 'What sits still, what to keep in stock and what to order on demand; how pickers and suppliers perform.',
  'wr.forbidden.title': 'Warehouse reports are not available to you',
  'wr.forbidden.text': 'Rights to stock, pick tasks or receipts are needed. The administrator grants them.',
  'wr.empty.title': 'No reports for {period} yet',
  'wr.empty.text': 'No movements, picks or receipts in the period. Dead stock below is counted over six months.',
  'wr.turn.title': 'Turnover by item',
  'wr.turn.footer': 'Slowest on top. Turnover with zero stock is a dash: an item that ran out is not the fastest-moving.',
  'wr.safety': 'safety stock',
  'wr.abc.title': 'ABC/XYZ matrix',
  'wr.abc.count': '{count} items',
  'wr.abc.error': 'ABC/XYZ could not be calculated',
  'wr.abc.empty': 'No stock sales in the period',
  'wr.mx.label': 'ABC/XYZ: rows — share of turnover, columns — demand stability',
  'wr.xyz.X': 'stable demand',
  'wr.xyz.Y': 'fluctuating',
  'wr.xyz.Z': 'sporadic demand',
  'wr.mx.key': 'key',
  'wr.mx.std': 'standard',
  'wr.mx.order': 'to order',
  'wr.mx.out': 'phase out',
  'wr.mx.unknown': '{count} more items without history — under two months of sales, no spread to measure.',
  'wr.dead.title': 'Dead stock — no movement over {days} days',
  'wr.dead.count': '{count} items · since {since}',
  'wr.dead.error': 'Dead stock could not be loaded',
  'wr.dead.empty': 'No dead stock',
  'wr.dead.last': 'Last movement',
  'wr.dead.days': 'Days idle',
  'wr.warehouse': 'Warehouse',
  'wr.pick.title': 'Picker performance',
  'wr.pick.error': 'Performance could not be calculated',
  'wr.pick.empty': 'No pick tasks in the period',
  'wr.pick.hours': 'Hours worked',
  'wr.pick.skipped': 'Lines skipped',
  'wr.sup.title': 'Supplier quality',
  'wr.sup.error': 'Supplier quality could not be calculated',
  'wr.sup.empty': 'No receipts in the period',
  'wr.sup.accepted': 'Accepted, pcs',
  'wr.sup.defect': 'Defects',
  'wr.sup.defectAria': 'Defects {pct}',
  'wr.sup.withDefects': 'Receipts with defects',
  'wr.sup.footer': 'Defects and shortfall are counted separately: they are different claims against the supplier.',
  'wr.pcs': 'pcs',
  'rm.new': 'New mailing',
  'rm.lead': 'Reports arrive by email on schedule as a CSV attachment. Times follow the server clock.',
  'rm.forbidden.title': 'Managing mailings is not available to you',
  'rm.forbidden.text': 'Schedules are set up by roles with the reports right. If you receive a report by email, ask the mailing author to remove the address.',
  'rm.toDashboards': 'To dashboards',
  'rm.error.title': 'Could not load mailings',
  'rm.error.text': 'The scheduler did not respond. Schedules have not changed — only the list failed.',
  'rm.empty.title': 'No mailings yet',
  'rm.empty.text': 'Set up the first one — for example, a sales report every Monday at 8:00.',
  'rm.search': 'Report or address',
  'rm.chip.off': 'Disabled',
  'rm.chip.broken': 'No next run',
  'rm.col.when': 'Frequency',
  'rm.col.recipients': 'Recipients',
  'rm.col.active': 'Enabled',
  'rm.col.actions': 'Actions',
  'rm.more': 'and {count} more',
  'rm.broken': 'Not scheduled — check the schedule',
  'rm.neverRan': 'never run',
  'rm.activeLabel': 'Mailing “{name}” enabled',
  'rm.on': 'On',
  'rm.off': 'Off',
  'rm.actions': 'Actions: {name}',
  'rm.edit': 'Edit',
  'rm.deleteAsk': 'Delete mailing…',
  'rm.deleteTitle': 'Delete the mailing “{name}”?',
  'rm.deleteText': 'No more emails will be sent on this schedule. The report itself stays.',
  'rm.footer': '{count} mailings · {active} enabled',
  'rm.sheet.overline': 'Report mailing',
  'rm.sheet.edit': 'Edit mailing',
  'rm.close': 'Close',
  'rm.noReports': 'No saved reports — build one in the report builder first.',
  'rm.mode.daily': 'Daily',
  'rm.mode.weekly': 'Weekly',
  'rm.mode.monthly': 'Monthly',
  'rm.mode.cron': 'Custom (cron)',
  'rm.days': 'Days of week',
  'rm.daysRequired': 'Choose at least one day',
  'rm.dow.1': 'Mon',
  'rm.dow.2': 'Tue',
  'rm.dow.3': 'Wed',
  'rm.dow.4': 'Thu',
  'rm.dow.5': 'Fri',
  'rm.dow.6': 'Sat',
  'rm.dow.0': 'Sun',
  'rm.dayOfMonth': 'Day of month',
  'rm.dayOfMonthHelp': '1 to 28 — every month has that day.',
  'rm.time': 'Time',
  'rm.serverTime': 'Server clock',
  'rm.cronHelp': 'Five fields: minute, hour, day, month, weekday. The server checks it on save.',
  'rm.describe.daily': 'Every day at {time}',
  'rm.describe.weekly': 'Weekly: {days} at {time}',
  'rm.describe.monthly': 'Monthly on day {day} at {time}',
  'rm.describe.raw': 'On schedule {cron}',
  'rm.emailPlaceholder': 'Email address',
  'rm.addEmail': 'Add',
  'rm.removeEmail': 'Remove {email}',
  'rm.recipientsHelp': 'A recipient is a CRM account: the report is built with their rights, so the file holds exactly what they would get exporting it themselves. Without access to the report data they get no letter — the reason shows in the delivery log. Outside addresses are not accepted.',
  'rm.deliveries': 'Delivery log',
  'rm.deliveries.empty': 'No letters yet.',
  'rm.deliveries.rows': '{count} rows',
  'rm.deliveries.retry': 'retry after {when}',
  'rm.delivery.pending': 'queued',
  'rm.delivery.sending': 'sending',
  'rm.delivery.sent': 'sent',
  'rm.delivery.failed': 'not sent, will retry',
  'rm.delivery.rejected': 'not sent',
  'rm.formatHelp': 'XLSX opens in Excel as is: sums as numbers, dates as dates. CSV is plain text for any program. The server does not produce PDF.',
  'rm.escHint': 'Esc — close without saving',
  'rm.save': 'Save',
  'rm.create': 'Create mailing',
  'rb.crumb': 'Builder',
  'rb.loading': 'Loading the builder',
  'rb.forbidden.title': 'The report builder is not available to you',
  'rb.forbidden.text': 'No right to reports. The administrator grants it.',
  'rb.error.title': 'Could not load data marts',
  'rb.untitled': 'New report',
  'rb.readOnly': 'View only — reports cannot be saved',
  'rb.savedAt': 'saved {at}',
  'rb.exportCsv': 'Export CSV',
  'rb.needMeasure': 'Add at least one measure',
  'rb.needName': 'Enter a name and a code',
  'rb.menu': 'More report actions',
  'rb.source.title': 'Data source',
  'rb.source.help': '{count} fields',
  'rb.noSourcesText': 'No data mart is open to you: the administrator grants source rights. A form without a source would build nothing.',
  'rb.fields': 'Mart fields',
  'rb.findField': 'Find a field',
  'rb.fieldsHelp': 'Click or Enter — the field goes to the matching row by type.',
  'rb.fieldAria': '{name}, {kind}',
  'rb.kind.dim': 'dimension',
  'rb.kind.num': 'measure',
  'rb.kind.flt': 'filter',
  'rb.used.dimension': 'dimension',
  'rb.used.measure': 'measure',
  'rb.used.filter': 'filter',
  'rb.structure': 'Report structure',
  'rb.structureHint': 'dimensions are rows, measures are numbers in columns',
  'rb.reset': 'Reset',
  'rb.dimensionsEmpty': 'No dimensions — a single total row',
  'rb.removeDimension': 'Remove dimension {name}',
  'rb.removeMeasure': 'Remove measure {name}',
  'rb.removeFilter': 'Remove condition {name}',
  'rb.aggregateFor': 'Aggregate for {name}',
  'rb.sort': 'Sorting',
  'rb.sortChoose': 'Choose a column',
  'rb.sortEmpty': 'Add a dimension or a measure first',
  'rb.sortDirection': 'Toggle direction',
  'rb.removeSort': 'Remove sorting',
  'rb.asc': 'ascending',
  'rb.desc': 'descending',
  'rb.preview': 'Preview',
  'rb.previewError': 'The preview could not be built',
  'rb.forbiddenSourceText': 'Your role has no right to this report’s source. Choose another mart or request access.',
  'rb.chooseSource': 'Choose a data mart',
  'rb.chooseSourceText': 'On the left are the marts open to your role. Or run a saved report.',
  'rb.noMeasure': 'Add at least one measure — there is nothing to count without it',
  'rb.noMeasureText': 'Dimensions set the rows, measures the numbers in the columns.',
  'rb.addFirstMeasure': 'Add “{name}”',
  'rb.pressPreview': 'Press Preview to build the report',
  'rb.resultEmpty': 'No data matches the report',
  'rb.previewFooter': 'Preview: first rows ({count}). The full result is in the saved report’s export.',
  'rb.savedMenu': 'More actions: {name}',
  'rb.deleteTitle': 'Delete the report “{name}”?',
  'rb.deleteText': 'The report disappears from the list and its mailings stop.',
  // admin (design)
  'adm.actions': 'Actions',
  'adm.close': 'Close',
  'adm.escHint': 'Esc — close without saving',
  'adm.saving': 'Saving…',
  'adm.retry': 'Retry',
  'adm.on': 'On',
  'adm.off': 'Off',
  'adm.enabled': 'Enabled',
  'adm.disabled': 'Disabled',
  'adm.enabledColumn': 'Enabled',
  'adm.status': 'Status',
  'adm.resetFilters': 'Reset filters',
  'adm.resetSearch': 'Clear search',
  'adm.ofTotal': '{shown} of {total}',
  'adm.ro.title': 'View only.',
  'adm.ro.text': 'Your role has no right to change system settings. Changes are made by the system administrator.',
  'adm.state.forbidden.title': 'This section is not available to you',
  'adm.state.forbidden.text': 'Your role has no right to this administration section. If you need it for work, ask the system administrator.',
  'adm.state.home': 'Go home',
  'adm.state.error.title': 'Could not load the data',
  'adm.state.error.text': 'The server did not answer. Saved settings keep working — try again.',
  'adm.savebar': 'Unsaved changes',
  'adm.savebar.count': 'Unsaved changes: {count}',
  'adm.savebar.reset': 'Discard changes',
  'adm.color.gray': 'Grey',
  'adm.color.blue': 'Blue',
  'adm.color.teal': 'Teal',
  'adm.color.green': 'Green',
  'adm.color.amber': 'Amber',
  'adm.color.orange': 'Orange',
  'adm.color.red': 'Red',
  'adm.color.purple': 'Purple',
  'adm.color.none': 'no colour',
  'adm.users.lead': 'Accounts for signing in: roles and their terms, link to the employee card, blocking. Passwords are not stored or shown here — sign-in goes through the corporate service.',
  'adm.users.ro': 'Only a role with the right to manage accounts can create users, grant roles and block.',
  'adm.users.forbidden': 'The user list is not available to you',
  'adm.users.error': 'Could not load users',
  'adm.users.roleFilter': 'Role',
  'adm.users.roleAll': 'Role: all',
  'adm.users.status': 'Account status',
  'adm.users.status.all': 'All',
  'adm.users.status.active': 'Active',
  'adm.users.status.blocked': 'Blocked',
  'adm.users.temporary': 'With temporary roles',
  'adm.users.empty': 'No users yet',
  'adm.users.emptyFiltered': 'No users match these filters',
  'adm.users.emptyFiltered.text': 'Blocked accounts are listed under “Blocked” — they can be unblocked there.',
  'adm.users.showBlocked': 'Show blocked',
  'adm.users.contact': 'Email',
  'adm.users.card': 'Employee card',
  'adm.users.sso': 'SSO: corporate sign-in',
  'adm.users.external': 'external client account',
  'adm.users.noRoles': 'no roles',
  'adm.users.actions': 'Actions: {name}',
  'adm.users.grant': 'Grant role…',
  'adm.users.revokeRole': 'Revoke role “{role}”',
  'adm.users.lastSuperadmin.revoke': 'This is the last active superadmin. Grant the Superadmin role to someone else first.',
  'adm.users.lastSuperadmin.block': 'This is the last active superadmin: once blocked, nobody could administer the system.',
  'adm.users.unlinkSso': 'Unlink the external (SSO) account',
  'adm.users.blockConfirm': 'Block {name}?',
  'adm.users.blockConfirm.text': 'The user will not be able to sign in. Their records and history stay; unblock from the same menu.',
  'adm.users.overline': 'Administration · Users',
  'adm.users.create': 'Create user',
  'adm.users.loginHelp': 'The first sign-in links the account to the corporate service by login',
  'adm.users.phone': 'Phone',
  'adm.users.contactRequired': 'Enter an email or a phone — at least one. Access is restored through them.',
  'adm.users.rolesHelp': 'Rights add up across roles. Superadmin is not granted here — only by a separate action.',
  'adm.users.addRole': 'Add role',
  'adm.users.removeRole': 'Remove role {role}',
  'adm.users.linkEmployee': 'Link to employee',
  'adm.users.linkEmployeeHelp': 'Leave, tasks and “own” records come from the employee card',
  'adm.users.sheet': 'User',
  'adm.users.editForm': 'Account',
  'adm.users.grantTitle': 'Grant role — {name}',
  'adm.users.grantForm': 'Role grant',
  'adm.users.grantSave': 'Grant role',
  'adm.users.now': 'now: {roles}',
  'adm.users.role': 'Role',
  'adm.users.addsTo': 'Adds to roles: {roles}',
  'adm.users.until': 'Valid until',
  'adm.users.untilHelp': 'A temporary role — e.g. a stand-in during leave. Empty means no end.',
  'adm.users.untilNote': 'After {date} the role stops applying by itself.',
  'adm.roles.title': 'Roles and permission matrix',
  'adm.roles.lead': 'What each role may do with each section’s records and how widely: own records, the department’s or the whole company’s. Rights of a user with several roles add up.',
  'adm.roles.ro': 'Only a role with the right to manage roles can change role rights.',
  'adm.roles.forbidden': 'Roles and rights are not available to you',
  'adm.roles.error': 'Could not load roles and rights',
  'adm.roles.list': 'Roles',
  'adm.roles.systemNote': 'Built-in roles cannot be deleted or renamed',
  'adm.roles.kind.system': 'built-in',
  'adm.roles.kind.own': 'custom',
  'adm.roles.holders': 'users: {count}',
  'adm.roles.inherits': 'inherits from {code}',
  'adm.roles.copy': 'Copy role',
  'adm.roles.rename': 'Rename role',
  'adm.roles.delete': 'Delete role',
  'adm.roles.delete.system': 'A built-in role cannot be deleted: code and seeds refer to it.',
  'adm.roles.delete.holders': 'The role is held by users ({count}). Revoke it from them first.',
  'adm.roles.deleteConfirm': 'Delete role “{name}”?',
  'adm.roles.deleteConfirm.text': 'The role and its rights are deleted. Its code stays taken — a new role cannot reuse it.',
  'adm.roles.more': 'More: rename, delete role',
  'adm.roles.superadmin.title': 'The built-in Superadmin role is not editable:',
  'adm.roles.discard': 'Discard unsaved rights changes?',
  'adm.roles.empty': 'Role “{name}” has no rights yet',
  'adm.roles.empty.text': 'A user with only this role sees an empty menu. Take a similar role’s rights as a base, or set the cells in the matrix by hand.',
  'adm.roles.copyFrom': 'Copy rights from role…',
  'adm.roles.copyRights': 'Copy',
  'adm.roles.tabs': 'Role rights',
  'adm.roles.tab.records': 'Record rights',
  'adm.roles.tab.fields': 'Field rights',
  'adm.roles.tab.users': 'Role users',
  'adm.roles.legend.none': 'no right',
  'adm.roles.legend.own': 'where they are responsible',
  'adm.roles.legend.department': 'their department and sub-departments',
  'adm.roles.legend.all': 'the whole company',
  'adm.roles.legend.changed': 'changed, not saved',
  'adm.roles.noRight': '— no right',
  'adm.roles.inheritedShort': 'inh.: {scope}',
  'adm.roles.noPermissions': 'There are no record rights in the system',
  'adm.roles.noFieldRights': 'There are no field rights in the system',
  'adm.roles.fields.sub': 'on top of record rights: the record is visible, a single field is not',
  'adm.roles.fields.note': 'A hidden field shows as “Hidden by rights” and is empty in exports.',
  'adm.roles.systemOn': 'On · built-in',
  'adm.roles.change': '{what}: {from} → {to}',
  'adm.roles.appliesTo': 'Applies to the role’s users ({count}) right after saving',
  'adm.roles.users.forbidden': 'The user list is not available to you',
  'adm.roles.users.forbidden.text': 'Who holds the role is visible with the right to manage accounts.',
  'adm.roles.users.empty': 'Nobody holds this role yet',
  'adm.roles.users.user': 'User',
  'adm.roles.users.term': 'Role term',
  'adm.roles.users.forever': 'no end',
  'adm.roles.overline': 'Administration · Roles',
  'adm.roles.create': 'Create role',
  'adm.roles.copyTitle': 'Copy of “{name}”',
  'adm.roles.copyName': '{name} (copy)',
  'adm.roles.codeHelp': 'Latin letters, digits and _. The code never changes and is not freed after deletion.',
  'adm.roles.parentHelp': 'Ancestor rights pass to the role and are removed only on the ancestor',
  'adm.roles.renameHelp': 'Was: “{name}”',
  'adm.roles.description': 'Description',
  'adm.roles.group.other': 'Other',
  'adm.action.read': 'Read',
  'adm.action.create': 'Create',
  'adm.action.update': 'Edit',
  'adm.action.delete': 'Delete',
  'adm.action.approve': 'Approve',
  'adm.action.export': 'Export',
  'adm.action.import': 'Import',
  'adm.resource.system.settings': 'System settings',
  'adm.resource.analytics.report': 'Reports',
  'adm.resource.sales.activity': 'Tasks and activities',
  'adm.resource.sales.plan': 'Sales plans',
  'adm.resource.sales.pricelist': 'Price lists',
  'adm.resource.sales.order': 'Customer orders',
  'adm.resource.payments.payment': 'Payments',
  'adm.resource.hr.candidate': 'Candidates',
  'adm.resource.hr.timesheet': 'Timesheet',
  'adm.resource.system.comment': 'Comments',
  'adm.resource.system.integration': 'Integrations',
  'adm.resource.warehouse.topology': 'Warehouses and cells',
  'adm.resource.warehouse.writeoff': 'Write-offs',
  'adm.audit.lead': 'Who changed what and when, in data and rights. Journal entries cannot be edited or deleted — the system writes them.',
  'adm.audit.forbidden': 'The audit journal is not available to you',
  'adm.audit.error': 'Could not load the journal',
  'adm.audit.actorPh': 'User: login',
  'adm.audit.typeAll': 'Record type: all',
  'adm.audit.actionAll': 'Action: all',
  'adm.audit.none': 'The journal has no entries yet',
  'adm.audit.empty.text': 'The filters together match no entries. Looking for a lost record? Drop the user filter — someone else may have changed it.',
  'adm.audit.details': 'Details',
  'adm.audit.what': 'What',
  'adm.audit.show': 'Show changes: {what}',
  'adm.audit.hide': 'Hide changes: {what}',
  'adm.audit.fields': 'fields: {count}',
  'adm.audit.nil': 'empty',
  'adm.audit.was': 'was:',
  'adm.audit.became': 'became:',
  'adm.audit.action.INSERT': 'Created',
  'adm.audit.action.UPDATE': 'Edited',
  'adm.audit.action.DELETE': 'Deleted',
  'adm.audit.action.PERMISSIONS': 'Rights changed',
  'adm.audit.action.TAGS': 'Tags',
  'adm.entity.Deal': 'Deal',
  'adm.entity.DealItem': 'Deal line',
  'adm.entity.Counterparty': 'Counterparty',
  'adm.entity.Contact': 'Contact',
  'adm.entity.Lead': 'Lead',
  'adm.entity.Quote': 'Quote',
  'adm.entity.Contract': 'Contract',
  'adm.entity.Invoice': 'Invoice',
  'adm.entity.PrimaryDocument': 'Primary document',
  'adm.entity.Payment': 'Payment',
  'adm.entity.Product': 'Product',
  'adm.entity.Shipment': 'Shipment',
  'adm.entity.GoodsReceipt': 'Goods receipt',
  'adm.entity.StockTransfer': 'Transfer',
  'adm.entity.Stocktake': 'Stocktake',
  'adm.entity.Employee': 'Employee',
  'adm.entity.Department': 'Department',
  'adm.entity.LeaveRequest': 'Leave request',
  'adm.entity.Vacancy': 'Vacancy',
  'adm.entity.AppUser': 'User',
  'adm.entity.Role': 'Role',
  'adm.entity.UserRole': 'User role',
  'adm.entity.RolePermission': 'Role right',
  'adm.entity.SystemSettings': 'System settings',
  'adm.entity.NumberSequence': 'Numbering',
  'adm.entity.ApprovalThreshold': 'Approval threshold',
  'adm.entity.Currency': 'Currency',
  'adm.entity.UnitOfMeasure': 'Unit of measure',
  'adm.entity.Funnel': 'Funnel',
  'adm.entity.FunnelStage': 'Funnel stage',
  'adm.entity.LeadDistributionRule': 'Distribution rule',
  'adm.entity.DealReason': 'Close reason',
  'adm.entity.Tag': 'Tag',
  'adm.entity.Segment': 'Segment',
  'adm.entity.Activity': 'Activity',
  'adm.entity.Warehouse': 'Warehouse',
  'adm.settings.lead': 'Company-wide rules: the working calendar and values filled into new documents. Changes apply to everyone right after saving.',
  'adm.settings.ro': 'Settings are changed by the system administrator.',
  'adm.settings.forbidden': 'System settings are not available to you',
  'adm.settings.error': 'Could not load the settings',
  'adm.settings.history': 'Change history',
  'adm.settings.calendar': 'Working calendar',
  'adm.settings.calendar.text': 'The company’s working days and hours. SLAs, task deadlines and “working day” terms will count by them.',
  'adm.settings.days.help': 'A pressed day is a working day',
  'adm.settings.noDays': 'Mark at least one working day',
  'adm.settings.endBeforeStart': 'The working day ends before it starts. Enter a time after {start}.',
  'adm.settings.tz.help': 'Times in documents and deadlines count in this zone',
  'adm.settings.defaults': 'Defaults',
  'adm.settings.defaults.text': 'Filled into new documents. Each document can change it.',
  'adm.settings.org.help': 'Which legal entity issues documents when none is chosen',
  'adm.settings.noOrganization': '— not chosen —',
  'adm.tz.Europe/Kaliningrad': 'Kaliningrad, UTC+2',
  'adm.tz.Europe/Moscow': 'Moscow, UTC+3',
  'adm.tz.Europe/Samara': 'Samara, UTC+4',
  'adm.tz.Asia/Yekaterinburg': 'Yekaterinburg, UTC+5',
  'adm.tz.Asia/Omsk': 'Omsk, UTC+6',
  'adm.tz.Asia/Novosibirsk': 'Novosibirsk, UTC+7',
  'adm.tz.Asia/Krasnoyarsk': 'Krasnoyarsk, UTC+7',
  'adm.tz.Asia/Irkutsk': 'Irkutsk, UTC+8',
  'adm.tz.Asia/Yakutsk': 'Yakutsk, UTC+9',
  'adm.tz.Asia/Vladivostok': 'Vladivostok, UTC+10',
  'adm.tz.Asia/Magadan': 'Magadan, UTC+11',
  'adm.tz.Asia/Kamchatka': 'Kamchatka, UTC+12',
  'adm.numbering.lead': 'The number mask and counter reset period for each document type. Types are fixed — none can be added, so the screen only edits masks.',
  'adm.numbering.ro': 'Masks are changed by the system administrator.',
  'adm.numbering.forbidden': 'Document numbering is not available to you',
  'adm.numbering.error': 'Could not load numbering settings',
  'adm.numbering.count': 'types: {count}',
  'adm.numbering.search': 'Document or mask',
  'adm.numbering.section': 'Section',
  'adm.numbering.section.all': 'All',
  'adm.numbering.section.sales': 'Sales',
  'adm.numbering.section.warehouse': 'Warehouse',
  'adm.numbering.section.finance': 'Finance',
  'adm.numbering.section.hr': 'HR',
  'adm.numbering.setup': 'No number masks are set',
  'adm.numbering.setup.text': 'Numbering is created by a migration. An empty list means it did not run: documents cannot get a number — tell the system administrator.',
  'adm.numbering.empty': 'No documents match “{query}”',
  'adm.numbering.empty.text': 'The list of types is fixed. Check the spelling or reset the section.',
  'adm.numbering.reset': 'Reset',
  'adm.numbering.current': 'Current value',
  'adm.numbering.actions': 'Actions: {doc}',
  'adm.numbering.tokens': 'Mask tokens: {YYYY} year, {YY} two-digit year, {MM} month, {N…} counter, the number of Ns is the zero-padded width. A new mask applies to documents created after saving; issued numbers do not change.',
  'adm.numbering.sheetTitle': '{doc} — mask and counter',
  'adm.numbering.form': 'Number mask',
  'adm.numbering.mask.help': 'One {N…} counter is required.',
  'adm.numbering.insert': 'Insert:',
  'adm.numbering.reset.help': 'Never · Yearly — 1 January · Monthly — the 1st. A reset without the year or month in the mask repeats numbers — the server refuses it.',
  'adm.numbering.previewOk': 'mask accepted',
  'adm.numbering.current.help': 'The last issued number. The next document gets +1. The counter cannot be lowered — numbers would repeat.',
  'adm.numbering.note': 'A new mask applies to documents created after saving. Issued numbers do not change.',
  'adm.numbering.fixFirst': 'Fix the mask to save',
  'adm.thresholds.lead': 'When a document goes for approval and who approves it. Rules of one document type are steps: each triggered step adds an approver, approvals follow step order.',
  'adm.thresholds.ro': 'Thresholds are changed by the system administrator.',
  'adm.thresholds.forbidden': 'Approval thresholds are not available to you',
  'adm.thresholds.error': 'Could not load approval rules',
  'adm.thresholds.count': 'rules: {count}',
  'adm.thresholds.allTypes': 'All types',
  'adm.thresholds.activeOnly': 'Enabled only',
  'adm.thresholds.empty': 'No approval rules',
  'adm.thresholds.empty.text': 'Documents go through without approval now — at any discount and amount. Start with a discount threshold.',
  'adm.thresholds.noneHere': 'No rules match these filters',
  'adm.thresholds.chain': 'Chain for “{type}”',
  'adm.thresholds.steps': 'steps: {count}',
  'adm.thresholds.step': 'Step {n}',
  'adm.thresholds.chain.text': 'If several steps trigger, they are approved in order. Disabled rules are not part of the chain.',
  'adm.thresholds.byRole': 'role “{role}”',
  'adm.thresholds.role': 'Role',
  'adm.thresholds.user': 'User',
  'adm.thresholds.rule': 'Rule: {name}',
  'adm.thresholds.actions': 'Actions: {name}',
  'adm.thresholds.escalates': 'escalates after {hours} h',
  'adm.thresholds.discount': 'Discount',
  'adm.thresholds.amount': 'Amount',
  'adm.thresholds.from': 'from',
  'adm.thresholds.if': 'If',
  'adm.thresholds.overline': 'Approval rule',
  'adm.thresholds.editTitle': '{type} — step {n}',
  'adm.thresholds.newTitle': 'New rule',
  'adm.thresholds.step.help': 'Approved in step order',
  'adm.thresholds.condition.help': 'Any of the set conditions triggers. An empty field means no condition on it, not zero.',
  'adm.thresholds.needCondition': 'Set a discount or an amount — at least one',
  'adm.thresholds.approverKind': 'Who approves',
  'adm.thresholds.approver.help': 'Role — any holder approves. User — always one person; their stand-in during leave.',
  'adm.thresholds.needApprover': 'Choose an approver',
  'adm.thresholds.escalate.help': 'Empty — no escalation',
  'adm.thresholds.ruleOn': 'Rule enabled',
  'adm.currency.lead': 'Currencies for prices, invoices and purchasing. Currencies are never deleted: documents refer to them. An existing currency code never changes.',
  'adm.currency.ro': 'Currencies are added by the system administrator.',
  'adm.currency.forbidden': 'The currency list is not available to you',
  'adm.currency.error': 'Could not load currencies',
  'adm.currency.search': 'Code or name',
  'adm.currency.setup': 'The currency list is empty',
  'adm.currency.setup.text': 'Currencies come from a migration; an empty list means it did not run. No invoice can be issued without currencies.',
  'adm.currency.empty': 'No currency “{query}”',
  'adm.currency.addCode': 'Add {code}',
  'adm.currency.code': 'Code',
  'adm.currency.actions': 'Actions: {code}',
  'adm.currency.new': 'New currency',
  'adm.currency.code.help': '3 Latin letters, ISO 4217',
  'adm.currency.codeInvalid': '3 Latin letters, ISO 4217 — {count} entered',
  'adm.currency.numeric.help': '3 digits, ISO 4217',
  'adm.currency.numericInvalid': '3 digits, ISO 4217',
  'adm.currency.codeLocked': 'The code cannot change after creation',
  'adm.currency.numericLocked': 'Bound to the code by ISO 4217',
  'adm.currency.newNote': 'After saving the code cannot be changed — check it against ISO 4217.',
  'adm.currency.symbol.help': 'Printed after the amount',
  'adm.currency.editNote': 'Documents refer to the currency, so it cannot be deleted and its code cannot change.',
  'adm.currency.fillCode': 'Fill in the code, numeric code and name',
  'adm.unit.lead': 'Units for products and document lines. The OKEI code goes into UPD and VAT invoices, precision sets quantity rounding. A unit code never changes.',
  'adm.unit.ro': 'Units are added by the system administrator.',
  'adm.unit.forbidden': 'Units of measure are not available to you',
  'adm.unit.error': 'Could not load units of measure',
  'adm.unit.search': 'Code, name, OKEI',
  'adm.unit.setup': 'The unit list is empty',
  'adm.unit.setup.text': 'Units come from a migration; an empty list means it did not run. No product can be created without units.',
  'adm.unit.empty': 'No unit “{query}”',
  'adm.unit.okei': 'OKEI code',
  'adm.unit.precision': 'Precision',
  'adm.unit.whole': '0 — whole',
  'adm.unit.digits': 'digits: {count}',
  'adm.unit.actions': 'Actions: {name}',
  'adm.unit.note': 'Precision is the number of decimals in quantities: pieces are whole, weight goes to grams. Quantities are stored with four decimals; more cannot be set.',
  'adm.unit.new': 'New unit',
  'adm.unit.code.help': 'As in a document line, up to 6 characters',
  'adm.unit.codeLocked': 'The code never changes: import and integrations find products by it',
  'adm.unit.okei.help': '3 digits by OKEI',
  'adm.unit.okeiInvalid': 'The OKEI code is 3 digits',
  'adm.unit.precision.help': 'Pieces — 0, length and area — 2, weight — 3',
  'adm.unit.example': 'example:',
  'adm.unit.updNote': 'In a UPD the line reads “{code}”, code {okei}.',
  'adm.reasons.title': 'Win and loss reasons',
  'adm.reasons.lead': 'Managers pick a reason from these lists when closing a deal; the order here is the order in the picker and changes by dragging. Reasons are never deleted: closed deals refer to them. Archive the ones not needed.',
  'adm.reasons.ro': 'The order and names of reasons are changed by the system administrator.',
  'adm.reasons.forbidden': 'The reason list is not available to you',
  'adm.reasons.error': 'Could not load reasons',
  'adm.reasons.won': 'Win reasons',
  'adm.reasons.lost': 'Loss reasons',
  'adm.reasons.sub': 'active: {active} · archived: {archived}',
  'adm.reasons.empty.won': 'No win reasons',
  'adm.reasons.empty.won.text': 'Closing a deal as won asks no reason, and the “Why we win” report is empty. Add 3–6 reasons.',
  'adm.reasons.empty.lost': 'No loss reasons',
  'adm.reasons.empty.lost.text': 'Lost deals close without a reason — nobody sees where money is lost. Add at least “Price above competitor” and “Delivery time”.',
  'adm.reasons.move': 'Move: {name}. Arrow up/down',
  'adm.reasons.actions': 'Actions: {name}',
  'adm.reasons.rename': 'Rename',
  'adm.reasons.renameSave': 'Rename',
  'adm.reasons.archive': 'Archive',
  'adm.reasons.archived': 'Archived — not offered when closing a deal',
  'adm.reasons.archivedGrip': 'Archived, cannot be moved',
  'adm.reasons.restore': 'Restore',
  'adm.reasons.restoreOf': 'Restore from archive: {name}',
  'adm.reasons.inArchive': 'archived',
  'adm.reasons.addHint': 'appears last in the list',
  'adm.reasons.keyboard': 'Keyboard: focus the handle, ↑/↓ to move. The order is saved at once.',
  'adm.reasons.was': 'Was: “{name}”. Up to 60 characters.',
  'adm.reasons.kindLocked': 'The kind never changes: closed deals would be rewritten',
  'adm.reasons.codeLocked': 'Integrations find the reason by its code',
  'adm.reasons.code.help': 'Latin, no spaces; never changes later',
  'adm.reasons.renameWarn': 'The new name appears in closed deals and reports. If the meaning differs, add a new reason and archive this one.',
  'adm.funnel.lead': 'A deal’s path from first contact to payment: stage order, probability and day limit. Stage probability sets the weighted funnel total in reports and dashboards.',
  'adm.funnel.ro': 'Stage order, probabilities and limits are changed by the system administrator.',
  'adm.funnel.forbidden': 'Funnel setup is not available to you',
  'adm.funnel.error': 'Could not load funnels',
  'adm.funnel.empty': 'No funnels yet',
  'adm.funnel.empty.text': 'Until there is a funnel, managers cannot create a deal.',
  'adm.funnel.list': 'Funnels',
  'adm.funnel.addShort': 'Funnel',
  'adm.funnel.meta': 'stages: {stages} · open deals: {open}',
  'adm.funnel.default': 'default',
  'adm.funnel.archived': 'archived',
  'adm.funnel.archiveNote': 'An archived funnel takes no new deals; its closed deals stay in reports.',
  'adm.funnel.stagesOf': 'Stages of “{name}”',
  'adm.funnel.counts': 'open: {open} + closing: {closing}',
  'adm.funnel.dragHint': 'Order — drag by the handle or ↑/↓',
  'adm.funnel.more': 'Funnel actions: {name}',
  'adm.funnel.rename': 'Rename funnel',
  'adm.funnel.makeDefault': 'Make the default funnel',
  'adm.funnel.archive': 'Archive',
  'adm.funnel.archive.default': 'The default funnel cannot be archived — make another one default first.',
  'adm.funnel.restore': 'Restore from archive',
  'adm.funnel.total': 'Open deals in the funnel: {count}',
  'adm.funnel.limitNote': 'Day limit — after it the deal is marked “Stuck” in the list and on the board',
  'adm.funnel.create': 'Create funnel',
  'adm.funnel.description': 'Description',
  'adm.stage.probability': 'Probability',
  'adm.stage.limit': 'Stage limit',
  'adm.stage.limitDays': 'Day limit on the stage',
  'adm.stage.days': 'days: {count}',
  'adm.stage.daysSuffix': 'days',
  'adm.stage.move': 'Move stage {name}. Arrow up/down',
  'adm.stage.pinned': 'Stage {name} is pinned at the end',
  'adm.stage.colorOf': 'Colour: {color}',
  'adm.stage.actions': 'Stage actions: {name}',
  'adm.stage.edit': 'Edit stage…',
  'adm.stage.remove.deals': 'The stage has open deals ({count}). Only a stage that never had deals can be deleted; it can be renamed.',
  'adm.stage.remove.last': 'This is the funnel’s only open stage',
  'adm.stage.removeConfirm': 'Delete stage “{name}”?',
  'adm.stage.removeConfirm.text': 'If deals ever passed the stage — even closed or deleted ones — the server refuses: the conversion report reads the transition history.',
  'adm.stage.closingSep': 'Closing stages — always last',
  'adm.stage.overline': 'Stage of “{funnel}”',
  'adm.stage.overlineOf': 'Stage of “{funnel}” · {n} of {of}',
  'adm.stage.name.help': 'Managers see it on the board, the deal card and reports. Renaming does not touch deals.',
  'adm.stage.position.help': 'Place among open stages',
  'adm.stage.color.help': '{color} · colour helps on the board, but the stage is always labelled by name',
  'adm.stage.probability.terminal': 'A closing stage has a fixed probability: won 100 %, lost 0 %',
  'adm.stage.was': 'Was: {value} %',
  'adm.stage.limit.help': 'Empty — no limit',
  'adm.stage.probabilityMoves': 'Probability changes on the stage’s open deals: {count}',
  'adm.stage.probabilityMoves.text': 'A deal’s probability is a snapshot of its stage, so the new one moves to the stage’s open deals; closed ones stay.',
  'adm.stage.type.help': 'The stage type does not change after creation',
  'adm.stage.now': 'On the stage now',
  'adm.stage.openCount': 'open deals: {count}',
  'adm.rule.title': 'Lead distribution rules',
  'adm.rule.lead': 'Who gets a new lead from the website, a call or email. The owner is set on arrival — a lead without a matching rule waits in the shared queue.',
  'adm.rule.ro': 'Rule order, members and switching are changed by the system administrator.',
  'adm.rule.forbidden': 'Lead distribution rules are not available to you',
  'adm.rule.error': 'Could not load rules',
  'adm.rule.order.title': 'Rules are checked top to bottom; a lead gets the first match.',
  'adm.rule.order.text': 'Disabled rules are skipped. Put narrow conditions above general ones.',
  'adm.rule.empty': 'No distribution rules yet',
  'adm.rule.empty.text': 'All new leads go to the shared queue. Add a rule so requests get an owner at once.',
  'adm.rule.listLabel': 'Distribution rules, in check order',
  'adm.rule.head': 'Rule and conditions',
  'adm.rule.members': 'Members',
  'adm.rule.and': 'and',
  'adm.rule.department': 'department: {name}',
  'adm.rule.more': '{count} more',
  'adm.rule.enabledOf': 'Rule {name} enabled',
  'adm.rule.actions': 'Rule actions: {name}',
  'adm.rule.move': 'Move rule {name}. Arrow up/down',
  'adm.rule.queueSep': 'If no rule matches — always last',
  'adm.rule.queuePinned': 'The shared queue is pinned last',
  'adm.rule.queue.title': 'All other leads',
  'adm.rule.queue.target': 'Shared queue — any manager takes it',
  'adm.rule.queue.text': 'A lead without a matching rule is not lost: it waits in the queue until someone takes it.',
  'adm.rule.deleteConfirm': 'Delete rule “{name}”?',
  'adm.rule.deleteConfirm.text': 'Leads already assigned keep their owners; new leads follow the remaining rules.',
  'adm.rule.overline': 'Rule {n} of {of}',
  'adm.rule.appliesToNew': 'Changes apply to new leads',
  'adm.rule.conditionsAll': 'Conditions — all must hold',
  'adm.rule.noConditions': 'No conditions — the rule matches any lead',
  'adm.rule.conditionField': 'Condition field {n}',
  'adm.rule.equals': 'equals',
  'adm.rule.removeCondition': 'Remove condition {n}',
  'adm.rule.addCondition': 'Add condition',
  'adm.rule.fieldsHint': 'Fields: source, UTM tags, company',
  'adm.rule.strategy.round_robin.text': 'Leads go to members in turn, one each — in list order.',
  'adm.rule.strategy.by_load.text': 'The member with the fewest leads in work gets it.',
  'adm.rule.strategy.by_region.text': 'The manager owning the lead’s territory gets it; if none, the territory tree is searched upward.',
  'adm.rule.strategy.manual.text': 'The rule only selects leads — an owner is assigned by hand.',
  'adm.rule.department.help': 'The department members come from',
  'adm.rule.membersCount': 'Members — {count}',
  'adm.rule.members.help': 'Turns follow this order. A dismissed employee cannot be added.',
  'adm.rule.activeLabel': 'Rule enabled',
  'adm.tags.title': 'Tags and segments',
  'adm.tags.lead': 'Tags are manual labels managers put on records. Segments are saved filters: they open from lists with one click and recount themselves.',
  'adm.tags.ro': 'Shared tags and segments are changed by the system administrator; personal segments can be saved from any list.',
  'adm.tags.forbidden': 'Tag management is not available to you',
  'adm.tags.error': 'Could not load tags',
  'adm.tags.tab.tags': 'Tags',
  'adm.tags.tab.segments': 'Segments',
  'adm.tags.search': 'Tag name',
  'adm.tags.add': 'Add tag',
  'adm.tags.empty': 'No tags yet',
  'adm.tags.empty.text': 'Tags mark what card fields lack: “Key”, “Stop shipping”, “Do not call”. Create a shared set — managers will pick from it.',
  'adm.tags.notFound': 'No tag “{query}”',
  'adm.tags.actions': 'Tag actions: {name}',
  'adm.tags.note': 'Deleting a tag removes it from all records; the records themselves do not change. Colour is a hint — a tag is always labelled by name.',
  'adm.tags.deleteConfirm': 'Delete tag “{name}”?',
  'adm.tags.deleteConfirm.text': 'The tag is removed from every record at once, and segments built on it stop finding them.',
  'adm.tags.new': 'New tag',
  'adm.tags.new.sub': 'Shared — available to everyone with rights on the tagged records',
  'adm.tags.edit': 'Edit tag',
  'adm.tags.form': 'Tag',
  'adm.tags.create': 'Create tag',
  'adm.tags.renameHelp': 'The new name appears on all tagged records and in filters',
  'adm.tags.preview': 'Preview',
  'adm.tags.previewName': 'Tag',
  'adm.tags.previewHint': 'as in filters and cards',
  'adm.segments.search': 'Segment name',
  'adm.segments.entity': 'Entity',
  'adm.segments.all': 'All',
  'adm.segments.sharedOnly': 'Shared only',
  'adm.segments.error': 'Could not load segments',
  'adm.segments.empty': 'No segments yet',
  'adm.segments.empty.text': 'A segment is a saved filter. Set a filter in the counterparty, deal, contact or lead list and press “Save as segment”.',
  'adm.segments.notFound': 'No segments match these filters',
  'adm.segments.name': 'Name',
  'adm.segments.filter': 'Saved filter',
  'adm.segments.noFilter': 'no conditions — the whole list',
  'adm.segments.count': 'Records',
  'adm.segments.access': 'Access',
  'adm.segments.shared': 'Shared',
  'adm.segments.mine': 'Personal · mine',
  'adm.segments.private': 'Personal',
  'adm.segments.actions': 'Segment actions: {name}',
  'adm.segments.makeShared': 'Make shared',
  'adm.segments.makePrivate': 'Make personal',
  'adm.segments.delete': 'Delete segment',
  'adm.segments.deleteConfirm': 'Delete segment “{name}”?',
  'adm.segments.deleteConfirm.text': 'The segment disappears from everyone’s lists. Records do not change.',
  'adm.segments.note': 'Record counts are within your visibility: they differ for a head and a manager. A personal segment is seen only by its owner; an administrator can make it shared.',
  'adm.fields.title': 'Custom fields',
  'adm.fields.lead': 'Fields the standard card lacks. They appear on the card, in list columns and filters and in import — at once, without a release.',
  'adm.fields.ro': 'Fields are added and hidden by the system administrator.',
  'adm.fields.forbidden': 'Custom field setup is not available to you',
  'adm.fields.error': 'Could not load fields',
  'adm.fields.count': 'fields: {count}',
  'adm.fields.empty': '“{entity}” has no custom fields',
  'adm.fields.empty.text': 'The card shows only standard fields. Add your own — e.g. “Industry” as a list — to filter records and build reports.',
  'adm.fields.options': 'List values',
  'adm.fields.requiredBadge': 'required',
  'adm.fields.actions': 'Field actions: {code}',
  'adm.fields.note': 'A required field needs a value on create and edit; old records may leave it empty. A hidden field leaves cards and lists; values stay in records.',
  'adm.fields.hideConfirm': 'Hide field “{label}”?',
  'adm.fields.hideConfirm.text': 'The field leaves cards, columns and filters. Values stay in records, but the field cannot be restored from this screen.',
  'adm.fields.newTitle': 'New field: {entity}',
  'adm.fields.newSub': 'Appears on the card, in filters and import',
  'adm.fields.create': 'Create field',
  'adm.fields.code.help': 'Latin letters, digits and _, starting with a letter; cannot change after creation',
  'adm.fields.codeInvalid': 'The code is Latin letters, digits and _, no spaces, starting with a letter',
  'adm.fields.codeTaken': 'A field with code {code} already exists: {entity}',
  'adm.fields.codeFree': 'Code is free',
  'adm.fields.use': 'Use',
  'adm.fields.useHelp': 'We fill in the name’s transliteration',
  'adm.fields.optionN': 'Value {n}',
  'adm.fields.removeOption': 'Remove value {n}',
  'adm.fields.addOption': 'Add value',
  'adm.fields.optionsOrder': 'Order — as in the card dropdown',
  'adm.fields.required.on': 'New and edited records cannot be saved without a value. Existing ones stay empty until filled.',
  'adm.fields.required.off': 'Off: the field may stay empty.',
  'record.hr.leave.rejectionReason': 'Rejection reason',
  'record.hr.leave.noRejectionReason': 'No reason given — the request was rejected before reasons were stored.',
  'record.hr.leave.rejectReasonHelp': 'Required: the employee will see it on the request card.',
  'record.hr.transfer.positionsFailed': 'The positions directory did not load — the position stays as it is.',
  'adm.users.lastLogin': 'Last sign-in',
  'adm.users.neverSeen': 'never',
  'payments.fiscal.col.action': 'Action',
  'payments.fiscal.retryOne': 'Retry',
  'payments.fiscal.retryOne.busy': 'Sending…',
  'payments.fiscal.retryOne.label': 'Retry receipt {receipt}',
  'payments.fiscal.retryOne.notDue': 'Next attempt is scheduled for {at}: retrying earlier only hammers the OFD',
  'payments.fiscal.retryOne.registered': 'Receipt {receipt} is registered with the OFD',
  'payments.fiscal.retryOne.failed': 'The attempt failed — status “{status}”: {error}',
  'payments.import.openOriginal': 'Open that upload',
  'payments.imports.title': 'Upload history',
  'payments.imports.empty': 'No statement has been uploaded to this account yet',
  'payments.imports.col.at': 'When',
  'payments.imports.col.file': 'File',
  'payments.imports.col.lines': 'Lines in file',
  'payments.imports.col.new': 'New',
  'payments.imports.col.duplicates': 'Repeats',
  'payments.imports.col.by': 'Uploaded by',
  'payments.imports.noFile': 'no file name',
  'payments.imports.repeat': 'repeat',
  'payments.imports.open': 'Open',
  'payments.imports.close': 'Collapse',
  'payments.imports.opened': 'Upload “{file}”',
  'payments.imports.summary': '{lines} lines, {imported} new, {duplicates} repeats',
  'payments.imports.noOwnLines': 'This upload has no lines of its own: everything in it was brought by an earlier one.',
  'payments.imports.lines': 'Upload lines',
  'payments.imports.processed': 'Posted',
  'record.pay.made.title': 'Already allocated',
  'record.pay.made.error': 'Could not load the payment allocations',
  'record.pay.made.empty': 'The payment has not been allocated to any invoice yet',
  'record.pay.made.at': 'When',
  'record.pay.made.rule': 'How',
  'record.pay.made.amount': 'Amount',
  'record.pay.made.rule.auto': 'auto-match',
  'record.pay.made.rule.manual': 'manually',
  'record.contact.col.stage': 'Stage',
  'record.contact.col.amount': 'Amount',
  'record.contact.col.closeOn': 'Close date',
  'record.wh.feed.title': 'Movements and discussion',
  'record.wh.feed.error': 'Could not load the document feed',
  'record.wh.feed.empty': 'The document has not moved anything and nobody has discussed it yet',
  'timeline.kind.change': 'Change',
  'timeline.kind.movement': 'Movement',
  'timeline.kind.document': 'Document',
  'timeline.kind.attachment': 'File',
  'timeline.kind.approval': 'Approval',
  'timeline.more': 'Show earlier',
  'timeline.moreFailed': 'Could not load earlier events',
  'timeline.beginning': 'This is the beginning of the history',
  'timeline.onDeal': 'on deal {number}',
  'timeline.document.invoice': 'Invoice',
  'timeline.document.quote': 'Quote',
  'timeline.document.act': 'Act',
  'timeline.document.upd': 'UPD',
  'timeline.document.torg12': 'TORG-12',
  'timeline.document.invoice_factura': 'VAT invoice',
  'timeline.documentStatus.sent': 'issued',
  'timeline.documentStatus.partially_paid': 'partially paid',
  'timeline.documentStatus.paid': 'paid',
  'timeline.documentStatus.overdue': 'overdue',
  'timeline.documentStatus.cancelled': 'cancelled',
  'timeline.documentStatus.issued': 'issued',
  'timeline.documentStatus.signed': 'signed',
  'timeline.scan.pending': 'being scanned',
  'timeline.scan.clean': 'scanned',
  'timeline.scan.infected': 'infected — download blocked',
  'timeline.scan.failed': 'scan failed — download blocked',
  'record.feed.filter.documents': 'Documents',
  'record.composer.mention': 'Mention',
  'record.composer.mentionPlaceholder': 'Colleague name',
  'record.composer.mentionFailed': 'Could not search colleagues',
  'record.composer.mentionFound': 'Colleagues found',
  'record.composer.mentioned': 'Mentioned',
  'record.composer.unmention': 'Remove mention: {name}',
  'timeline.change.INSERT': 'created',
  'timeline.change.UPDATE': 'updated',
  'timeline.change.DELETE': 'deleted',
  'timeline.change.TAGS': 'tags',
  'timeline.movement.receipt': 'receipt',
  'timeline.movement.putaway': 'put-away',
  'timeline.movement.transfer': 'transfer',
  'timeline.movement.pick': 'pick',
  'timeline.movement.ship': 'shipment',
  'timeline.movement.return': 'return',
  'timeline.movement.write_off': 'write-off',
  'timeline.movement.adjust': 'adjustment',
  'timeline.movement.count': 'count',
  // audit entity types (all journal classes)
  'adm.entity.AcquiringWebhook': 'Acquiring webhook',
  'adm.entity.ApprovalDelegation': 'Approval delegation',
  'adm.entity.ApprovalRequest': 'Approval request',
  'adm.entity.ApprovalStep': 'Approval step',
  'adm.entity.Attachment': 'Attachment',
  'adm.entity.AutomationRule': 'Automation rule',
  'adm.entity.BankAccount': 'Bank account',
  'adm.entity.BankStatementImport': 'Bank statement import',
  'adm.entity.BankStatementLine': 'Bank statement line',
  'adm.entity.Candidate': 'Candidate',
  'adm.entity.CandidateApplication': 'Candidate application',
  'adm.entity.CertificationReminder': 'Certification reminder',
  'adm.entity.CostLayer': 'Cost layer',
  'adm.entity.CounterpartyBankAccount': 'Counterparty bank account',
  'adm.entity.CustodyBillingRecord': 'Custody billing record',
  'adm.entity.CustodyDailySnapshot': 'Custody daily snapshot',
  'adm.entity.CustodyTariff': 'Custody tariff',
  'adm.entity.CustomerBalance': 'Customer balance',
  'adm.entity.DealContact': 'Deal contact',
  'adm.entity.DocumentSignature': 'Document signature',
  'adm.entity.DocumentTemplate': 'Document template',
  'adm.entity.DunningAction': 'Dunning action',
  'adm.entity.EmployeeAssignment': 'Employee assignment',
  'adm.entity.EmployeeDocument': 'Employee document',
  'adm.entity.EntityComment': 'Entity comment',
  'adm.entity.FiscalOperation': 'Fiscal operation',
  'adm.entity.FiscalReceipt': 'Fiscal receipt',
  'adm.entity.FiscalReceiptItem': 'Fiscal receipt item',
  'adm.entity.GoodsReceiptItem': 'Goods receipt item',
  'adm.entity.GoodsReturn': 'Goods return',
  'adm.entity.GoodsReturnItem': 'Goods return item',
  'adm.entity.InvoiceItem': 'Invoice item',
  'adm.entity.KpiDefinition': 'Kpi definition',
  'adm.entity.KpiTarget': 'Kpi target',
  'adm.entity.LeaveBalance': 'Leave balance',
  'adm.entity.MarketingSpend': 'Marketing spend',
  'adm.entity.MarkingOperation': 'Marking operation',
  'adm.entity.Notification': 'Notification',
  'adm.entity.OnboardingChecklist': 'Onboarding checklist',
  'adm.entity.OnboardingTask': 'Onboarding task',
  'adm.entity.OnboardingTemplate': 'Onboarding template',
  'adm.entity.OnboardingTemplateTask': 'Onboarding template task',
  'adm.entity.OneCConflict': '1c conflict',
  'adm.entity.OneCConnection': '1c connection',
  'adm.entity.OneCExchangeEntry': '1c exchange entry',
  'adm.entity.OneCExchangeRun': '1c exchange run',
  'adm.entity.OneCLink': '1c link',
  'adm.entity.PaymentAllocation': 'Payment allocation',
  'adm.entity.PaymentIntent': 'Payment intent',
  'adm.entity.Permission': 'Permission',
  'adm.entity.PickTask': 'Pick task',
  'adm.entity.PickTaskLine': 'Pick task line',
  'adm.entity.PriceList': 'Price list',
  'adm.entity.PriceListItem': 'Price list item',
  'adm.entity.PrimaryDocumentItem': 'Primary document item',
  'adm.entity.ProductBatch': 'Product batch',
  'adm.entity.QuoteItem': 'Quote item',
  'adm.entity.ReceiptMarkingCode': 'Receipt marking code',
  'adm.entity.RecurringInvoice': 'Recurring invoice',
  'adm.entity.SalesOrder': 'Sales order',
  'adm.entity.SalesOrderItem': 'Sales order item',
  'adm.entity.SalesPlan': 'Sales plan',
  'adm.entity.SavedView': 'Saved view',
  'adm.entity.SerialNumber': 'Serial number',
  'adm.entity.ShipmentItem': 'Shipment item',
  'adm.entity.ShipmentPackage': 'Shipment package',
  'adm.entity.ShipmentPackageItem': 'Shipment package item',
  'adm.entity.Stock': 'Stock',
  'adm.entity.StockReservation': 'Stock reservation',
  'adm.entity.StockRevaluation': 'Stock revaluation',
  'adm.entity.StockTransferItem': 'Stock transfer item',
  'adm.entity.StockWriteOff': 'Stock write off',
  'adm.entity.StockWriteOffItem': 'Stock write off item',
  'adm.entity.StocktakeLine': 'Stocktake line',
  'adm.entity.StorageCell': 'Storage cell',
  'adm.entity.StorageZone': 'Storage zone',
  'adm.entity.SupportMessage': 'Support message',
  'adm.entity.SupportTicket': 'Support ticket',
  'adm.entity.Territory': 'Territory',
  'adm.entity.TimeEntry': 'Time entry',
  'adm.entity.TrainingCourse': 'Training course',
  'adm.entity.TrainingRecord': 'Training record',
  // Report builder: bounds of a «between» filter.
  'report.filter.from': 'from',
  'report.filter.to': 'to',

  'payments.item.marketing': 'Marketing and advertising',

  // Taxes (V57): rates by code and period, 22 % standard rate from 2026.
  'nav.adminTaxRates': 'Taxes',
  'column.tax_rate_code': 'VAT rate',
  'card.taxRate.pick': 'Choose a rate',
  'record.product.taxNotEffective': 'Rate {code} is not in force today',
  'adm.tax.lead': 'VAT rates by code and validity period. A product stores the rate code, a document stores the percent in force on its date: the standard rate is 20 % until 31.12.2025 and 22 % from 01.01.2026. A rate used by documents is not edited — it is closed with an end date and a new period is added.',
  'adm.tax.ro': 'Tax rates are configured by the system administrator.',
  'adm.tax.add': 'Add rate',
  'adm.tax.search': 'Code, name or receipt attribute',
  'adm.tax.forbidden': 'No access to tax rates',
  'adm.tax.error': 'Could not load tax rates',
  'adm.tax.setup': 'No tax rates',
  'adm.tax.setup.text': 'Without rates neither an invoice nor a receipt can be issued. The reference is seeded by a migration — if it is empty, check it.',
  'adm.tax.empty': 'Nothing found for “{query}”',
  'adm.tax.code': 'Code',
  'adm.tax.name': 'Name',
  'adm.tax.kind': 'Kind',
  'adm.tax.percent': 'Rate',
  'adm.tax.ofd': 'Receipt attribute',
  'adm.tax.period': 'Valid',
  'adm.tax.state': 'State',
  'adm.tax.usage': 'References',
  'adm.tax.usage.hint': 'Document lines issued at this rate, and products carrying its code',
  'adm.tax.usage.value': 'lines {lines} · products {products}',
  'adm.tax.newPeriod': 'New period',
  'adm.tax.newPeriodOf': 'New period of {code}',
  'adm.tax.new': 'New rate',
  'adm.tax.form': 'Tax rate',
  'adm.tax.delete': 'Delete',
  'adm.tax.deleteBlockedLines': 'Documents were issued at this rate ({count} lines) — it can only be closed with a date',
  'adm.tax.deleteBlockedProducts': 'This is the last period of a code products carry ({count})',
  'adm.tax.deleteConfirm': 'Delete rate “{name}”?',
  'adm.tax.deleteConfirm.text': 'No documents use it. Once deleted, no new lines can be issued under this period.',
  'adm.tax.actions': 'Actions for rate {code}',
  'adm.tax.kind.standard': 'Standard',
  'adm.tax.kind.reduced': 'Reduced',
  'adm.tax.kind.special': 'Special (simplified tax)',
  'adm.tax.kind.zero': 'Zero',
  'adm.tax.kind.exempt': 'VAT exempt',
  'adm.tax.estimatedShort': 'estimated',
  'adm.tax.openEnded': 'open-ended',
  'adm.tax.state.active': 'In force',
  'adm.tax.state.future': 'Upcoming',
  'adm.tax.state.closed': 'Closed',
  'adm.tax.codeInvalid': 'Lowercase latin letters, digits and underscores; starts with a letter',
  'adm.tax.code.help': 'Products find their rate by code; a new period of the same tax uses the same code',
  'adm.tax.codeLocked': 'The code does not change: products find the rate by it',
  'adm.tax.periodInvalid': 'The end is before the start',
  'adm.tax.frozen': 'Documents were issued at this rate ({count} lines): its percent, kind, receipt attribute and start date do not change — past documents would change their meaning. Close the rate with an end date and add a new period.',
  'adm.tax.estimated': 'Estimated rate',
  'adm.tax.estimated.label': 'The tax is extracted from the amount as r/(100+r) — for advances and prepayments',
  'adm.tax.estimated.help': 'For example, 22/122. Not used on invoice or deal lines — only on receipts',
  'adm.tax.ofd.pick': 'Choose an attribute',
  'adm.tax.ofd.help': 'The rate attribute on a receipt (fiscal data format, tag 1199). The list is fixed by the format and narrowed by percent and estimation',
  'adm.tax.ofd.none': 'The fiscal data format has no attribute for this percent — a receipt at this rate cannot be punched',
  'adm.tax.validFrom': 'Valid from',
  'adm.tax.validTo': 'Valid until',
  'adm.tax.validTo.help': 'Empty — open-ended. Inclusive',
  // Склады и топология: склады, зоны, ячейки, генератор ячеек
  'nav.warehouses': 'Warehouses & layout',
  'topo.lead': 'Warehouses, storage zones and cells. Warehouse and zone codes are printed in every cell barcode and therefore never change; a cell holding stock, a reservation or an open task can only be blocked.',
  'topo.ro': 'Warehouses, zones and cells are visible, but only the head of this warehouse or an administrator can change them.',
  'topo.forbidden': 'No access to the warehouse layout',
  'topo.error': 'Could not load warehouses',
  'topo.active': 'Active',
  'topo.inactive': 'Inactive',
  'topo.pick': 'Choose…',
  'topo.codeInvalid': '1 to 32 letters, digits, “_” or “-” — no dots or spaces',
  'topo.code.help': 'Part of the cell barcode (SITE.ZONE.CELL); cannot be changed once saved',
  'topo.code.locked': 'The code does not change: it is printed on the cell labels',
  'topo.strategy.help': 'Which batches leave first. A zone may set its own',
  'topo.strategy.FIFO': 'FIFO — first in, first out',
  'topo.strategy.FEFO': 'FEFO — first expiry, first out',
  'topo.strategy.LIFO': 'LIFO — last in, first out',
  'topo.strategy.MANUAL': 'Manual — the picker chooses',
  'topo.wh.add': 'Add warehouse',
  'topo.wh.new': 'New warehouse',
  'topo.wh.form': 'Warehouse',
  'topo.wh.search': 'Search by code, name, address',
  'topo.wh.setup': 'No warehouses yet',
  'topo.wh.setup.text': 'Create a warehouse, then its zones and cells — receiving has nowhere to put goods without them.',
  'topo.wh.empty': 'Nothing found for “{query}”',
  'topo.wh.code': 'Code',
  'topo.wh.name': 'Name',
  'topo.wh.organization': 'Organisation',
  'topo.wh.organization.help': 'Whose inventory the site holds. Cannot be changed once saved',
  'topo.wh.organization.locked': 'The organisation does not change: the stock would move with it without a document',
  'topo.wh.address': 'Address',
  'topo.wh.manager': 'Head',
  'topo.wh.manager.help': 'An employee from HR. The head edits the zones and cells of their own warehouse',
  'topo.wh.managerIs': 'head {name}',
  'topo.wh.strategy': 'Picking strategy',
  'topo.wh.strategyIs': 'picking {strategy}',
  'topo.wh.crossDock': 'Cross-docking',
  'topo.wh.crossDock.help': 'Goods may go from receiving straight to shipping, skipping put-away',
  'topo.wh.crossDockShort': 'cross-docking',
  'topo.wh.active': 'Active',
  'topo.wh.active.help': 'An inactive site stays in history; a closed site is made inactive, not deleted',
  'topo.wh.zones': 'Zones',
  'topo.wh.cells': 'Cells',
  'topo.wh.state': 'State',
  'topo.wh.editOf': 'Edit warehouse {code}',
  'topo.wh.delete': 'Delete warehouse',
  'topo.wh.deleteConfirm': 'Delete warehouse {code}?',
  'topo.wh.deleteConfirm.text': 'Its zones and cells are deleted with it. The server refuses a site with stock or unfinished documents — make such a site inactive instead.',
  'topo.cells.summary': '{cells} · occupied {occupied} · blocked {blocked}',
  'topo.cells.summary.hint': 'Total cells · holding stock · blocked',
  'topo.zones': 'Storage zones',
  'topo.zone.add': 'Add zone',
  'topo.zone.new': 'New zone',
  'topo.zone.form': 'Storage zone',
  'topo.zone.setup': 'No zones yet',
  'topo.zone.setup.text': 'A zone sets the storage mode: racked cells, pallets, floor, custody, quarantine, defect.',
  'topo.zone.code': 'Code',
  'topo.zone.name': 'Name',
  'topo.zone.mode': 'Storage mode',
  'topo.zone.regime': 'Temperature',
  'topo.zone.strategy': 'Strategy',
  'topo.zone.priority': 'Priority',
  'topo.zone.priority.help': 'Lower is offered first for put-away',
  'topo.zone.inherit': 'As the warehouse ({strategy})',
  'topo.zone.inherited': '(warehouse)',
  'topo.zone.owner': 'Goods owner',
  'topo.zone.owner.help': 'The customer whose goods the zone holds; storage is billed to them. Search by name or tax ID',
  'topo.zone.ownerIs': 'owner: {name}',
  'topo.zone.tempMin': 'Temperature from, °C',
  'topo.zone.tempMax': 'Temperature to, °C',
  'topo.zone.temp.help': 'Empty — the regime’s usual bounds',
  'topo.zone.tempNumber': 'Temperature must be a number',
  'topo.zone.tempInverted': 'Lower bound above upper bound',
  'topo.zone.active': 'Active',
  'topo.zone.active.help': 'An inactive zone is not offered for put-away',
  'topo.zone.noCells': 'no cells',
  'topo.zone.noCells.text': 'Mode “{mode}” stores goods without cells — at zone level.',
  'topo.zone.actions': 'Actions for zone {code}',
  'topo.zone.delete': 'Delete zone',
  'topo.zone.deleteBlocked': 'Occupied cells in the zone: {count} — move the goods first',
  'topo.zone.deleteConfirm': 'Delete zone {code}?',
  'topo.zone.deleteConfirm.text': 'Its cells ({count}) are deleted with it. The server refuses a zone with stock, reservations or open tasks.',
  'topo.mode.addressed': 'Addressed (cells)',
  'topo.mode.pallet': 'Pallet',
  'topo.mode.bulk': 'Floor',
  'topo.mode.custody': 'Custody',
  'topo.mode.quarantine': 'Quarantine',
  'topo.mode.cross_dock': 'Cross-dock',
  'topo.mode.defect': 'Defect',
  'topo.mode.addressed.help': 'Racks with addressed cells: row, rack, tier, position',
  'topo.mode.pallet.help': 'Stored by pallet (SSCC), no cells',
  'topo.mode.bulk.help': 'Floor storage for oversized goods, no cells',
  'topo.mode.custody.help': 'Customer goods: never sold as ours, storage billed to the owner',
  'topo.mode.quarantine.help': 'Received but not inspected — nothing is picked from quarantine',
  'topo.mode.cross_dock.help': 'From receiving straight to shipping, skipping put-away',
  'topo.mode.defect.help': 'Damaged and rejected goods, apart from sellable stock',
  'topo.regime.ambient': 'Ambient',
  'topo.regime.chilled': 'Chilled',
  'topo.regime.frozen': 'Frozen',
  'topo.regime.hazardous': 'Hazardous',
  'topo.cells.title': 'Cells of zone {zone}',
  'topo.cells.truncated': '{shown} of {total} shown — narrow by row',
  'topo.cells.search': 'Cell code',
  'topo.cells.row': 'Row',
  'topo.cells.anyRow': 'All rows',
  'topo.cells.any': 'All',
  'topo.cells.blockedFilter': 'Blocking',
  'topo.cells.blockedYes': 'Blocked',
  'topo.cells.blockedNo': 'Working',
  'topo.cells.occupiedFilter': 'Occupancy',
  'topo.cells.occupiedYes': 'Occupied',
  'topo.cells.occupiedNo': 'Empty',
  'topo.cells.bulk': 'Actions on selected cells',
  'topo.cells.selected': 'Selected: {count}',
  'topo.cells.selectAll': 'Select all shown cells',
  'topo.cells.selectOne': 'Select cell {code}',
  'topo.cells.block': 'Block',
  'topo.cells.unblock': 'Unblock',
  'topo.cells.clear': 'Clear selection',
  'topo.cells.blockConfirm': 'Block the selected cells ({count})?',
  'topo.cells.reason': 'Reason',
  'topo.cells.reason.help': 'Required: a block without a reason outlives its cause',
  'topo.cells.setup': 'No cells yet',
  'topo.cells.setup.text': 'Generate them from a template: ranges of rows, racks, tiers and positions.',
  'topo.cells.empty': 'No cells match these filters',
  'topo.cells.code': 'Code',
  'topo.cells.address': 'Row / rack / tier / position',
  'topo.cells.capacity': 'Capacity',
  'topo.cells.dims': 'L×W×H, mm',
  'topo.cells.abc': 'ABC',
  'topo.cells.abc.help': 'Turnover class: fast movers (A) are offered nearer to dispatch',
  'topo.cells.state': 'State',
  'topo.cells.unlimited': 'unlimited',
  'topo.cells.kg': '{value} kg',
  'topo.cells.m3': '{value} m³',
  'topo.cells.pallets': '{value} pal.',
  'topo.cells.blockedBadge': 'Blocked',
  'topo.cells.reserveBadge': 'Reserve',
  'topo.cells.stockBadge': 'Stock',
  'topo.cells.reservedBadge': 'Reserved',
  'topo.cells.taskBadge': 'Task',
  'topo.cells.free': 'free',
  'topo.cells.actions': 'Actions for cell {code}',
  'topo.cells.delete': 'Delete cell',
  'topo.cells.deleteConfirm': 'Delete cell {code}?',
  'topo.cells.deleteConfirm.text': 'The cell is empty. Once deleted, its code can be created again by the generator.',
  'topo.cells.busy.stock': 'the cell holds stock',
  'topo.cells.busy.reserved': 'its stock is reserved',
  'topo.cells.busy.task': 'an open task points to it',
  'topo.cells.busy.blockInstead': 'it cannot be deleted, only blocked',
  'topo.cells.form': 'Cell',
  'topo.cells.limits.help': 'Empty means unlimited, not zero — that is how the put-away suggestion reads it.',
  'topo.cells.maxWeight': 'Max weight, kg',
  'topo.cells.maxVolume': 'Max volume, m³',
  'topo.cells.maxPallets': 'Pallet places',
  'topo.cells.length': 'Length, mm',
  'topo.cells.width': 'Width, mm',
  'topo.cells.height': 'Height, mm',
  'topo.cells.limitInvalid': 'Limits must be positive numbers',
  'topo.cells.pickable': 'Picking from the cell',
  'topo.cells.pickable.help': 'Off — a reserve cell: it replenishes pick faces, and the picking route skips it',
  'topo.gen.open': 'Generate cells',
  'topo.gen.overline': 'Zone {zone}',
  'topo.gen.title': 'Cell generator',
  'topo.gen.subtitle': 'At most {max} cells at once. Existing codes are skipped',
  'topo.gen.row': 'Rows',
  'topo.gen.rack': 'Racks',
  'topo.gen.tier': 'Tiers',
  'topo.gen.position': 'Positions',
  'topo.gen.from': '{axis}: from',
  'topo.gen.to': '{axis}: to',
  'topo.gen.mask': 'Code mask',
  'topo.gen.mask.help': '{ROW}, {RACK}, {TIER}, {POS}; “:2” zero-pads a number to two digits. Example: {ROW}-{RACK:2}-{TIER:2}-{POS} → A-06-04-2. A range is numbers (1…12) or letters (A…F); empty means the coordinate is not used',
  'topo.gen.defaults': 'Capacity and flags of the new cells',
  'topo.gen.preview': 'Preview',
  'topo.gen.previewing': 'Calculating…',
  'topo.gen.previewTitle': 'Generator preview',
  'topo.gen.create': 'Create cells: {count}',
  'topo.gen.createNeedsPreview': 'Preview first',
  'topo.gen.summary': 'The template describes {total}: {create} to create, {existing} already exist',
  'topo.gen.codes': 'Codes:',
  'topo.gen.skipped': 'Skipped (already exist):',
  'topo.gen.nothingNew': 'Every cell of the template exists — nothing to create',
  'topo.gen.stale': 'The template changed after the preview — refresh it',
  'topo.gen.done': 'Cells created: {created}, existing skipped: {skipped}',
  'topo.wh.manager.locked': 'The head is assigned by an administrator; otherwise a head could take over another warehouse',
  'topo.wh.notMine': 'not your warehouse',
  'topo.wh.notMine.hint': 'You can edit only the warehouses you head',
  'topo.pick.search': 'Start typing a name',

  // The whole product (V60): form, photos, characteristics, category tree.
  'nav.productCategories': 'Product categories',
  'column.uom_id': 'Unit',
  'column.storage_condition': 'Storage conditions',
  'column.is_marked': 'Marking',
  'column.is_batch_tracked': 'Batch tracking',
  'column.is_serial_tracked': 'Serial tracking',
  'value.sales.product.storage_condition.ambient': 'Ambient',
  'value.sales.product.storage_condition.chilled': 'Chilled',
  'value.sales.product.storage_condition.frozen': 'Frozen',
  'value.sales.product.storage_condition.hazardous': 'Hazardous',
  'product.create.title': 'New product',
  'product.create.submit': 'Create product',
  'product.edit.open': 'Edit',
  'product.edit.title': 'Edit product',
  'product.edit.save': 'Save',
  'product.form.section.main': 'General',
  'product.form.section.description': 'Description',
  'product.form.section.accounting': 'Accounting and storage',
  'product.form.section.marking': 'Marking',
  'product.form.needSkuName': 'Enter the SKU and the name',
  'product.form.fix': 'Fix the fields marked in red',
  'product.form.number': 'A non-negative number is required',
  'product.form.integer': 'A non-negative whole number is required',
  'product.form.noCategory': 'No category',
  'product.form.uomDefault': 'Piece (default)',
  'product.form.description': 'Product description',
  'product.form.descriptionHelp': 'Separate paragraphs with an empty line. Markup is not supported — the text is shown as typed.',
  'product.form.tracking': 'Unit tracking',
  'product.form.trackingHelp': 'Batches — stock per batch with expiry dates; serial numbers — every unit separately',
  'product.form.shelfLifeDays': 'Shelf life, days',
  'product.form.reorderPoint': 'Reorder point',
  'product.form.reorderHelp': 'Below this stock level the system proposes a purchase',
  'product.form.volumeM3': 'Volume, m³',
  'product.form.lengthMm': 'Length, mm',
  'product.form.widthMm': 'Width, mm',
  'product.form.heightMm': 'Height, mm',
  'product.form.markedHelp': 'The product is subject to Chestny ZNAK marking: a DataMatrix code is scanned on receipt and shipment',
  'product.form.marked.on': 'Subject to marking',
  'product.form.marked.off': 'Not marked',
  'product.form.lockedHelp': 'Fixed: the product already has stock movements',
  'product.form.lockedNote': 'The product already has movements or stock — its unit, type and tracking are fixed. If they are wrong, create a new product.',
  'product.form.conflict': 'Someone else changed the product while you were editing. Close the form and open it again to see the latest data.',
  'product.tracking.none': 'No batches or serials',
  'product.tracking.batch': 'Batches',
  'product.tracking.serial': 'Serial numbers',
  'product.tab.overview': 'Description',
  'product.tab.photos': 'Photos',
  'product.card.error': 'Could not load the product',
  'product.description.empty': 'No description',
  'product.description.emptyText': 'Add one with “Edit”.',
  'product.dimensions': 'Dimensions (L × W × H)',
  'product.mm': 'mm',
  'product.badge.marked': 'Marking',
  'product.attr.title': 'Characteristics',
  'product.attr.empty': 'No characteristics',
  'product.attr.emptyText': 'For example: “Material — steel”, “Length — 120 mm”.',
  'product.attr.edit': 'Edit characteristics',
  'product.attr.add': 'Add a characteristic',
  'product.attr.save': 'Save characteristics',
  'product.attr.name': 'Name',
  'product.attr.value': 'Value',
  'product.attr.unit': 'Unit',
  'product.attr.actions': 'Actions',
  'product.attr.nameOf': 'Name of characteristic {index}',
  'product.attr.valueOf': 'Value of characteristic {index}',
  'product.attr.unitOf': 'Unit of characteristic {index}',
  'product.attr.up': 'Move characteristic {index} up',
  'product.attr.down': 'Move characteristic {index} down',
  'product.attr.remove': 'Remove characteristic {index}',
  'product.attr.duplicate': 'Characteristic “{name}” is listed twice',
  'product.attr.incomplete': 'Every characteristic needs a name and a value',
  'product.photo.upload': 'Upload photos',
  'product.photo.uploading': 'Uploading: {count}',
  'product.photo.choose': 'Choose photos',
  'product.photo.rules': 'JPEG, PNG or WebP, up to {mb} MB. Several at once are fine.',
  'product.photo.full': 'Limit reached — {max} photos per product',
  'product.photo.empty': 'No photos',
  'product.photo.emptyText': 'Upload one or several — the first becomes the main one.',
  'product.photo.list': 'Product photos',
  'product.photo.show': 'Show photo {name}',
  'product.photo.main': 'Main',
  'product.photo.makeMain': 'Make main',
  'product.photo.left': 'Move {name} left',
  'product.photo.right': 'Move {name} right',
  'product.photo.delete': 'Delete photo {name}',
  'product.photo.deleteTitle': 'Delete the photo?',
  'product.photo.deleteConfirm': 'Delete photo',
  'product.photo.deleteText': 'Photo “{name}” will be removed from the gallery and from storage.',
  'product.photo.deleteMainText': 'Photo “{name}” is the main one. The next one in order becomes main.',
  'product.photo.none': 'No photo',
  'product.photo.openGallery': 'Open the gallery',
  'product.photo.state.pending': 'Being checked by the antivirus',
  'product.photo.state.loading': 'Loading',
  'product.photo.state.rejected': 'Failed the check',
  'category.lead': 'The catalogue tree. Only an empty category — no products, no subcategories — can be deleted.',
  'category.ro': 'Categories are edited by whoever may edit the product catalogue.',
  'category.addRoot': 'New category',
  'category.addChild': 'Add a subcategory',
  'category.edit': 'Rename or move',
  'category.delete': 'Delete',
  'category.notEmpty': 'Not possible: {products} products, {children} subcategories',
  'category.empty': 'No categories yet',
  'category.emptyText': 'Create the first one to sort products into sections.',
  'category.collapse': 'Collapse “{name}”',
  'category.expand': 'Expand “{name}”',
  'category.counts': '{products} products · {children} subcategories',
  'category.menu': 'Actions for category “{name}”',
  'category.deleteTitle': 'Delete category “{name}”?',
  'category.deleteText': 'The category is empty — no product or subcategory is left without a section.',
  'category.createTitle': 'New category',
  'category.editTitle': 'Category',
  'category.name': 'Name',
  'category.parent': 'Parent category',
  'category.parentHelp': 'Choose another one to move the category with its subcategories. It cannot move inside its own branch.',
  'category.root': 'Catalogue root',
  'nav.priceLists': 'Price lists',
  'nav.salesPlans': 'Sales plans',
  'plans.lead': 'A target for the period against the fact — won deals closed in that period. A head sees their department, a manager sees themselves',
  'plans.quarter': 'Quarter',
  'plans.quarter.label': 'Q{q} {year}',
  'plans.quarter.prev': 'Previous quarter',
  'plans.quarter.next': 'Next quarter',
  'plans.add': 'Set a plan',
  'plans.employees': 'By manager',
  'plans.employees.empty': 'No manager plans for this quarter',
  'plans.employees.empty.text': 'Completion is measured against a plan: without a figure there is nothing to show',
  'plans.departments': 'By department',
  'plans.departments.empty': 'No department plans for this quarter',
  'plans.forbidden': 'No access to sales plans',
  'plans.error': 'Plans failed to load',
  'plans.unnamed': 'Unnamed',
  'plans.col.employee': 'Manager',
  'plans.col.department': 'Department',
  'plans.col.period': 'Period',
  'plans.col.planned': 'Plan',
  'plans.col.actual': 'Actual',
  'plans.col.completion': 'Completion',
  'plans.col.detail': 'Details',
  'plans.col.month': 'Month',
  'plans.col.cumulative': 'Cumulative',
  'plans.wholeQuarter': 'Whole quarter',
  'plans.open': 'Forecast and months: {name}',
  'plans.forecastAndMonths': 'Forecast and months',
  'plans.actions': 'Plan actions: {name}',
  'plans.percent': '{value}%',
  'plans.noTarget': 'No target set',
  'plans.noTarget.hint': 'The plan is zero: completion is not computed — "never set" and "missed" are different things',
  'plans.detail': 'Sales plan',
  'plans.detail.planned': 'Plan: {amount}',
  'plans.close': 'Close',
  'plans.forecast': 'Forecast for the period end',
  'plans.forecast.employeeOnly': 'A forecast exists only for a manager\'s plan: the pipeline belongs to a person',
  'plans.forecast.error': 'The forecast failed to load',
  'plans.forecast.actual': 'Earned',
  'plans.forecast.pipeline': 'Weighted pipeline',
  'plans.forecast.projected': 'Forecast',
  'plans.forecast.verdict': 'Outlook',
  'plans.forecast.onTrack': 'On track',
  'plans.forecast.behind': 'Falling short of the plan',
  'plans.months': 'By month',
  'plans.months.error': 'The monthly breakdown failed to load',
  'plans.form': 'Sales plan',
  'plans.new': 'New plan',
  'plans.form.forbidden': 'No right to set plans',
  'plans.form.kind': 'For',
  'plans.form.kind.employee': 'A manager',
  'plans.form.kind.department': 'A department',
  'plans.form.choose': '— choose —',
  'plans.form.employee.help': 'Only those you may set a plan for',
  'plans.form.nobody': 'There is nobody you may set a plan for',
  'plans.form.from': 'Period start',
  'plans.form.to': 'Period end',
  'plans.form.period.help': 'Defaults to the selected quarter',
  'plans.form.periodInvalid': 'The period ends before it starts',
  'plans.form.amount': 'Plan amount',
  'plans.form.amountInvalid': 'A non-negative number with at most two decimals',
  'plans.form.currency': 'Currency',
  'plans.form.currencyInvalid': 'A three-letter currency code, e.g. RUB',
  'plans.revise': 'Change amount',
  'plans.revise.title': 'Change plan: {name}',
  'plans.revise.help': 'The period and whom the plan is for do not change — that would be a different plan',
  'pl.lead': 'Product prices by list. A deal or quote line without a price takes it from the customer\'s own list, otherwise from the effective list of the highest priority in the document\'s currency; on a tie, from the default list',
  'pl.ro': 'You can view price lists and prices but not change them: the price list edit right is required',
  'pl.add': 'New price list',
  'pl.new': 'New price list',
  'pl.form': 'Price list',
  'pl.search': 'Search by code and name',
  'pl.forbidden': 'Price lists are not available',
  'pl.error': 'Could not load price lists',
  'pl.empty': 'No price lists yet',
  'pl.empty.text': 'Without a list, prices on deal and quote lines are typed by hand',
  'pl.notFound': 'Nothing found for "{query}"',
  'pl.code': 'Code',
  'pl.code.help': 'Optional: without a code PL-NNNNNN is assigned',
  'pl.codeLocked': 'The code does not change: it tells where a document price came from',
  'pl.name': 'Name',
  'pl.currency': 'Currency',
  'pl.currency.help': 'Three-letter ISO code: RUB, USD, EUR. Every price of the list is in it',
  'pl.currencyInvalid': 'Three Latin letters',
  'pl.currencyLocked': 'The list already has prices, so its currency is fixed: prices would be relabelled, not converted. Create a new list',
  'pl.period': 'Validity',
  'pl.period.open': 'open',
  'pl.period.always': 'always',
  'pl.periodInvalid': 'The end is before the start',
  'pl.validFrom': 'Valid from',
  'pl.validFrom.help': 'Empty means from any date',
  'pl.validUntil': 'Valid until',
  'pl.validUntil.help': 'Empty means open-ended; inclusive',
  'pl.priority': 'Priority',
  'pl.priority.help': 'Higher wins: a promotion at 10 overrides the base list at 0',
  'pl.priorityIs': 'priority {priority}',
  'pl.state': 'State',
  'pl.state.active': 'in effect',
  'pl.state.inactive': 'off',
  'pl.state.outOfPeriod': 'out of period',
  'pl.items': 'Prices',
  'pl.counterparties': 'Customers',
  'pl.counterpartiesIs': 'assigned to customers: {count}',
  'pl.default': 'Default',
  'pl.default.help': 'One per currency and day: the server refuses a second default list with an overlapping period',
  'pl.default.on': 'Default list',
  'pl.default.off': 'Regular list',
  'pl.active': 'Active',
  'pl.active.help': 'An inactive list prices no documents and is not shown among product prices',
  'pl.actions': 'Actions for list {code}',
  'pl.delete': 'Delete list',
  'pl.deleteBlocked': 'Assigned to customers ({count}) — they would be left without prices',
  'pl.deleteConfirm': 'Delete the list "{name}"?',
  'pl.deleteConfirm.text': 'Prices in documents already issued stay as they are — a document keeps its own price. New lines will no longer be priced from this list',
  'pl.prices': 'Prices',
  'pl.items.search': 'Article or name',
  'pl.items.add': 'Add products',
  'pl.items.addTitle': 'Add products to the list',
  'pl.items.addSubtitle': 'Each product has its own price in {currency}',
  'pl.items.addCount': 'Add: {count}',
  'pl.items.pick': 'Product',
  'pl.items.pickHint': 'Find a product by name and pick it — several are fine',
  'pl.items.chosen': 'Chosen products',
  'pl.items.unpick': 'Remove "{name}" from the choice',
  'pl.items.refused': 'Not added:',
  'pl.items.empty': 'The list has no prices',
  'pl.items.empty.text': 'Add products or upload prices from CSV',
  'pl.items.notFound': 'No products for "{query}"',
  'pl.sku': 'Article',
  'pl.product': 'Product',
  'pl.uom': 'Unit',
  'pl.price': 'Price, {currency}',
  'pl.priceFor': 'Price of {sku}',
  'pl.priceInvalid': 'A number not below zero, up to four decimals',
  'pl.editPrice': 'Change the price of {sku}',
  'pl.fromQuantity': 'from {quantity}',
  'pl.productInactive': 'discontinued',
  'pl.removeItem': 'Remove {sku} from the list',
  'pl.removeItem.confirm': 'Remove {sku} from the list?',
  'pl.removeItem.do': 'Remove',
  'pl.removeItem.text': 'Deal and quote lines without a price will no longer get this product\'s price from the list',
  'pl.import': 'Import CSV',
  'pl.import.title': 'Import prices from CSV',
  'pl.import.format': 'Two columns with a header: "Article" and "Price" (separator — semicolon or comma, decimals with a comma or a dot). A product already in the list gets its price replaced, a new one is added',
  'pl.import.file': 'File',
  'pl.import.run': 'Upload',
  'pl.import.running': 'Uploading…',
  'pl.import.summary': 'Added: {created}, updated: {updated}, failed: {failed}',
  'pl.import.errors': 'Failed rows',
  'pl.import.line': 'Line',
  'pl.import.column': 'Column',
  'pl.import.reason': 'Reason',
  'pl.product.title': 'Product prices by list',
  'pl.product.forbidden': 'No access to price lists',
  'pl.product.none': 'No list prices today',
  'pl.product.none.text': 'The product is in no effective list — the price on a document line is typed by hand',
  'pl.product.list': 'Price list',
  'pl.product.price': 'Price',
  'pl.product.from': 'From quantity',
  'pl.product.discount': 'base {base}, discount {percent} %',
  'product.tab.prices': 'Prices',
  // ------------------------------------------------- review of #82–#94 (October 2026)
  'record.inv.submitApproval': 'Submit for approval',
  'record.inv.approval.submitted': 'The invoice was submitted for approval.',
  'record.inv.approval.notRequired': 'No threshold is crossed — no approval needed, the invoice can be sent.',
  'record.inv.line.add': 'Add line',
  'record.inv.line.added': 'Line added, totals recalculated.',
  'record.inv.line.removed': 'Line removed, totals recalculated.',
  'record.inv.line.remove': 'Remove line “{line}”',
  'record.inv.line.actions': 'Line actions',
  'dashboard.none.title': 'No dashboards yet',
  'dashboard.none.text': 'Build the first dashboard from saved reports — it will open when you sign in.',
  'dashboard.none.textReadOnly': 'No dashboard has been shared with you yet. A manager or an analyst can create one.',
  'dashboard.none.create': 'Create the first dashboard',
  'dashboard.noWidgets.title': 'This dashboard has no widgets yet',
  'dashboard.noWidgets.textReadOnly': 'Widgets are added by the dashboard owner.',
  'dashboard.noWidgets.add': 'Add a widget',
  'dashboard.widget.empty': 'The report behind this widget returned no rows',
  'rb.saveChanges': 'Save changes',
  'rb.saveAsNew': 'Save as new',
  'leave.create.title': 'Absence request',
  'leave.create.submit': 'Submit request',
  'leave.create.from': 'From',
  'leave.create.to': 'To',
  'leave.create.comment': 'Comment',
  'leave.create.needEmployee': 'Choose the employee',
  'leave.create.needDates': 'Set the start and end dates',
  'leave.create.badPeriod': 'The end is before the start',
  'leave.create.employeeHelp': 'Empty — the request is yours. The approval route is built by the system.',
  'leave.create.employeeHelpNoCard': 'Your account has no employee card — choose whom you are filing for.',
  'record.hr.leave.cancel': 'Cancel request',
  'record.hr.leave.cancelTitle': 'Cancel the absence request?',
  'record.hr.leave.cancelText': 'The request will be cancelled as of today. If the leave was approved, the drawn days return to the balance.',
  'record.hr.leave.cancelled': 'The request was cancelled.',
  // Tasks, meetings, reminders, calendar (#110–#113)
  'nav.calendar': 'Calendar',
  'tasks.new': 'New task',
  'tasks.noRecord': 'No record',
  'cal.title': 'Calendar',
  'cal.view': 'Calendar view',
  'cal.view.day': 'Day',
  'cal.view.week': 'Week',
  'cal.view.month': 'Month',
  'cal.prev': 'Previous',
  'cal.next': 'Next',
  'cal.today': 'Today',
  'cal.newTask': 'Task',
  'cal.newMeeting': 'Meeting',
  'cal.grid': 'Calendar grid',
  'cal.empty': 'No tasks or meetings in this period',
  'cal.forbidden.title': 'No access to the calendar',
  'cal.forbidden.text': 'The calendar shows tasks and meetings — it needs the right to tasks and activities.',
  'cal.forbiddenPeople.text': 'One of the selected employees is outside your access: your right covers your own tasks or your department. Remove them from the selection.',
  'cal.error.title': 'The calendar did not load',
  'cal.noPeople.title': 'Nobody selected',
  'cal.noPeople.text': 'This account has no employee card, so it has no calendar of its own. Choose employees whose calendars are open to you.',
  'cal.slot.title': 'New at this time',
  'cal.slot.text': 'Plan for {when}:',
  'cal.slot.task': 'A task',
  'cal.slot.meeting': 'A meeting',
  'cal.openDay': 'Open day {when}',
  'cal.more': '{count} more',
  'cal.people.me': 'Only me',
  'cal.people.department': 'My department',
  'cal.people.pick': 'Employees',
  'cal.people.filter': 'Find by name or department',
  'cal.people.done': 'Done',
  'cal.people.ownOnly': 'Only your own calendar is open to you',
  'cal.people.legend': 'Calendars on the grid',
  'cal.people.error': 'The employee list did not load',
  'cal.kind.task': 'Task',
  'cal.kind.meeting': 'Meeting',
  'cal.kind.call': 'Call',
  'cal.details.close': 'Close',
  'cal.conflict': 'Overlaps another meeting of the same person',
  'cal.conflict.short': 'overlap',
  'cal.when': 'When',
  'cal.status': 'Status',
  'cal.organizer': 'Organiser',
  'cal.record': 'Record',
  'cal.noRecord': 'No record',
  'cal.participants': 'Participants',
  'cal.participant.employee': 'employee',
  'cal.participant.contact': 'customer contact',
  'cal.contact.hidden': 'Customer contact (no access)',
  'cal.moveTo': 'Move to',
  'cal.moveTo.help': 'Same as dragging on the grid: a meeting keeps its length',
  'cal.move': 'Move',
  'cal.readOnly': 'The organiser or their manager can move and edit it',
  'cal.edit': 'Edit',
  'cal.plan': 'Plan',
  'cal.plan.task': 'Task…',
  'cal.plan.meeting': 'Meeting…',
  'cal.remind.default': 'Company default',
  'cal.remind.none': 'No reminder',
  'cal.remind.0': 'At the start',
  'cal.remind.5': '5 minutes before',
  'cal.remind.10': '10 minutes before',
  'cal.remind.15': '15 minutes before',
  'cal.remind.30': '30 minutes before',
  'cal.remind.60': '1 hour before',
  'cal.remind.120': '2 hours before',
  'cal.remind.1440': '1 day before',
  'cal.remind.before': '{minutes} min before',
  'cal.repeat.none': 'Does not repeat',
  'cal.repeat.daily': 'Every day',
  'cal.repeat.weekly': 'Every week',
  'cal.repeat.monthly': 'Every month',
  'cal.repeat.until': 'until {date}',
  'cal.form.task.overline': 'Task',
  'cal.form.task.new': 'New task',
  'cal.form.task.edit': 'Edit task',
  'cal.form.task.create': 'Create task',
  'cal.form.meeting.overline': 'Meeting',
  'cal.form.meeting.new': 'New meeting',
  'cal.form.meeting.edit': 'Edit meeting',
  'cal.form.meeting.create': 'Book meeting',
  'cal.form.save': 'Save',
  'cal.form.needSubject': 'A subject is required',
  'cal.form.needDueForRepeat': 'A recurring task needs a due date — the next one is counted from it',
  'cal.form.needAssignee': 'A task without a record needs an assignee — otherwise nobody sees it',
  'cal.form.needStart': 'The meeting needs a start',
  'cal.form.endBeforeStart': 'The meeting must end after it starts',
  'cal.form.subject': 'Subject',
  'cal.form.due': 'Due',
  'cal.form.remind': 'Remind',
  'cal.form.assignee': 'Assignee',
  'cal.form.assignee.ownHelp': 'You can assign tasks only to yourself',
  'cal.form.assignee.none': 'Not chosen',
  'cal.form.me': '{name} (me)',
  'cal.form.repeat': 'Repeat',
  'cal.form.until': 'Repeat until',
  'cal.form.until.help': 'Empty — no end. The next task appears when the current one is done or cancelled',
  'cal.form.body': 'Description',
  'cal.form.agenda': 'Agenda',
  'cal.form.start': 'Start',
  'cal.form.end': 'End',
  'cal.form.location': 'Place or link',
  'cal.form.location.help': 'Address, meeting room or video call link',
  'cal.form.employees': 'Employees',
  'cal.form.employees.help': 'Selected: {count}. Invitees are notified',
  'cal.form.employees.filter': 'Find by name or department',
  'cal.form.contacts': 'Customer contacts',
  'cal.form.contacts.remove': 'Remove {name}',
  'adm.settings.reminders': 'Reminders',
  'adm.settings.reminders.text': 'How long before a meeting or a task deadline the notification comes when the form names no lead time of its own.',
  'adm.settings.reminder': 'Remind before, minutes',
  'adm.settings.reminder.help': 'Applies to tasks and meetings planned after saving; planned ones keep theirs',
  'adm.settings.reminder.invalid': 'A whole number of minutes from 0 to 10080 (a week)',
  // Mail: letters to customers from a card and templates (#117)
  'nav.adminMail': 'Mail',
  'mail.write': 'Write an email',
  'mail.record.deal': 'Email about the deal',
  'mail.record.counterparty': 'Email to the customer',
  'mail.record.contact': 'Email to the contact',
  'mail.record.invoice': 'Email about the invoice',
  'mail.form': 'Email',
  'mail.close': 'Close',
  'mail.send': 'Send',
  'mail.sending': 'Sending…',
  'mail.draft.error': 'Could not prepare the email',
  'mail.notConnected': 'Mail is not connected: the email will be logged in the feed as refused and will not reach the customer. Connect it in Administration → Mail.',
  'mail.template': 'Template',
  'mail.template.blank': 'No template',
  'mail.template.none': 'No templates for this card',
  'mail.to': 'To',
  'mail.to.help': 'An address from the customer’s contacts or any other',
  'mail.recipients': 'Customer contacts',
  'mail.subject': 'Subject',
  'mail.body': 'Text',
  'mail.missing': 'Nothing to fill in: {list}. They are blank in the text — complete it by hand',
  'mail.attachments': 'Attachments',
  'mail.attachment.invoicePdf': 'invoice printout',
  'mail.attachment.unavailable.pending': 'still being scanned',
  'mail.attachment.unavailable.infected': 'blocked by the antivirus',
  'mail.attachment.unavailable.failed': 'scan failed',
  'mail.attachment.unavailable.missing': 'file is missing from storage',
  'mail.result.title': 'Email',
  'mail.result.sent': 'Sent: {to}',
  'mail.result.failed': 'The mail server did not answer — the email is queued for a retry, next attempt {when}.',
  'mail.result.rejected': 'Not sent: {reason}',
  'mail.result.pending': 'The email is logged; its delivery state is not known yet',
  'mail.feed.pending': 'waiting to be sent',
  'mail.feed.sending': 'sending',
  'mail.feed.sent': 'sent',
  'mail.feed.failed': 'queued for a retry',
  'mail.feed.failedBecause': 'queued for a retry: {reason}',
  'mail.feed.rejected': 'not sent',
  'mail.feed.rejectedBecause': 'not sent: {reason}',
  'nav.mailInbox': 'Mail triage',
  'mail.noSubject': '(no subject)',
  'mail.feed.inbound': 'Inbound',
  'mail.feed.reply': 'reply to our letter',
  'mail.feed.files': 'attachments: {files}',
  'mailbox.title': 'Inbound mail: IMAP mailboxes',
  'mailbox.lead': 'Letters from these mailboxes go to the customer\'s card feed: a reply to a CRM letter joins its thread, a known contact\'s letter goes to his card, the rest to the triage queue.',
  'mailbox.add': 'Connect mailbox',
  'mailbox.form': 'Mailbox settings',
  'mailbox.name': 'Name',
  'mailbox.kind': 'Kind',
  'mailbox.kind.shared': 'Shared',
  'mailbox.kind.personal': 'Personal',
  'mailbox.kind.personalOf': 'Personal: {owner}',
  'mailbox.owner': 'Owner',
  'mailbox.owner.noAccess': 'The user list is a separate right (users); the current owner can be kept',
  'mailbox.folder': 'Folder',
  'mailbox.enabled': 'Poll this mailbox',
  'mailbox.server': 'Server',
  'mailbox.state': 'State',
  'mailbox.pollNow': 'Check now',
  'mailbox.empty': 'No mailbox connected',
  'mailbox.empty.text': 'Inbound letters do not reach the CRM until at least one IMAP mailbox is connected',
  'mailbox.error': 'The mailbox list did not load',
  'mailbox.forbidden': 'Mailboxes are mail credentials',
  'mailbox.delete.confirm': 'Disconnect mailbox "{name}"?',
  'mailbox.delete.text': 'Polling stops. Letters already received stay in the customers\' cards.',
  'mailbox.status.idle': 'not polled yet',
  'mailbox.status.ok': 'polled {at}',
  'mailbox.status.failed': 'server unavailable, retry {at}: {error}',
  'mailbox.status.rejected': 'server refused; polling stopped until the settings are saved: {error}',
  'mailbox.poll.ok': '"{name}": {received} letters received, {unmatched} to triage',
  'mailbox.poll.failed': '"{name}": server unavailable — {error}',
  'mailbox.poll.rejected': '"{name}": server refused — {error}',
  'mailbox.poll.busy': '"{name}": the mailbox is being polled already',
  'mailbox.poll.disabled': '"{name}": polling is off or settings are incomplete',
  'inbox.title': 'Inbound mail triage',
  'inbox.lead': 'Letters whose sender was not found among contacts and counterparties. The mail-domain hint is only a hint: a person attaches the letter.',
  'inbox.ro': 'Only those with the mail triage right may attach or dismiss letters.',
  'inbox.forbidden': 'The mail triage queue is closed',
  'inbox.error': 'The triage queue did not load',
  'inbox.empty': 'No letters to triage',
  'inbox.empty.text': 'Every received letter is matched to a card',
  'inbox.noSender': 'no sender',
  'inbox.files': 'Attachments',
  'inbox.skipped': 'Not stored: {files}',
  'inbox.suggestion': 'Possibly {name} — by mail domain',
  'inbox.attachTo': 'Attach to',
  'inbox.target.counterparty': 'Counterparty',
  'inbox.target.contact': 'Contact',
  'inbox.target.deal': 'Deal',
  'inbox.attach': 'Attach',
  'inbox.dismiss': 'Not relevant',
  'adm.resource.mail.inbox': 'Inbound mail triage',
  'mail.anchor.any': 'Any card',
  'mail.anchor.deal': 'Deal',
  'mail.anchor.counterparty': 'Counterparty',
  'mail.anchor.contact': 'Contact',
  'mail.anchor.invoice': 'Invoice',
  'mail.adm.title': 'Mail',
  'mail.adm.lead': 'Mail server connection and email templates. Variables are filled in from the card the email is written from.',
  'mail.adm.add': 'New template',
  'mail.adm.templates': 'Email templates',
  'mail.adm.forbidden': 'No access to email templates',
  'mail.adm.error': 'Could not load the templates',
  'mail.adm.empty': 'No templates yet',
  'mail.adm.empty.text': 'Managers can write without a template; a template saves typing the same text again',
  'mail.adm.name': 'Name',
  'mail.adm.anchor': 'For card',
  'mail.adm.anchor.help': 'Decides which variables are available',
  'mail.adm.state': 'State',
  'mail.adm.actions': 'Actions',
  'mail.adm.actionsOf': 'Actions with template “{name}”',
  'mail.adm.edit': 'Edit template',
  'mail.adm.disable': 'Disable',
  'mail.adm.enable': 'Enable',
  'mail.adm.delete': 'Delete',
  'mail.adm.delete.confirm': 'Delete template “{name}”?',
  'mail.adm.delete.text': 'Sent emails stay in the feeds; the template will no longer be offered',
  'mail.adm.form': 'Email template',
  'mail.adm.variables': 'Variables',
  'mail.adm.variables.help': 'Click to insert into the text. An unknown variable or one of another card will not be saved',
  'mail.conn.title': 'SMTP connection',
  'mail.conn.forbidden': 'Mail connection is closed',
  'mail.conn.forbidden.text': 'Mail server credentials are a separate right (integrations)',
  'mail.conn.error': 'Could not load the mail connection',
  'mail.conn.off': 'Mail is off: emails from cards are logged in the feed as refused and do not reach customers',
  'mail.conn.enabled': 'Send emails',
  'mail.conn.host': 'Server',
  'mail.conn.port': 'Port',
  'mail.conn.security': 'Encryption',
  'mail.conn.security.starttls': 'STARTTLS',
  'mail.conn.security.ssl': 'SSL/TLS',
  'mail.conn.security.none': 'No encryption',
  'mail.conn.username': 'Login',
  'mail.conn.password': 'Password',
  'mail.conn.password.set': 'A password is stored; leaving the field empty keeps it',
  'mail.conn.password.unset': 'No password set',
  'mail.conn.password.clear': 'Clear password',
  'mail.conn.from': 'Sender address',
  'mail.conn.fromName': 'Sender name',
  'mail.conn.saved': 'Saved',

  // ИИ (#126)
  'nav.adminAi': 'AI',
  'adm.action.use': 'Use',
  'adm.resource.ai.assistant': 'AI functions',
  'ai.adm.title': 'AI',
  'ai.adm.lead': 'Language model provider, per-organization switch, token spend and prompts. Personal data is masked before it reaches the provider',
  'ai.adm.forbidden': 'AI settings are closed',
  'ai.conn.title': 'Provider connection',
  'ai.conn.forbidden': 'Provider connection is closed',
  'ai.conn.forbidden.text': 'The provider key, spend and call journal are a separate right (integrations)',
  'ai.conn.error': 'Could not load the AI connection',
  'ai.conn.off': 'AI is off: AI functions refuse with an explanation and send nothing to the provider',
  'ai.conn.masking': 'Names, phones, e-mail, passport, SNILS, INN, cards and accounts are replaced by labels before sending and restored in the answer. The journal keeps only the number of replacements, never the values',
  'ai.conn.enabled': 'AI is on',
  'ai.conn.provider': 'Provider',
  'ai.conn.provider.none': 'Not selected',
  'ai.conn.endpoint': 'API address',
  'ai.conn.endpoint.help': 'Empty — the public address of the provider',
  'ai.conn.folderId': 'Folder (folderId)',
  'ai.conn.scope': 'Access scope',
  'ai.conn.scope.help': 'As issued in the GigaChat account',
  'ai.conn.authEndpoint': 'Authorization address',
  'ai.conn.model': 'Model',
  'ai.conn.model.help': 'Empty — the default model of the provider',
  'ai.conn.embeddingModel': 'Embedding model',
  'ai.conn.secret': 'Access key',
  'ai.conn.secret.set': 'Key saved; an empty field keeps it',
  'ai.conn.secret.unset': 'No key set',
  'ai.conn.secret.clear': 'Clear key',
  'ai.conn.limit': 'Monthly token limit per user',
  'ai.conn.limit.help': 'A user over the limit is refused before the provider is called',
  'ai.conn.priceInput': 'Price of 1000 prompt tokens, RUB',
  'ai.conn.priceOutput': 'Price of 1000 answer tokens, RUB',
  'ai.conn.priceEmbedding': 'Price of 1000 embedding tokens, RUB',
  'ai.conn.price.help': 'Empty — cost is not computed and shown as a dash, not zero',
  'ai.conn.timeout': 'Request timeout, s',
  'ai.conn.saved': 'Saved',
  'ai.conn.check': 'Check connection',
  'ai.conn.checking': 'Checking…',
  'ai.check.result': 'Check result',
  'ai.check.ok': 'The provider answered',
  'ai.check.rejected': 'The provider refused',
  'ai.check.unavailable': 'The provider is unavailable',
  'ai.org.title': 'Organizations',
  'ai.org.lead': 'AI is switched on per legal entity: staff of a switched-off organization are refused with an explanation',
  'ai.org.empty': 'No organizations',
  'ai.org.name': 'Organization',
  'ai.org.state': 'AI',
  'ai.org.switch': 'AI for "{name}"',
  'ai.usage.title': 'Spend by user',
  'ai.usage.month': 'Month',
  'ai.usage.limit': 'Per-user limit: {limit} tokens a month',
  'ai.usage.empty': 'Nobody used AI this month',
  'ai.usage.user': 'User',
  'ai.usage.system': 'System',
  'ai.usage.calls': 'Calls',
  'ai.usage.failures': 'Failures',
  'ai.usage.input': 'Prompt tokens',
  'ai.usage.output': 'Answer tokens',
  'ai.usage.cost': 'Cost',
  'ai.usage.cost.unknown': 'The token price is not set for at least one call',
  'ai.cost.unknown': 'not set',
  'ai.calls.title': 'Call journal',
  'ai.calls.lead': 'Who, when, which prompt and how many tokens. Prompt and answer texts are not stored',
  'ai.calls.empty': 'No calls yet',
  'ai.calls.at': 'When',
  'ai.calls.prompt': 'Prompt',
  'ai.calls.embed': 'embeddings',
  'ai.calls.provider': 'Provider',
  'ai.calls.status': 'Outcome',
  'ai.calls.status.succeeded': 'succeeded',
  'ai.calls.status.failed': 'unavailable',
  'ai.calls.status.rejected': 'refused',
  'ai.calls.status.pending': 'in progress',
  'ai.calls.masked': 'Masked',
  'ai.calls.tokens': 'Tokens',
  'ai.prompts.title': 'Prompts',
  'ai.prompts.lead': 'An edit is a new version; the journal remembers which version produced an answer, and an earlier one can be restored',
  'ai.prompts.forbidden': 'Prompts are closed',
  'ai.prompts.forbidden.text': 'The prompt registry is a system reference (system settings)',
  'ai.prompts.empty': 'No prompts',
  'ai.prompts.add': 'New prompt',
  'ai.prompts.code': 'Code',
  'ai.prompts.code.help': 'Latin letters, digits, dot, hyphen; the feature calls the prompt by it',
  'ai.prompts.active': 'Active',
  'ai.prompts.variables': 'Variables',
  'ai.prompts.history': 'Versions',
  'ai.prompts.versions': 'versions: {count}',
  'ai.prompts.activate': 'Active version of {code}',
  'ai.prompts.actions': 'Actions',
  'ai.prompts.newVersion': 'New version',
  'ai.prompts.newVersionOf': 'New version of {code}',
  'ai.prompts.form': 'Prompt',
  'ai.prompts.format': 'Answer format',
  'ai.prompts.format.text': 'Text',
  'ai.prompts.format.json': 'JSON',
  'ai.prompts.temperature': 'Temperature',
  'ai.prompts.maxTokens': 'Answer limit, tokens',
  'ai.prompts.description': 'Description',
  'ai.prompts.system': 'Instruction (system)',
  'ai.prompts.user': 'Request',
  'ai.prompts.user.help': 'Variables go in double curly braces; the feature fills them, and a variable without a value is a refusal, not braces in the request',

  // Автосценарии (#116)
  'nav.adminAutomation': 'Automation',
  'adm.auto.title': 'Automation',
  'adm.auto.lead': 'A rule watches an event — a new record, a changed field or stage, a deadline — checks its conditions and acts. Rules of one group run top to bottom. A rule cannot be deleted: its run log points at it; switch it off instead.',
  'adm.auto.count': 'rules: {count}',
  'adm.auto.ro': 'Rules, their order and switching are changed by the system administrator. The run log is read-only.',
  'adm.auto.add': 'New rule',
  'adm.auto.forbidden': 'Automation is not available to you',
  'adm.auto.error': 'Could not load automation rules',
  'adm.auto.empty': 'No rules yet',
  'adm.auto.empty.text': 'Build the first one: event, conditions and action — no SQL.',
  'adm.auto.move': 'Move “{name}”: up and down arrows',
  'adm.auto.enabledOf': 'Rule “{name}” is on',
  'adm.auto.journalOf': 'Run log of “{name}”',
  'adm.auto.journal': 'Run log',
  'adm.auto.editOf': 'Edit rule “{name}”',
  'adm.auto.previous': '{label} — previous value',
  'adm.auto.and': 'and',
  'adm.auto.or': 'or',
  'adm.auto.if': 'if',
  'adm.auto.rawSummary': 'Conditions beyond the builder — opened as JSON text',
  'adm.auto.always': 'Always — no conditions',
  'adm.auto.overline': 'Automation rule',
  'adm.auto.rearmHint': 'Saving re-arms the rule: deadlines that passed before do not fire',
  'adm.auto.form': 'Automation rule',
  'adm.auto.name': 'Name',
  'adm.auto.description': 'Why this rule exists',
  'adm.auto.description.help': 'For whoever will work out why something happened',
  'adm.auto.entity': 'Entity',
  'adm.auto.entityImmutable': 'The entity of a rule does not change: conditions name its fields. Need another — create a new rule',
  'adm.auto.trigger': 'Event',
  'adm.auto.trigger.created': 'Record created',
  'adm.auto.trigger.field_changed': 'Field changed',
  'adm.auto.trigger.stage_changed': 'Stage changed',
  'adm.auto.trigger.sla_breached': 'Deadline missed',
  'adm.auto.trigger.scheduled': 'On a schedule',
  'adm.auto.slaMeans': 'The deadline is missed when {what}',
  'adm.auto.timer': 'When',
  'adm.auto.timerAmount': 'How much',
  'adm.auto.timerUnit': 'Unit',
  'adm.auto.timerDirection': 'Before or after',
  'adm.auto.timerAnchor': 'Counted from',
  'adm.auto.timerCustom': 'Offset, ISO-8601',
  'adm.auto.timer.help': 'At most a year either way. Deadlines that passed before the rule was saved do not fire',
  'adm.auto.unit.M': 'minutes',
  'adm.auto.unit.H': 'hours',
  'adm.auto.unit.D': 'days',
  'adm.auto.after': 'after',
  'adm.auto.before': 'before',
  'adm.auto.conditions': 'Conditions',
  'adm.auto.rawText': 'The conditions of this rule go beyond the builder (negation or more than two levels) and are edited as text. The server checks them on save',
  'adm.auto.rawLabel': 'Conditions, JSON',
  'adm.auto.rawInvalid': 'The conditions are not JSON: check brackets and quotes',
  'adm.auto.rootGroup': 'Rule conditions',
  'adm.auto.groupN': 'Group {n}',
  'adm.auto.modeOf': '{where}: how to combine',
  'adm.auto.mode.all': 'All conditions',
  'adm.auto.mode.any': 'Any of the conditions',
  'adm.auto.emptyGroup': 'Empty group',
  'adm.auto.removeGroup': 'Remove group {n}',
  'adm.auto.addConditionTo': 'Add a condition: {where}',
  'adm.auto.addCondition': 'Condition',
  'adm.auto.addGroup': 'Condition group',
  'adm.auto.condField': 'Field of condition {n}',
  'adm.auto.condOp': 'Comparison of condition {n}',
  'adm.auto.condValue': 'Value of condition {n}',
  'adm.auto.condRemove': 'Remove condition {n}',
  'adm.auto.true': 'yes',
  'adm.auto.false': 'no',
  'adm.auto.listHint': 'values separated by commas',
  'adm.auto.actions': 'Actions',
  'adm.auto.noActions': 'A rule without actions cannot be saved: it would fill the log with “matched” and do nothing',
  'adm.auto.addAction': 'Action',
  'adm.auto.placeholders': 'Text may include a record field: {number}, {title}',
  'adm.auto.actionN': 'Action {n}',
  'adm.auto.actionType': 'What to do, action {n}',
  'adm.auto.actionRemove': 'Remove action {n}',
  'adm.auto.action.create_task': 'Create a task',
  'adm.auto.action.notify': 'Notify',
  'adm.auto.action.assign': 'Assign responsible',
  'adm.auto.action.send_email': 'Send an e-mail',
  'adm.auto.action.webhook': 'Call a webhook',
  'adm.auto.param.create_task.subject': 'Task subject',
  'adm.auto.param.create_task.dueInHours': 'Due in, hours',
  'adm.auto.param.create_task.assigneeEmployeeId': 'Assignee (the responsible by default)',
  'adm.auto.param.notify.recipient': 'Whom to notify',
  'adm.auto.param.notify.title': 'Title',
  'adm.auto.param.notify.message': 'Text',
  'adm.auto.param.notify.kind': 'Kind',
  'adm.auto.param.assign.to': 'Assign to',
  'adm.auto.param.assign.employeeId': 'Employee',
  'adm.auto.param.send_email.template': 'E-mail template',
  'adm.auto.param.send_email.to': 'To (the deal’s main contact by default)',
  'adm.auto.param.webhook.url': 'URL',
  'adm.auto.option.notify.kind.info': 'Information',
  'adm.auto.option.notify.kind.warning': 'Warning',
  'adm.auto.option.notify.kind.task': 'Task',
  'adm.auto.option.assign.to.employee': 'A given employee',
  'adm.auto.option.assign.to.manager': 'The responsible’s manager',
  'adm.auto.recipient.responsible': 'The responsible',
  'adm.auto.recipient.manager': 'The responsible’s manager',
  'adm.auto.recipient.role': 'Everyone with a role',
  'adm.auto.recipient.user': 'A user',
  'adm.auto.recipient.role.value': 'Role code',
  'adm.auto.recipient.user.value': 'User id',
  'adm.auto.activeLabel': 'Rule is on',
  'adm.auto.conflict': 'The rule was changed meanwhile — close the form and open it again',
  'adm.auto.record': 'Record',
  'adm.auto.record.help': 'Log and check for one record: why the rule did or did not fire on it',
  'adm.auto.allRecords': 'All records',
  'adm.auto.show': 'Show',
  'adm.auto.evaluate': 'Check conditions now',
  'adm.auto.evaluate.help': 'Does nothing: only shows whether the rule would fire and why',
  'adm.auto.verdict': 'Condition check',
  'adm.auto.wouldFire': 'Conditions hold — the rule would fire',
  'adm.auto.wouldNotFire': 'Conditions do not hold — the rule would not fire',
  'adm.auto.met': 'met',
  'adm.auto.notMet': 'not met',
  'adm.auto.actual': 'value “{value}”',
  'adm.auto.actualNone': 'no value',
  'adm.auto.kind.all': 'all of',
  'adm.auto.kind.any': 'any of',
  'adm.auto.kind.not': 'not',
  'adm.auto.runs': 'Rule runs',
  'adm.auto.actionRuns': 'Action execution',
  'adm.auto.noRuns': 'The rule has not run yet',
  'adm.auto.noRunsOnRecord': 'The rule has not run on this record',
  'adm.auto.noRuns.text': 'A run appears when the rule’s event happens; a switched-off rule does not run. Conditions can be checked without a run',
  'adm.auto.col.when': 'When',
  'adm.auto.col.record': 'Record',
  'adm.auto.col.result': 'Result',
  'adm.auto.col.why': 'Reason',
  'adm.auto.col.action': 'Action',
  'adm.auto.col.outcome': 'Outcome',
  'adm.auto.runsOf': 'Runs on record {record}',
  'adm.auto.run.matched': 'Fired',
  'adm.auto.run.notMatched': 'Did not fire',
  'adm.auto.run.failed': 'Error',
  'adm.auto.run.acted': 'actions: {count}',
  'adm.auto.run.depth': 'in a rule chain, depth {depth}',
  'adm.auto.outcome.done': 'Done',
  'adm.auto.outcome.rejected': 'Refused',
  'adm.auto.outcome.failed': 'Failed, will retry',

  // Telephony (#122)
  'nav.adminTelephony': 'Telephony',
  'nav.messengerInbox': 'Messenger triage',
  'nav.adminMessengers': 'Messengers',
  'timeline.kind.message': 'Message',
  'messenger.channel.telegram': 'Telegram',
  'messenger.channel.whatsapp': 'WhatsApp',
  'messenger.direction.inbound': 'Client',
  'messenger.direction.outbound': 'Us',
  'messenger.delivery.received': 'Received',
  'messenger.delivery.pending': 'Queued',
  'messenger.delivery.sending': 'Sending',
  'messenger.delivery.sent': 'Sent',
  'messenger.delivery.failed': 'Not delivered — will retry',
  'messenger.delivery.rejected': 'Refused',
  'messenger.reply.title': 'Reply in the messenger',
  'messenger.reply.chat': 'Chat',
  'messenger.reply.text': 'Reply text',
  'messenger.reply.send': 'Send',
  'messenger.reply.sending': 'Sending…',
  'messenger.reply.sent': 'Sent to the client’s chat',
  'messenger.reply.failed': 'The messenger did not answer: the message is saved and will be retried',
  'messenger.reply.rejected': 'Not sent: {reason}',
  'messenger.reply.unusable.telegram': 'Telegram is not connected: a reply will be refused until an administrator sets the bot token',
  'messenger.reply.unusable.whatsapp': 'WhatsApp is not connected: a reply will be refused until an administrator sets up Meta',
  'messenger.reply.windowClosed': 'The client last wrote in WhatsApp more than 24 hours ago ({at}). Outside the window WhatsApp forbids free text and requires an approved template, and templates are not connected in the CRM. Call the client or send an e-mail.',
  'messenger.inbox.title': 'Messenger triage',
  'messenger.inbox.lead': 'Telegram and WhatsApp chats whose writer the system did not recognise. Bind a chat to a contact and its messages land in the card’s feed.',
  'messenger.inbox.ro': 'Read only: binding chats needs the triage right',
  'messenger.inbox.forbidden': 'The messenger triage queue needs its own right',
  'messenger.inbox.error': 'Could not load the triage queue',
  'messenger.inbox.empty': 'No unrecognised chats',
  'messenger.inbox.empty.text': 'Everyone who wrote in Telegram and WhatsApp is recognised and already on a card.',
  'messenger.inbox.messages': 'Latest messages',
  'messenger.inbox.suggestion': 'Possibly {name}: this @username is on a contact card. Check before binding.',
  'messenger.inbox.attachTo': 'Bind to',
  'messenger.inbox.attach': 'Bind',
  'messenger.adm.title': 'Messengers',
  'messenger.adm.lead': 'A Telegram bot and a WhatsApp Business number: client messages go to the card’s feed, the manager’s answer to the same chat.',
  'messenger.adm.forbidden': 'Messenger settings need the integrations right',
  'messenger.adm.error': 'Could not load the messenger settings',
  'messenger.adm.incomplete': 'Incomplete',
  'messenger.adm.webhook.telegram': 'Webhook address for Telegram (registered with the button below — setWebhook with the secret):',
  'messenger.adm.webhook.whatsapp': 'Callback URL for Meta (WhatsApp → Configuration → Webhook, field messages):',
  'messenger.adm.enabled.telegram': 'Telegram enabled',
  'messenger.adm.enabled.whatsapp': 'WhatsApp enabled',
  'messenger.adm.endpoint': 'API address',
  'messenger.adm.endpoint.telegram': 'Default https://api.telegram.org',
  'messenger.adm.endpoint.whatsapp': 'Default https://graph.facebook.com/v21.0',
  'messenger.adm.phoneNumberId': 'Phone number ID',
  'messenger.adm.phoneNumberId.help': 'The sender number’s id from the Meta console (WhatsApp → API Setup)',
  'messenger.adm.token.telegram': 'Bot token (from @BotFather)',
  'messenger.adm.token.whatsapp': 'Permanent access token (System User)',
  'messenger.adm.secret': 'Webhook secret (secret_token)',
  'messenger.adm.appSecret': 'App secret (X-Hub-Signature-256)',
  'messenger.adm.verifyToken': 'Verify token (webhook check)',
  'messenger.adm.secret.set': 'Stored. An empty field keeps the stored value.',
  'messenger.adm.secret.unset': 'Not set',
  'messenger.adm.saved': 'Saved',
  'messenger.adm.register': 'Register the webhook with Telegram',
  'messenger.adm.registered': 'Telegram accepted {url}',
  'messenger.adm.events': 'Webhook journal',
  'messenger.adm.events.empty': 'No webhooks from messengers yet',
  'messenger.adm.events.at': 'Received',
  'messenger.adm.events.channel': 'Channel',
  'messenger.adm.events.status': 'Outcome',
  'messenger.adm.events.detail': 'Details',
  'messenger.event.processed': 'Accepted',
  'messenger.event.duplicate': 'Repeat',
  'messenger.event.ignored': 'Service',
  'messenger.event.rejected': 'Rejected',
  'messenger.event.failed': 'Failed',
  'telephony.call': 'Call',
  'telephony.call.pending': 'Connecting…',
  'telephony.call.ordered': 'The PBX is connecting: your phone rings first, then {number}',
  'telephony.call.rejected': 'The PBX refused the call: {reason}',
  'telephony.call.unavailable': 'The PBX did not answer — dial by hand. The call is in the feed as planned.',
  'telephony.incoming.title': 'Incoming call',
  'telephony.incoming.close': 'Close',
  'telephony.incoming.hidden': 'Number withheld',
  'telephony.incoming.open': 'Open the card',
  'telephony.incoming.unknown': 'New number',
  'telephony.incoming.createLead': 'Create a lead',
  'telephony.incoming.others': 'More cards with this number: {count}',
  'telephony.entity.contact': 'Contact',
  'telephony.entity.counterparty': 'Counterparty',
  'telephony.entity.lead': 'Lead',
  'telephony.entity.deal': 'Deal',
  'telephony.direction.inbound': 'Inbound',
  'telephony.direction.outbound': 'Outbound',
  'telephony.duration.minutes': '{minutes} min {seconds} s',
  'telephony.duration.seconds': '{seconds} s',
  'telephony.recording': 'Call recording',
  'telephony.recording.play': 'Play the recording',
  'telephony.recording.loading': 'Loading the recording…',
  'telephony.recording.link': 'Call recording',
  'telephony.adm.title': 'Telephony',
  'telephony.adm.lead': 'Mango Office cloud PBX: click-to-call, the incoming-call popup, calls with recordings in the feed.',
  'telephony.adm.forbidden': 'Telephony settings need the integrations permission',
  'telephony.adm.error': 'Could not load the telephony settings',
  'telephony.adm.connection': 'PBX connection',
  'telephony.adm.webhook': 'Address for the PBX (Mango Office → Integrations → API → external system address):',
  'telephony.adm.enabled': 'Telephony enabled',
  'telephony.adm.endpoint': 'PBX API address',
  'telephony.adm.endpoint.help': 'For Mango Office — https://app.mango-office.ru/vpbx',
  'telephony.adm.line': 'Outbound line number',
  'telephony.adm.line.help': 'Optional: without it the PBX picks the line',
  'telephony.adm.apiKey': 'Key (vpbx_api_key)',
  'telephony.adm.salt': 'Signing salt (vpbx_api_salt)',
  'telephony.adm.secret.set': 'Saved. An empty field keeps the stored value.',
  'telephony.adm.secret.unset': 'Not set',
  'telephony.adm.extensions': 'Employee extensions',
  'telephony.adm.extensions.help': 'The PBX names a ringing phone by its extension: the popup goes to that employee, and a call from a card starts with their phone.',
  'telephony.adm.extensions.empty': 'No extensions mapped: the popup goes to the customer\'s manager, and nobody can call from a card.',
  'telephony.adm.employee': 'Employee',
  'telephony.adm.extension': 'Extension',
  'telephony.adm.add': 'Add',
  'telephony.adm.remove': 'Remove',
  'telephony.adm.saved': 'Saved',
  'telephony.adm.events': 'PBX event journal',
  'telephony.adm.events.empty': 'No events from the PBX yet',
  'telephony.adm.events.at': 'Received',
  'telephony.adm.events.type': 'Event',
  'telephony.adm.events.status': 'Outcome',
  'telephony.adm.events.detail': 'Details',
  'nav.adminIntegrations': 'Integrations',
  'integrations.title': 'Integrations',
  'integrations.lead': 'All connections to external systems, push channels and outgoing webhooks on CRM events. Credentials are stored encrypted and never returned.',
  'integrations.forbidden': 'Integrations require the integrations permission',
  'integrations.error': 'Could not load integration data',
  'integrations.connections': 'Connections',
  'integrations.col.name': 'Connection',
  'integrations.col.state': 'State',
  'integrations.col.credentials': 'Credentials',
  'integrations.col.check': 'Connection check',
  'integrations.col.where': 'Configured in',
  'integrations.credentials.set': 'Set',
  'integrations.credentials.unset': 'Not set',
  'integrations.check': 'Check connection',
  'integrations.check.never': 'Not checked yet',
  'integrations.check.none': 'No check: verified by the first call',
  'integrations.check.ok': 'Works',
  'integrations.check.failed': 'Failed',
  'integrations.where.screen': 'Open settings',
  'integrations.where.push': 'Below, in push channels',
  'integrations.where.messenger': 'On the messengers screen',
  'integrations.where.stub': 'Stub: no real adapter yet',
  'integrations.where.other': 'Unknown connection: configured via REST',
  'integrations.push': 'Push channels',
  'integrations.push.lead': 'Secrets are write-only: the server says whether one is set, never what it is. An empty field keeps the stored value.',
  'integrations.push.webpush': 'Browser push (Web Push)',
  'integrations.push.fcm': 'Android push (FCM)',
  'integrations.push.rustore': 'RuStore push',
  'integrations.push.enabled': 'Channel enabled',
  'integrations.push.incomplete': 'Enabled but incomplete',
  'integrations.push.vapid': 'Generate VAPID keys',
  'integrations.push.field.publicKey': 'VAPID public key',
  'integrations.push.field.subject': 'VAPID contact (mailto: or https:)',
  'integrations.push.field.projectId': 'Project id',
  'integrations.push.field.clientEmail': 'Service account e-mail',
  'integrations.push.field.endpoint': 'API address',
  'integrations.push.field.tokenUri': 'Token URI',
  'integrations.push.secret.webpush': 'VAPID private key',
  'integrations.push.secret.fcm': 'Service account private key (PEM)',
  'integrations.push.secret.rustore': 'Project service token',
  'integrations.secret.kept': 'Stored. An empty field keeps it.',
  'integrations.secret.unset': 'Not set',
  'integrations.saved': 'Saved',
  'integrations.cancel': 'Cancel',
  'integrations.webhooks': 'Outgoing webhooks',
  'integrations.webhooks.lead': 'An external address receives a POST on the chosen events. The body is signed with HMAC-SHA256 using the subscription secret: header X-CRM-Signature "t=<time>,v1=<signature>" over "<time>.<body>". An unavailable receiver (5xx, no answer) is retried with growing pauses, a refusal (4xx) is not. Internal network addresses are forbidden.',
  'integrations.webhooks.add': 'Add subscription',
  'integrations.webhooks.edit': 'Edit',
  'integrations.webhooks.empty': 'No subscriptions: CRM events are sent nowhere',
  'integrations.webhooks.subscriptions': 'Subscriptions',
  'integrations.webhooks.name': 'Name',
  'integrations.webhooks.url': 'Receiver URL',
  'integrations.webhooks.url.help': 'https://… on the public network; internal addresses are forbidden',
  'integrations.webhooks.events': 'Events',
  'integrations.webhooks.active': 'Subscription enabled',
  'integrations.webhooks.stats': 'Deliveries',
  'integrations.webhooks.counts': 'delivered {delivered}, waiting {waiting}, lost {lost}',
  'integrations.webhooks.journal': 'Journal',
  'integrations.webhooks.actions': 'Actions',
  'integrations.webhooks.ping': 'Ping receiver',
  'integrations.webhooks.ping.ok': 'Receiver answered',
  'integrations.webhooks.ping.rejected': 'Receiver refused',
  'integrations.webhooks.ping.unavailable': 'Receiver unavailable',
  'integrations.webhooks.rotate': 'New secret',
  'integrations.webhooks.rotate.confirm': 'Issue a new secret? The old one stops working at once, and the receiver will refuse until it is replaced.',
  'integrations.webhooks.delete': 'Delete',
  'integrations.webhooks.delete.confirm': 'Delete the subscription? The delivery journal stays; waiting deliveries will not be sent.',
  'integrations.webhooks.secret': 'Signing secret',
  'integrations.webhooks.secret.once': 'Secret of subscription "{name}" — copy it now: it is shown once, afterwards it can only be reissued.',
  'integrations.webhooks.secret.hide': 'Copied, hide',
  'integrations.journal': 'Delivery journal',
  'integrations.journal.all': 'Show all subscriptions',
  'integrations.journal.status': 'Delivery state',
  'integrations.journal.status.any': 'All states',
  'integrations.journal.empty': 'No deliveries yet',
  'integrations.journal.at': 'Time',
  'integrations.journal.subscription': 'Subscription',
  'integrations.journal.event': 'Event',
  'integrations.journal.state': 'State',
  'integrations.journal.attempts': 'Attempts',
  'integrations.journal.attemptsCount': 'Attempts: {count}',
  'integrations.journal.attemptsTitle': 'Delivery attempts',
  'integrations.journal.next': 'Next attempt',
  'integrations.journal.result': 'Outcome',
  'integrations.journal.code': 'Status code',
  'integrations.journal.answer': 'Receiver answer',
  'integrations.journal.retry': 'Retry now',
  'integrations.delivery.pending': 'Pending',
  'integrations.delivery.sending': 'Sending',
  'integrations.delivery.delivered': 'Delivered',
  'integrations.delivery.failed': 'Failed, will retry',
  'integrations.delivery.rejected': 'Refused by receiver',
  'integrations.delivery.abandoned': 'Abandoned after all attempts',
  'telephony.event.received': 'Received',
  'telephony.event.processed': 'Processed',
  'telephony.event.ignored': 'No action',
  'telephony.event.rejected': 'Rejected: signature',
  'telephony.event.failed': 'Failed',
  'summary.title': 'Negotiation summary',
  'summary.button': 'Summary',
  'summary.again': 'Summarise again',
  'summary.from': 'From',
  'summary.to': 'To',
  'summary.intro': 'A summary of letters, calls, messages and comments for the period — every statement links to the record it was taken from.',
  'summary.state.working': 'The summary is being prepared…',
  'summary.state.failed': 'No summary',
  'summary.section.agreements': 'Agreements',
  'summary.section.openQuestions': 'Open questions',
  'summary.section.nextSteps': 'Next step',
  'summary.section.empty': 'None',
  'summary.unsupported.title': 'Not backed by a source',
  'summary.unsupported.hint': 'The model said this without citing a record it was given — do not take it on trust.',
  'summary.unsupported.no_source': 'no citation',
  'summary.unsupported.unknown_source': 'cites a source that does not exist: {labels}',
  'summary.unknownLabels': 'the model also cited what does not exist: {labels}',
  'summary.sources': 'Sources in the request: {count}',
  'summary.omitted': 'Left out of the request: {count} earlier records of the period',
  'summary.notInFeed': 'This record is not loaded in the feed — press “Show earlier”',
  'summary.untranscribed': 'not transcribed',
  'summary.fragment': 'Call {clock}',
  'summary.callButton': 'Call summary',
  'summary.requestedAt': 'Made {at}',
  'transcript.button': 'Transcribe',
  'transcript.show': 'Transcript',
  'transcript.hide': 'Hide transcript',
  'transcript.loading': 'Loading…',
  'transcript.state.pending': 'Transcription queued',
  'transcript.state.submitted': 'Recognising the recording…',
  'transcript.state.failed': 'The recognition service did not answer, will retry: {error}',
  'transcript.state.rejected': 'Not transcribed: {error}',
  'transcript.retry': 'Transcribe again',
  'transcript.refresh': 'Refresh',
  'transcript.empty': 'Not a word was recognised in the recording',
  'speechkit.title': 'Speech recognition (Yandex SpeechKit)',
  'speechkit.intro': 'Transcripts of call recordings. The key is an API key of a Yandex Cloud service account with the ai.speechkit-stt.user role (the YandexGPT one will do).',
  'speechkit.enabled': 'Enabled',
  'speechkit.endpoint': 'Recognition API address',
  'speechkit.operationEndpoint': 'Operations API address',
  'speechkit.folderId': 'Folder id (optional)',
  'speechkit.model': 'Model',
  'speechkit.apiKey': 'API key',
  'speechkit.apiKeySet': 'A key is stored — leave empty to keep it',
  'speechkit.save': 'Save',
  'speechkit.saved': 'Saved',
  'speechkit.usable': 'Connected',
  'speechkit.notUsable': 'Not connected',
  // Lead scoring (#129)
  'nav.leadScoreModel': 'Lead scoring',
  'admin.rule.field.scoreClass': 'Lead score',
  'column.score_class': 'Score',
  'column.score_probability': 'Conversion probability',
  'column.score_method': 'Scored by',
  'column.scored_at': 'Scored',
  'value.sales.lead.score_class.hot': 'Hot',
  'value.sales.lead.score_class.warm': 'Warm',
  'value.sales.lead.score_class.cold': 'Cold',
  'value.sales.lead.score_method.model': 'Model',
  'value.sales.lead.score_method.rule': 'Rule',
  'leadScore.title': 'Lead score',
  'leadScore.loading': 'Loading the score…',
  'leadScore.error': 'Could not load the score',
  'leadScore.none': 'No score yet: a new lead is scored within a minute of arriving',
  'leadScore.rescore': 'Rescore',
  'leadScore.rescoring': 'Rescoring…',
  'leadScore.why': 'Why',
  'leadScore.byModel': 'Conversion probability {probability} — model',
  'leadScore.byRule': 'Rule, not a model: {points} point(s)',
  'leadScore.byRuleInsufficient': 'Rule, not a model (too few leads with an outcome): {points} point(s)',
  'leadScore.text.analyzed': 'Enquiry text (AI): {signals}',
  'leadScore.text.no_text': 'The enquiry has no text to read',
  'leadScore.text.pending': 'The enquiry text is waiting for AI',
  'leadScore.text.unavailable': 'The enquiry text was not read: AI unavailable',
  'leadScore.text.failed': 'The AI provider did not answer — will retry',
  'leadScore.text.rejected': 'AI could not read the enquiry text',
  'leadScore.intent.high': 'high intent',
  'leadScore.intent.medium': 'medium intent',
  'leadScore.intent.low': 'weak intent',
  'leadScore.intent.none': 'not about buying',
  'leadScore.signal.urgent': 'urgent',
  'leadScore.signal.budget': 'budget named',
  'leadScore.signal.spam': 'looks like spam',
  'leadScore.value.yes': 'yes',
  'leadScore.value.no': 'no',
  'leadScore.factorLine': '{factor} — {effect} ({kind})',
  'leadScore.kind.model': 'model',
  'leadScore.kind.rule': 'rule',
  'leadScore.kind.text': 'text',
  'leadScore.factor.intent': 'Intent from the text: {value}',
  'leadScore.factor.source': 'Source: {value}',
  'leadScore.feature.source': 'Source: {value}',
  'leadScore.model.lead': 'Logistic regression on leads that ended converted or rejected. Until there are enough of them, leads are scored by a points rule — with no probability.',
  'leadScore.model.forbidden': 'The lead scoring report is not available to you',
  'leadScore.model.coverage': 'Open leads: by the model — {model}, by the rule — {rule}, unscored — {unscored}',
  'leadScore.model.none.title': 'The model has not been trained yet',
  'leadScore.model.none.text': 'Leads are scored by the points rule. Training needs at least {min} leads with an outcome.',
  'leadScore.model.insufficient.title': 'Not enough data for a model',
  'leadScore.model.insufficient.text': '{message}. Attempt of {date}. Leads are scored by the rule, with no probability.',
  'leadScore.model.summary': 'Trained {date}: {train} leads in training, {holdout} in the holdout (arrived since {from}). Hot from {hot}, warm from {warm}.',
  'leadScore.model.textLearned': 'Enquiry text signals (AI) are learned by the model: training had leads with a read text.',
  'leadScore.model.textByRule': 'The model has not seen leads with a read text yet — the text enters as the rule\'s fixed offsets.',
  'leadScore.model.origins': 'Training features: intake snapshot — {intake}, creation journal — {journal}. Left out of training — {excluded}: there is no record of how they arrived, and their current row describes qualification rather than the enquiry.',
  'leadScore.model.col.baseline': 'Without the model',
  'leadScore.model.aucHint': 'Ranking: the model against the points rule',
  'leadScore.model.baselineNote': 'AUC is compared with the points rule; log-loss and Brier with "always the average conversion": the rule gives points, not a probability.',
  'leadScore.model.col.leads': 'Leads',
  'leadScore.model.col.actual': 'Converted',
  'leadScore.model.rates': 'Conversion: training {train}, holdout {holdout}',
  'leadScore.factor.has_phone': 'Phone given: {value}',
  'leadScore.feature.has_phone': 'Phone given',
  'leadScore.factor.has_email': 'E-mail given: {value}',
  'leadScore.feature.has_email': 'E-mail given',
  'leadScore.factor.corporate_email': 'E-mail on a company domain: {value}',
  'leadScore.feature.corporate_email': 'E-mail on a company domain',
  'leadScore.factor.has_company': 'Company named: {value}',
  'leadScore.feature.has_company': 'Company named',
  'leadScore.factor.has_inn': 'INN given: {value}',
  'leadScore.feature.has_inn': 'INN given',
  'leadScore.factor.known_client': 'Already a known client: {value}',
  'leadScore.feature.known_client': 'Already a known client',
  'leadScore.factor.has_utm': 'Came with a campaign tag (UTM): {value}',
  'leadScore.feature.has_utm': 'Came with a campaign tag (UTM)',
  'leadScore.factor.message_words': 'Words in the message: {value}',
  'leadScore.feature.message_words': 'Message length (log)',
  'leadScore.factor.text_read': 'Text read by AI: {value}',
  'leadScore.feature.text_read': 'Text read by AI',
  'leadScore.factor.intent_high': 'High intent to buy: {value}',
  'leadScore.feature.intent_high': 'High intent to buy',
  'leadScore.factor.intent_low': 'Weak intent: {value}',
  'leadScore.feature.intent_low': 'Weak intent',
  'leadScore.factor.urgent': 'Urgent: {value}',
  'leadScore.feature.urgent': 'Urgent',
  'leadScore.factor.budget_mentioned': 'Budget or volume named: {value}',
  'leadScore.feature.budget_mentioned': 'Budget or volume named',
  'leadScore.factor.spam': 'Spam: {value}',
  'leadScore.feature.spam': 'Spam',

  // Tasks proposed by AI (#131)
  'notifications.kind.task_proposed': 'Tasks proposed by AI',
  'proposals.title': 'Proposed by AI',
  'proposals.error': 'Could not load the proposed tasks',
  'proposals.due': 'Due: {date}',
  'proposals.noDue': 'No due date: {reason}',
  'proposals.basis': 'Basis: “{text}”',
  'proposals.basisUnverified': 'Basis (not found word for word in the text): {text}',
  'proposals.assignee': 'Assignee: {name}',
  'proposals.noAssignee': 'No assignee determined',
  'proposals.accept': 'Confirm',
  'proposals.notAssignable': 'You cannot assign the proposed person — choose another',
  'proposals.edit': 'Edit and confirm',
  'proposals.dismiss': 'Dismiss',
  'proposals.me': 'Me',
  'proposals.onLeave': 'on leave until {until}',
  'proposals.load': 'tasks in 3 days: {count}',
  'proposals.form.subject': 'Task subject',
  'proposals.form.due': 'Due',
  'proposals.form.assignee': 'Assignee',
  'proposals.form.submit': 'Create task',
  'proposals.form.cancel': 'Cancel',
  'proposals.source.emailIn': 'customer letter {date}',
  'proposals.source.emailOut': 'our letter {date}',
  'proposals.source.call': 'call {date}',
  'proposals.source.comment': 'comment {date}',
  'aiTasks.title': 'Tasks from letters, calls and comments',
  'aiTasks.intro':
    'AI reads matched letters, transcribed calls and comments and proposes tasks with an assignee and a ' +
    'due date; a task appears only once confirmed. Every source costs tokens; what arrives while the ' +
    'feature is off is not read later.',
  'aiTasks.enabled': 'Propose tasks',

  // Next step on a deal (#133)
  'nextStep.title': 'Next step',
  'nextStep.error': 'Could not load the recommendations',
  'nextStep.none': 'No open recommendations',
  'nextStep.kind.quote_unanswered': 'Quote unanswered',
  'nextStep.kind.stage_stuck': 'Stuck on stage',
  'nextStep.kind.no_activity': 'No contact',
  'nextStep.deal': 'Deal {number}',
  'nextStep.reason': 'Pretext:',
  'nextStep.opener': 'Open with: “{text}”',
  'nextStep.source.ai': 'Pretext suggested by AI',
  'nextStep.source.template': 'Pretext is a system template',
  'nextStep.accept': 'Create task',
  'nextStep.dismiss': 'Dismiss',
  'nextStep.dismissReason': 'Reason (optional)',
  'nextStep.dismissConfirm': 'Dismiss',
  'nextStep.cancel': 'Cancel',
  'nextStep.decidedBy': 'Decided by the owner: {name}',
  'nextStep.notYours': 'You cannot decide recommendations on this deal',
  'nextStep.history': 'Decisions on recommendations: {count}',
  'nextStep.status.accepted': 'accepted',
  'nextStep.status.dismissed': 'dismissed',
  'nextStep.status.resolved': 'no longer relevant',
  'nextStep.status.open': 'open',
  'nextStepAdmin.title': 'Pretext for the next step on a deal',
  'nextStepAdmin.intro':
    'Recommendations "call about an unanswered quote", "the deal is stuck", "no contact for long" are ' +
    'always found by rules. When on, AI writes a ready pretext for the call for every new recommendation — ' +
    'this costs tokens; when off, a template is shown and labelled as one.',
  'nextStepAdmin.enabled': 'Write the pretext with AI',

  // Draft answer to a customer (#134)
  'replyDraft.title': 'AI draft answer',
  'replyDraft.button': 'Draft an answer',
  'replyDraft.again': 'New draft',
  'replyDraft.working': 'The draft is being written',
  'replyDraft.inserted': 'The draft is in the field — read and edit it before sending',
  'replyDraft.failed': 'No draft: {reason}',
  'replyDraft.basis': 'What the draft relied on',
  'replyDraft.contracts': 'Contracts in force',
  'replyDraft.history': 'History records',
  'replyDraft.cited': 'cited in the answer',
  'replyDraft.noContracts': 'No contracts in force — no terms in the draft come from a contract',
  'replyDraft.contractsWithheld': 'The customer has contracts you cannot see: they were not given to the draft',
  'replyDraft.unknown': 'The model cited records it was never given: {labels}',
  'replyDraft.noKnowledgeBase': 'The CRM has no company knowledge base: the draft knows no policies or general rules',
  'replyDraft.review': 'The draft goes nowhere by itself: only the Send button sends',
  'mail.reply.button': 'Reply',
  'mail.reply.title': 'Reply to the letter',
  'mail.reply.loading': 'Opening the reply…',

  // CRM assistant (#136)
  'nav.assistant': 'Assistant',
  'assistant.lead':
    'Ask in words — the assistant answers from CRM data with links to records. It sees exactly what you ' +
    'see: a question about data closed to you gets a refusal, not an empty list.',
  'assistant.examples':
    'For example: “which of Ivanov’s deals are stuck on the proposal for more than two weeks”, “my deals ' +
    'with no movement for a month”, “what do we know about Romashka”, “revenue by manager”.',
  'assistant.question': 'Question to the assistant',
  'assistant.placeholder': 'Your question (Ctrl+Enter to send)',
  'assistant.ask': 'Ask',
  'assistant.thinking': 'Looking for the answer…',
  'assistant.newChat': 'New conversation',
  'assistant.failed': 'The assistant did not answer',
  'assistant.exchange': 'Question and answer',
  'assistant.understood': 'Understood as',
  'assistant.tool.deals_stalled': 'deals stuck on a stage',
  'assistant.tool.report': 'report',
  'assistant.tool.search': 'search in records',
  'assistant.tool.none': 'a question beyond the assistant',
  'assistant.refused': 'Refused:',
  'assistant.empty': 'Nothing found.',
  'assistant.candidates': 'Matching employees',
  'assistant.records': 'Records of the answer',
  'assistant.table': 'Report result',
  'assistant.dropped': 'The model cited records it was never given ({labels}) — the links were removed',
  // Clients at risk (#135)
  'nav.clientRisk': 'Clients at risk',
  'notifications.kind.client_risk': 'Clients at risk',
  'clientRisk.intro':
    'The risk is a rule over facts — silence after our letters and calls, complaints and their tone ' +
    '(AI ticket triage), payment discipline, falling purchases, an invoice falling due soon. The weights ' +
    'are set by reasoning, not fitted to data: the score is not a probability of leaving. "At risk" from ' +
    '{high} points, "watch" from {medium}. Stopped answering — {touches} or more of our messages without ' +
    'an answer, the first at least {silence} days ago; complaints — within {complaints} days; due soon — ' +
    'within {due} days. Recomputed hourly and when the client card is opened.',
  'clientRisk.filter': 'Risk level',
  'clientRisk.filter.all': 'All',
  'clientRisk.filter.high': 'At risk',
  'clientRisk.filter.medium': 'Watch',
  'clientRisk.level.high': 'at risk',
  'clientRisk.level.medium': 'watch',
  'clientRisk.level.low': 'no risk',
  'clientRisk.col.client': 'Client',
  'clientRisk.col.level': 'Level',
  'clientRisk.col.score': 'Score',
  'clientRisk.col.reasons': 'Reasons',
  'clientRisk.col.responsible': 'Responsible',
  'clientRisk.col.since': 'At risk since',
  'clientRisk.empty': 'No clients at risk',
  'clientRisk.emptyText': 'None of the clients visible to you scored any risk at the last recomputation',
  'clientRisk.truncated': 'The first 500 clients are shown — narrow the level',
  'clientRisk.noResponsible': 'not assigned',
  'clientRisk.nobodyTold': 'Nobody to notify: the responsible person has no account',
  'clientRisk.error': 'Could not load the client risk',
  'clientRisk.card.title': 'Risk of losing the client',
  'clientRisk.card.score': 'score {score} of 100',
  'clientRisk.card.since': 'since {at}',
  'clientRisk.card.rule': 'A rule with weights set by reasoning — not a model forecast',

  // ------------------------------------------------- #94: screens over the existing API
  // Dashboards: dragging, editing and refreshing a widget, pie, gauge, heat map.
  'dashboard.layout.hint': 'Drag a widget by its ⠿ handle onto another one or move it with the arrows — the layout is saved at once',
  'dashboard.widget.drag': 'Drag widget "{title}"',
  'dashboard.widget.moveEarlier': 'Move "{title}" earlier',
  'dashboard.widget.moveLater': 'Move "{title}" later',
  'dashboard.widget.edit': 'Edit',
  'dashboard.widget.editTitle': 'Widget "{title}"',
  'dashboard.widget.save': 'Save widget',
  'dashboard.widget.cancelEdit': 'Cancel',
  'dashboard.widget.height': 'Height (rows)',
  'dashboard.widget.refreshNow': 'Refresh',
  'dashboard.widget.pie.other': 'Other',
  'dashboard.widget.pie.negative':
    'The pie is not drawn: some values are negative, and a negative share has no slice — shown as a table',
  'dashboard.widget.gauge.noScale':
    'No scale: a gauge needs a second value in the report row (a plan next to the actual, for instance)',
  'dashboard.widget.gauge.label': '{value} of {scale}',
  'dashboard.widget.gauge.over': 'Above the scale',
  'dashboard.widget.heatmap.needsTwo':
    'A heat map needs two dimensions and a value — the report has one dimension, shown as a table',
  // Subscriptions: list and card.
  'nav.subscriptions': 'Subscriptions',
  'column.frequency': 'Frequency',
  'column.day_of_month': 'Day of month',
  'column.next_run_on': 'Next invoice',
  'value.billing.recurring.frequency.weekly': 'Weekly',
  'value.billing.recurring.frequency.monthly': 'Monthly',
  'value.billing.recurring.frequency.quarterly': 'Quarterly',
  'value.billing.recurring.frequency.yearly': 'Yearly',
  'record.sub.active': 'Active',
  'record.sub.stopped': 'Stopped',
  'record.sub.contract': 'Under contract',
  'record.sub.schedule': 'Schedule',
  'record.sub.day': 'on day {day}',
  'record.sub.period': 'Term',
  'record.sub.since': 'from {date}, open-ended',
  'record.sub.ended': 'The subscription has ended',
  'record.sub.template': 'Invoice lines',
  'record.sub.sections': 'Subscription sections',
  'record.sub.noLines': 'The template has no lines',
  'record.sub.stop': 'Stop',
  'record.sub.stop.title': 'Stop subscription "{name}"?',
  'record.sub.stop.text': 'Invoices will no longer be issued. The client is not told — let them know yourself.',
  'record.sub.resume': 'Resume',
  'record.sub.resume.title': 'Resume subscription "{name}"',
  'record.sub.resume.text':
    'Periods missed while stopped are not invoiced: the next invoice is the first run after the chosen date.',
  'record.sub.resume.on': 'Resume from',
  'record.sub.resume.missing': 'Choose the date to resume from',
  // Report builder: run journal.
  'rb.runs.title': 'Report runs',
  'rb.runs.empty': 'The report has not been run yet',
  'rb.runs.rows': '{count} rows',
  'rb.runs.status.queued': 'queued',
  'rb.runs.status.running': 'running',
  'rb.runs.status.completed': 'completed',
  'rb.runs.status.failed': 'failed',
  // Mail: retrying an undelivered email.
  'mail.result.retryNow': 'Retry now',
  // Warehouse: opening a stocktake, raising a receipt and a transfer.
  'stocktake.create.title': 'New stocktake',
  'stocktake.create.submit': 'Open stocktake',
  'stocktake.create.pickWarehouse': 'Choose a warehouse',
  'stocktake.create.pickZone': 'Choose a zone',
  'stocktake.create.pickCell': 'Choose a cell',
  'stocktake.create.cellSearch': 'Find a cell',
  'stocktake.create.cellsTruncated': 'Not all cells are shown — narrow the search',
  'stocktake.create.productHelp': 'One product across every cell of this warehouse',
  'stocktake.create.blind': 'Blind count',
  'stocktake.create.blindHelp': 'The counter will not see the expected quantity — the server withholds it',
  'stocktake.create.needWarehouse': 'Choose a warehouse',
  'stocktake.create.needZone': 'Choose a zone',
  'stocktake.create.needCell': 'Choose a cell',
  'stocktake.create.needProduct': 'Choose a product',
  'stocktake.create.noTopology': 'No access to the warehouse directory — the warehouses cannot be listed',
  'whdoc.create.pickWarehouse': 'Choose a warehouse',
  'whdoc.create.needWarehouse': 'Choose a warehouse',
  'whdoc.create.needLines': 'Every line needs a product and a quantity above zero',
  'whdoc.create.noTopology': 'No access to the warehouse directory — the warehouses cannot be listed',
  'whdoc.lines': 'Lines',
  'whdoc.line': 'Line {n}',
  'whdoc.addLine': 'Add line',
  'whdoc.removeLine': 'Remove line',
  'whdoc.quantity': 'Quantity',
  'whdoc.unitCost': 'Purchase price',
  'whdoc.unitCostHelp': 'Without a price the receipt creates no cost layer',
  'whdoc.receipt.title': 'New goods receipt',
  'whdoc.receipt.submit': 'Open receipt',
  'whdoc.receipt.kind': 'Receipt kind',
  'whdoc.receipt.planned': 'Planned — with the expected lines',
  'whdoc.receipt.unplanned': 'Unplanned — no lines',
  'whdoc.receipt.unplannedHelp': 'The storekeeper scans the lines; everything that arrived reads as a surplus',
  'whdoc.transfer.title': 'New transfer',
  'whdoc.transfer.submit': 'Raise transfer',
  'whdoc.transfer.fromCell': 'Take from',
  'whdoc.transfer.pickCell': 'Choose a cell',
  'whdoc.transfer.cellOption': 'Cell {cell}, {available} free',
  'whdoc.transfer.noStock': 'This product is not in the sending warehouse',
  'whdoc.transfer.overAvailable': 'Only {available} free — dispatch will fail',
  'whdoc.transfer.needWarehouses': 'Choose the sending and the receiving warehouse',
  'whdoc.transfer.sameWarehouse': 'The receiving warehouse is the sending one',
  'whdoc.transfer.needLines': 'Every line needs a product, a cell and a quantity above zero',

  // #109: narrow screens — navigation drawer, list cards.
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',
  'list.cards.label': 'Records',
  'list.cards.sortBy': 'Sort by',
  'list.cards.sortAscending': 'Ascending — tap to reverse',
  'list.cards.sortDescending': 'Descending — tap to reverse',

  // #88: XLSX export of lists, reports and schedules.
  'export.xlsx': 'Export to Excel (XLSX)',
  'rb.exportXlsx': 'Export to Excel',
  'rb.exportXlsxOf': 'Export “{name}” to Excel',
  'rm.format.xlsx': 'Excel (XLSX)',
  'rm.format.csv': 'CSV',
}
